webpackJsonp([1],{

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constantRouterMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asyncRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_views_layout_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_account__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_views_account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_operateData__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_operateData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_views_operateData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_subStation_subManager__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_subStation_subManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_views_subStation_subManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_subStation_subSet__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_subStation_subSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_views_subStation_subSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_subStation_subData__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_subStation_subData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_views_subStation_subData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_subStation_subAlbum__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_subStation_subAlbum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_views_subStation_subAlbum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_distributorMana_distributorManager__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_distributorMana_distributorManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_views_distributorMana_distributorManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_distributorMana_distributorData__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_distributorMana_distributorData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_views_distributorMana_distributorData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_distributorMana_distributorInfo__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_distributorMana_distributorInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_views_distributorMana_distributorInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_pendCheck__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_pendCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_views_pendCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_orderManager__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_orderManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_views_orderManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_orderManager_lock__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_orderManager_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_views_orderManager_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_dataCenter_incrementData__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_dataCenter_incrementData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_views_dataCenter_incrementData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_dataCenter_lockUserDetail__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_dataCenter_lockUserDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_views_dataCenter_lockUserDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_dataCenter_authUserMobile__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_dataCenter_authUserMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_views_dataCenter_authUserMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_dataCenter_albumsRank__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_dataCenter_albumsRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_views_dataCenter_albumsRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_advancePayment__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_advancePayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_views_advancePayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_advancePayment_recharge__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_advancePayment_recharge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_views_advancePayment_recharge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_advancePayment_rechargeList__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_advancePayment_rechargeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_views_advancePayment_rechargeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_partnerNotice__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_partnerNotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_views_partnerNotice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_activityNotice__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_activityNotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_views_activityNotice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_error_404__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_error_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_views_error_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_error_401__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_error_401___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_views_error_401__);



/* layout*/


//账号选择


//工作台（经营数据）


//子站管理





//分销商管理




//待审核分销商


//订单管理



// 数据中心





//预付货款管理




//合伙人通知

//活动通知


/* error page*/



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
// console.log(this);
var constantRouterMap = [{ path: '/404', component: __WEBPACK_IMPORTED_MODULE_24_views_error_404___default.a, hidden: true }, { path: '/401', component: __WEBPACK_IMPORTED_MODULE_25_views_error_401___default.a, hidden: true }, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  redirect: '/account',
  hidden: true
}, {
  path: '/account',
  component: __WEBPACK_IMPORTED_MODULE_3_views_account___default.a,
  hidden: true,
  name: 'Account'
}, {
  path: '/operate',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  redirect: '/operate/index',
  icon: 'icon-shop',
  text: '工作台',
  name: 'Operate',
  hidden: false,
  children: [{
    path: 'index',
    component: __WEBPACK_IMPORTED_MODULE_4_views_operateData___default.a,
    text: '工作台',
    activeName: 'index'
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history', //后端支持可开
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  base: 'stage',
  routes: constantRouterMap
}));

var asyncRouterMap = [{
  path: '/substation',
  redirect: '/substation/manager',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  text: '子站管理',
  icon: 'icon-goods',
  permission: [11, 12, 13, 21, 22],
  hidden: false,
  children: [{
    path: 'manager',
    component: __WEBPACK_IMPORTED_MODULE_5_views_subStation_subManager___default.a,
    name: 'SubManager',
    permission: [11, 12, 13, 21, 22],
    text: '子站管理',
    activeName: 'manager'
  }, { path: 'set', component: __WEBPACK_IMPORTED_MODULE_6_views_subStation_subSet___default.a, name: 'substationSet', permission: [11], text: '子站设置', activeName: 'set' },
  // {path: 'data', component: SubStationData, text: '子站数据', permission: [11, 12, 13, 21, 22], activeName: 'data'},
  { path: 'album', component: __WEBPACK_IMPORTED_MODULE_8_views_subStation_subAlbum___default.a, text: '子站专辑', permission: [11, 12, 13, 21, 22], activeName: 'album' }]
}, {
  path: '/distributor',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  redirect: '/distributor/manager',
  icon: 'icon-distributor',
  text: '分销商管理',
  permission: [11, 12, 13],
  hidden: false,
  children: [{
    path: 'manager',
    component: __WEBPACK_IMPORTED_MODULE_9_views_distributorMana_distributorManager___default.a,
    permission: [11, 12, 13],
    name: 'distributorManager',
    text: '分销商管理',
    activeName: 'manager'
  },
  // {path: 'data', component: DistributorData, permission: [11, 12, 13], text: '分销商数据', activeName: 'data'},
  {
    path: 'detail',
    component: __WEBPACK_IMPORTED_MODULE_11_views_distributorMana_distributorInfo___default.a,
    permission: [11, 12, 13],
    name: 'distributorDetail',
    text: '分销商信息',
    hidden: true,
    activeName: 'manager'
  }]
},
/*{
  path: '/advancepayment',
  component: Layout,
  redirect: '/advancepayment/manager',
  icon: 'icon-distributor',
  text: '进货款管理',
  permission: [11, 12, 13],
  hidden: false,
  children: [{
    path: 'manager',
    component: advancePayment,
    permission: [11, 12, 13],
    name: 'advancePayment',
    text: '进货款管理',
    hidden: true,
    activeName: 'manager'
  },{
    path: 'recharge',
    component: Recharge,
    permission: [11, 12, 13],
    name: 'recharge',
    text: '充值',
    hidden: true,
    activeName: 'recharge'
  },{
    path: 'rechargelist',
    component: RechargeList,
    permission: [11, 12, 13],
    name: 'rechargelist',
    text: '充值申请',
    hidden: true,
    activeName: 'rechargelist'
  }]
},*/
/*{
  path: '/pendcheck',
  redirect: '/pendcheck/index',
  icon: 'icon-profile',
  component: Layout,
  text: '待审核分销商',
  hidden: false,
  children: [{ path: 'index', component: PendCheck, text:'待审核分销商', activeName:'index'}]
},*/
{
  path: '/ordermanager',
  redirect: '/ordermanager/index',
  icon: 'icon-order',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  text: '订单管理',
  hidden: false,
  children: [{
    path: 'index',
    component: __WEBPACK_IMPORTED_MODULE_13_views_orderManager___default.a,
    text: '站外订单',
    activeName: 'index'
  }, {
    path: 'lock',
    component: __WEBPACK_IMPORTED_MODULE_14_views_orderManager_lock___default.a,
    text: 'APP内订单',
    activeName: 'lock'
  }]
}, {
  path: '/data/center',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  redirect: '/data/center/lock',
  icon: 'icon-rank',
  permission: [11, 12, 13, 21, 22],
  text: '数据中心',
  hidden: false,
  children: [{
    path: 'increment',
    component: __WEBPACK_IMPORTED_MODULE_15_views_dataCenter_incrementData___default.a,
    name: 'incrementData',
    // hidden: true,
    text: '用户增长',
    permission: [11, 12, 13],
    activeName: 'increment'
  }, {
    path: 'rank',
    component: __WEBPACK_IMPORTED_MODULE_18_views_dataCenter_albumsRank___default.a,
    name: 'rankData',
    // hidden: true,
    text: '专辑排行',
    permission: [11, 12, 13],
    activeName: 'rank'
  }, {
    path: 'lock',
    component: __WEBPACK_IMPORTED_MODULE_16_views_dataCenter_lockUserDetail___default.a,
    name: 'lockUserDetail',
    text: '锁定用户详情',
    permission: [11, 12, 13, 21, 22],
    activeName: 'lock'
  }, {
    path: 'mobile',
    component: __WEBPACK_IMPORTED_MODULE_17_views_dataCenter_authUserMobile___default.a,
    name: 'authUserMobile',
    text: '授权手机号用户',
    permission: [11, 12, 13],
    activeName: 'mobile'
  }]
}, {
  path: '/partnernotice',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  redirect: '/partnernotice/index',
  icon: 'icon-notice',
  text: '通知中心',
  permission: [11],
  children: [{
    path: 'index',
    component: __WEBPACK_IMPORTED_MODULE_22_views_partnerNotice___default.a,
    permission: [11],
    name: 'partnerNotice',
    text: '通知中心',
    activeName: 'index'
  }]
}, {
  path: '/partnernotice',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  redirect: '/partnernotice/index',
  icon: 'icon-notice',
  text: '通知中心',
  permission: [21],
  children: [{
    path: 'index',
    component: __WEBPACK_IMPORTED_MODULE_22_views_partnerNotice___default.a,
    permission: [21],
    name: 'partnerNotice',
    text: '通知中心',
    activeName: 'index'
  }]
}, {
  path: '/activityNotice',
  component: __WEBPACK_IMPORTED_MODULE_2_views_layout_Layout___default.a,
  redirect: '/activityNotice/index',
  icon: 'icon-notice',
  text: '活动模板',
  permission: [11, 21],
  children: [{
    path: 'index',
    component: __WEBPACK_IMPORTED_MODULE_23_views_activityNotice___default.a,
    permission: [11, 21],
    name: 'activityNotice',
    text: '活动模板',
    activeName: 'index'
  }]
}];

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(847)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(930),
  /* scopeId */
  "data-v-23a55c9d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_permission__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_config__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters__ = __webpack_require__(502);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_4__modules_permission__["a" /* default */],
    config: __WEBPACK_IMPORTED_MODULE_5__modules_config__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_6__getters__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isXimalayaEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validatePhone; });
/* unused harmony export validateidCardNo */
/* unused harmony export validatePassword */
/* unused harmony export validateURL */
/* unused harmony export validateLowerCase */
/* unused harmony export validateUpperCase */
/* unused harmony export validatAlphabets */


/* 是否是公司邮箱*/
var isXimalayaEmail = function isXimalayaEmail(str) {
  var reg = /^[a-z0-9](?:[-_.+]?[a-z0-9]+)*@ximalaya\.com$/i;
  return reg.test(str.trim());
};

var validatePhone = function validatePhone(number) {
  var reg = /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-8]|18[0-9]|14[57]|199)[0-9]{8}$/;
  return reg.test(number);
};

var validateidCardNo = function validateidCardNo(number) {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return reg.test(number);
};

var validatePassword = function validatePassword(str) {
  var reg = /^([A-Z]|[a-z]|[0-9]|[`\-\=[];,.\/~!@#$%\^*()_+}{:?]){6,20}$/;
  return reg.test(str.trim());
};

/* 合法uri*/
var validateURL = function validateURL(textval) {
  var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
};

/* 小写字母*/
var validateLowerCase = function validateLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
};

/* 验证key*/
// export function validateKey(str) {
//     var reg = /^[a-z_\-:]+$/;
//     return reg.test(str);
// }

/* 大写字母*/
var validateUpperCase = function validateUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
};

/* 大小写字母*/
var validatAlphabets = function validatAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
};



/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store___ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fastclick__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_index_scss__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_styles_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_clipboard2__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






//element-ui



//全局自定义的css
 // 全局自定义的css样式




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_clipboard2___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);

var whiteList = ['/login', '/logout', '/account', '/404']; // 不重定向 免登陆白名单

__WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.path === '/login') {
    //next({ path: '/' });
    next();
  } else {
    if (__WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].getters.hasRole) {
      //已经拿到了用户信息，可以进入系统
      if (to.path == '/account') {
        next({ name: 'Operate' });
      } else if (whiteList.indexOf(to.path) !== -1 || to.permission && to.permission.indexOf(__WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].getters.promotorType * 10 + __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].getters.accountState) > -1 || !to.permission) {
        next();
      } else {
        next({ path: '/404', query: { noGoBack: true } });
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].dispatch('GetInfo').then(function (res) {
        // 拉取user_info
        // const hasRole = res.data.hasRole;
        return __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].dispatch('GenerateRoutes', { promotorType: res.data.promotorType, accountState: res.data.accountState });
      }).then(function () {
        // 生成可访问的路由表
        __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].addRoutes(__WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].getters.addRouters); // 动态添加可访问路由表
        if (!__WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].getters.hasRole && to.path != '/account') {
          next({ name: "Account" });
        } else if (to.path === '/account' && __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].getters.hasRole) {
          next({ name: 'Operate' });
        } else if (!__WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].getters.hasRole && to.path === '/account') {
          next();
        } else {
          next(to);
        }
      }).catch(function (err) {
        //console.log(err);
      });
    }
  }
});

__WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].afterEach(function () {});

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    __WEBPACK_IMPORTED_MODULE_4_fastclick___default.a.attach(document.body);
  }, false);
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(23);

//
//
//
//
//
//
//
//
//
//
//





// enumerating ECharts events for now
var ACTION_EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'focusnodeadjacency', 'unfocusnodeadjacency', 'brush', 'brushselected'];

var MOUSE_EVENTS = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousedown', 'mouseup', 'globalout'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: Object,
    theme: [String, Object],
    initOptions: Object,
    group: String,
    autoResize: Boolean,
    watchShallow: Boolean
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    // Only recalculated when accessed from JavaScript.
    // Won't update DOM on value change because getters
    // don't depend on reactive values
    width: {
      cache: false,
      get: function get() {
        return this.delegateGet('width', 'getWidth');
      }
    },
    height: {
      cache: false,
      get: function get() {
        return this.delegateGet('height', 'getHeight');
      }
    },
    isDisposed: {
      cache: false,
      get: function get() {
        return !!this.delegateGet('isDisposed', 'isDisposed');
      }
    },
    computedOptions: {
      cache: false,
      get: function get() {
        return this.delegateGet('computedOptions', 'getOption');
      }
    }
  },
  watch: {
    group: function group(_group) {
      this.chart.group = _group;
    }
  },
  methods: {
    // provide a explicit merge option method
    mergeOptions: function mergeOptions(options, notMerge, lazyUpdate) {
      this.delegateMethod('setOption', options, notMerge, lazyUpdate);
    },

    // just delegates ECharts methods to Vue component
    // use explicit params to reduce transpiled size for now
    resize: function resize(options) {
      this.delegateMethod('resize', options);
    },
    dispatchAction: function dispatchAction(payload) {
      this.delegateMethod('dispatchAction', payload);
    },
    convertToPixel: function convertToPixel(finder, value) {
      return this.delegateMethod('convertToPixel', finder, value);
    },
    convertFromPixel: function convertFromPixel(finder, value) {
      return this.delegateMethod('convertFromPixel', finder, value);
    },
    containPixel: function containPixel(finder, value) {
      return this.delegateMethod('containPixel', finder, value);
    },
    showLoading: function showLoading(type, options) {
      this.delegateMethod('showLoading', type, options);
    },
    hideLoading: function hideLoading() {
      this.delegateMethod('hideLoading');
    },
    getDataURL: function getDataURL(options) {
      return this.delegateMethod('getDataURL', options);
    },
    getConnectedDataURL: function getConnectedDataURL(options) {
      return this.delegateMethod('getConnectedDataURL', options);
    },
    clear: function clear() {
      this.delegateMethod('clear');
    },
    dispose: function dispose() {
      this.delegateMethod('dispose');
    },
    delegateMethod: function delegateMethod(name) {
      var _chart;

      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].util.warn('Cannot call [' + name + '] before the chart is initialized. Set prop [options] first.', this);
        return;
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_chart = this.chart)[name].apply(_chart, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args));
    },
    delegateGet: function delegateGet(name, method) {
      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].util.warn('Cannot get [' + name + '] before the chart is initialized. Set prop [options] first.', this);
      }
      return this.chart[method]();
    },
    init: function init() {
      var _this = this;

      if (this.chart) {
        return;
      }

      var chart = __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.init(this.$el, this.theme, this.initOptions);

      if (this.group) {
        chart.group = this.group;
      }

      chart.setOption(this.options, true);

      // expose ECharts events as custom events
      ACTION_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);
        });
      });
      MOUSE_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);

          // for backward compatibility, may remove in the future
          _this.$emit('chart' + event, params);
        });
      });

      if (this.autoResize) {
        this.__resizeHanlder = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
          chart.resize();
        }, 100, { leading: true });
        window.addEventListener('resize', this.__resizeHanlder);
      }

      this.chart = chart;
    },
    destroy: function destroy() {
      if (this.autoResize) {
        window.removeEventListener('resize', this.__resizeHanlder);
      }
      this.dispose();
      this.chart = null;
    },
    refresh: function refresh() {
      this.destroy();
      this.init();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$watch('options', function (options) {
      if (!_this2.chart && options) {
        _this2.init();
      } else {
        _this2.chart.setOption(_this2.options, true);
      }
    }, { deep: !this.watchShallow });

    var watched = ['theme', 'initOptions', 'autoResize', 'watchShallow'];
    watched.forEach(function (prop) {
      _this2.$watch(prop, function () {
        _this2.refresh();
      }, { deep: true });
    });
  },
  mounted: function mounted() {
    // auto init if `options` is already provided
    if (this.options) {
      this.init();
    }
  },
  activated: function activated() {
    if (this.autoResize) {
      this.chart && this.chart.resize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.destroy();
  },
  connect: function connect(group) {
    if (typeof group !== 'string') {
      group = group.map(function (chart) {
        return chart.chart;
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.connect(group);
  },
  disconnect: function disconnect(group) {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.disConnect(group);
  },
  registerMap: function registerMap() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerMap.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  },
  registerTheme: function registerTheme() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerTheme.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_card_number__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_card_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_card_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_card_table__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_card_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_card_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activeName: '0',
      pageSize: 20,
      tabList: [{
        txt: '昨日',
        key: 'yesterday'
      }, {
        txt: '7日',
        key: 'weekly'
      }, {
        txt: '30日',
        key: 'monthly'
      }, {
        txt: '汇总',
        key: 'summary'
      }],
      tableData: [{
        goodsName: '鞋',
        goodsType: '100',
        user: '1',
        orderMoney: 'a',
        orderStatus: 'asdf',
        brokerage: 'uioiu'
      }, {
        goodsName: '鞋',
        goodsType: '100',
        user: '1',
        orderMoney: 'a',
        orderStatus: 'asdf',
        brokerage: 'uioiu'
      }, {
        goodsName: '鞋',
        goodsType: '100',
        user: '1',
        orderMoney: 'a',
        orderStatus: 'asdf',
        brokerage: 'uioiu'
      }],
      propstable: {}
    };
  },

  components: {
    cardNumber: __WEBPACK_IMPORTED_MODULE_1_components_card_number___default.a, cardTable: __WEBPACK_IMPORTED_MODULE_2_components_card_table___default.a
  },
  props: ['cardData', 'pagSearch'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['promotorType'])),
  mounted: function mounted() {},

  methods: {
    getTableData: function getTableData(key) {
      var vis = this;
      var data = vis.cardData.data;
      if (vis.cardData.type == 'table' && data.list) {
        var tableKey = vis.cardData.key; //['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount', 'lockUserCount']

        var dataList = data.list;
        var temp = {
          "totalPages": Math.ceil(data.total / data.pageSize),
          "curPage": data.curPage,
          "totalRecords": data.total,
          list: []
        };

        var changeTableKey = [];
        dataList.forEach(function (item) {
          var tmp = {};
          changeTableKey = [];
          tableKey.map(function (keyItem, index) {
            if (keyItem == 'name') {
              tmp[keyItem] = item[keyItem];
              changeTableKey.push(keyItem);
            } else if (item[key]) {
              for (var iKey in item[key]) {
                tmp[iKey] = item[key][iKey];
              }
              changeTableKey.push(keyItem);
            }
          });
          temp.list.push(tmp);
        });
        temp['keyList'] = changeTableKey;
        return temp;
      }
    },
    handleSizeChange: function handleSizeChange() {
      this.pageSize = arguments[0];
      this.$emit('pagSearch', { 'pageSize': this.pageSize, curPage: this.cardData.data.curPage });
    },
    handleCurrentChange: function handleCurrentChange() {
      this.$emit('pagSearch', { pageSize: this.pageSize, curPage: arguments[0] });
    }
  },
  watch: {
    cardData: function cardData() {
      var vis = this;
      var cadata = this.cardData;
      if (cadata.type == 'table' && cadata.data.list) {
        var dataKey = ['yesterday', 'weekly', 'monthly', 'summary'];
        dataKey.forEach(function (key) {
          vis['propstable'][key] = vis.getTableData(key);
        });
      }
    }
  }
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    //SubManager    distributorManager
    var model = this.numberData && this.numberData.model;
    var txtArray = [];
    if (model) {
      txtArray = [{
        txt: '分成比例',
        key: 'shareRatio',
        role: [1, 2]
      }, {
        txt: '在职分销商',
        key: 'inServiceDistributerCount',
        role: [1, 2]
      }, {
        txt: '子站数',
        key: 'subSiteCount',
        role: [1, 2]
      }];
    } else {
      txtArray = [{
        txt: '销售金额',
        key: 'salesAmount',
        role: [1, 2]
      }, {
        txt: '佣金',
        key: 'commission',
        role: [1, 2]
      }, {
        txt: '付费订单数',
        key: 'paidOrderCount',
        role: [1, 2]
      },
      // {
      //   txt: '付费用户数',
      //   key: 'paidUserCount',
      //   role: [1,2]
      // },
      {
        txt: '锁定用户数',
        key: 'lockUserCount',
        role: [1, 2]
      }];
    }
    return {
      txtArray: txtArray
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['promotorType', 'isPromotorDisplay'])),
  watch: {
    numberData: function numberData(val) {
      //根据分销商合伙人以及appRatio是否为null展示站内站外分成比例
      if (val.model == 'real_time' && val.data.appRatio != null) {
        this.txtArray = [{
          txt: '站外分成比例',
          key: 'shareRatio',
          role: [1, 2]
        }, {
          txt: '站内分成比例',
          key: 'appRatio',
          role: [1, 2]
        }, {
          txt: '在职分销商',
          key: 'inServiceDistributerCount',
          role: [1, 2]
        }, {
          txt: '子站数',
          key: 'subSiteCount',
          role: [1, 2]
        }];
      }
    }
  },
  created: function created() {
    if (!this.isPromotorDisplay) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.txtArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.key == 'lockUserCount') {
            item.role = [1];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },

  props: ['numberData'],
  methods: {
    toLockDetail: function toLockDetail(e) {
      e.preventDefault();
      this.$router.push({ name: 'lockUserDetail' });
    }
  }
});

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

//需要的字段和数据都需要传入
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pageSize: 2,
      keyTxt: {
        name: {
          txt: '',
          width: 103 * 1.25
        },
        salesAmount: {
          txt: '销售金额',
          width: 120 * 1.25
        },
        commission: {
          txt: '佣金',
          width: 90 * 1.25
        },
        paidOrderCount: {
          txt: '付费订单数',
          width: 127 * 1.25
        },
        // paidUserCount: {
        //   txt: '付费用户数',
        //   width: 144*1.25
        // },
        lockSalesAmount: {
          txt: '销售金额',
          width: 120 * 1.25
        },
        lockCommission: {
          txt: '佣金',
          width: 90 * 1.25
        },
        lockPaidOrderCount: {
          txt: '付费订单数',
          width: 127 * 1.25
        }
        // lockPaidUserCount: {
        //   txt: '付费用户数',
        //   width: 144*1.25
        // }
      }
    };
  },

  props: ['tableData', 'pagSearch']
});

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_throttle_debounce_throttle__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_throttle_debounce_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_throttle_debounce_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resize_event__ = __webpack_require__(501);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'myCarousel',

  props: {
    initialIndex: {
      type: Number,
      default: 0
    },
    height: String,
    trigger: {
      type: String,
      default: 'hover'
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 3000
    },
    indicatorPosition: String,
    indicator: {
      type: Boolean,
      default: true
    },
    arrow: {
      type: String,
      default: 'hover'
    },
    loop: {
      type: Boolean,
      default: true
    },
    type: String
  },

  data: function data() {
    return {
      items: [],
      activeIndex: -1,
      containerWidth: 0,
      timer: null,
      hover: false,
      left: true,
      right: true
    };
  },


  computed: {
    hasLabel: function hasLabel() {
      return this.items.some(function (item) {
        return item.label.toString().length > 0;
      });
    }
  },

  watch: {
    items: function items(val) {
      if (val.length > 0) this.setActiveItem(this.initialIndex);
    },
    activeIndex: function activeIndex(val, oldVal) {
      this.resetItemPosition(oldVal);
      this.$emit('change', val, oldVal);
    },
    autoplay: function autoplay(val) {
      val ? this.startTimer() : this.pauseTimer();
    }
  },

  methods: {
    handleMouseEnter: function handleMouseEnter() {
      this.hover = true;
      this.pauseTimer();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hover = false;
      this.startTimer();
    },
    itemInStage: function itemInStage(item, index) {
      var length = this.items.length;
      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
        return 'left';
      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
        return 'right';
      }
      return false;
    },
    handleButtonEnter: function handleButtonEnter(arrow) {
      var _this = this;

      this.items.forEach(function (item, index) {
        if (arrow === _this.itemInStage(item, index)) {
          item.hover = true;
        }
      });
    },
    handleButtonLeave: function handleButtonLeave() {
      this.items.forEach(function (item) {
        item.hover = false;
      });
    },
    updateItems: function updateItems() {
      this.items = this.$children.filter(function (child) {
        return child.$options.name === 'ElCarouselItem';
      });
    },
    resetItemPosition: function resetItemPosition(oldIndex) {
      var _this2 = this;

      this.items.forEach(function (item, index) {
        item.translateItem(index, _this2.activeIndex, oldIndex);
      });
    },
    playSlides: function playSlides() {
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    pauseTimer: function pauseTimer() {
      clearInterval(this.timer);
    },
    startTimer: function startTimer() {
      if (this.interval <= 0 || !this.autoplay) return;
      this.timer = setInterval(this.playSlides, this.interval);
    },
    setActiveItem: function setActiveItem(index) {
      if (typeof index === 'string') {
        var filteredItems = this.items.filter(function (item) {
          return item.name === index;
        });
        if (filteredItems.length > 0) {
          index = this.items.indexOf(filteredItems[0]);
        }
      }
      index = Number(index);
      if (isNaN(index) || index !== Math.floor(index)) {
        "production" !== 'production' && console.warn('[Element Warn][Carousel]index must be an integer.');
        return;
      }
      var length = this.items.length;
      // debugger
      if (!this.loop) {
        if (index == 0) {
          this.left = false;
        } else {
          this.left = true;
        }
        if (index == length - 1) {
          this.right = false;
        } else {
          this.right = true;
        }
        if (index < 0 || index > length) {
          return false;
        }
      }
      if (index < 0) {
        this.activeIndex = length - 1;
      } else if (index >= length) {
        this.activeIndex = 0;
      } else {
        this.activeIndex = index;
      }
    },
    prev: function prev() {
      this.setActiveItem(this.activeIndex - 1);
    },
    next: function next() {
      this.setActiveItem(this.activeIndex + 1);
    },
    handleIndicatorClick: function handleIndicatorClick(index) {
      this.activeIndex = index;
    },
    handleIndicatorHover: function handleIndicatorHover(index) {
      if (this.trigger === 'hover' && index !== this.activeIndex) {
        this.activeIndex = index;
      }
    }
  },

  created: function created() {
    var _this3 = this;

    this.throttledArrowClick = __WEBPACK_IMPORTED_MODULE_0_throttle_debounce_throttle___default()(300, true, function (index) {
      _this3.setActiveItem(index);
    });
    this.throttledIndicatorHover = __WEBPACK_IMPORTED_MODULE_0_throttle_debounce_throttle___default()(300, function (index) {
      _this3.handleIndicatorHover(index);
    });
  },
  mounted: function mounted() {
    var _this4 = this;

    this.updateItems();
    this.$nextTick(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resize_event__["a" /* addResizeListener */])(_this4.$el, _this4.resetItemPosition);
      if (_this4.initialIndex < _this4.items.length && _this4.initialIndex >= 0) {
        _this4.activeIndex = _this4.initialIndex;
      }
      _this4.startTimer();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resize_event__["b" /* removeResizeListener */])(this.$el, this.resetItemPosition);
  }
});

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			accounts: [],
			nickName: this.name,
			role: 1
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['name'])),
	created: function created() {
		var vis = this;
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api__["P" /* chooseAccount */])().then(function (res) {
			if (res.data.length === 1) {
				vis.chooseRole(res.data[0].id);
			}
			vis.accounts = res.data;
		}).catch(function (error) {
			vis.role = 0;
		});
	},

	methods: {
		format: function format(time) {
			var t = new Date(time);
			var y = t.getFullYear();
			var m = t.getMonth() + 1;
			var d = t.getDate();
			return y.toString().substr(2) + '-' + m + '-' + d;
		},
		chooseRole: function chooseRole(id) {
			var _this = this;

			var vis = this;
			/*chooseAccount(id).then(res=>{
   	vis.$router.push({name:'Operate'})
   })*/
			this.$store.dispatch('Choose', id).then(function (res) {
				if (res.ret == 0) {
					_this.$router.push({ name: 'Operate' });
				}
			});
		},
		logout: function logout() {
			this.$store.dispatch('LogOut').then(function () {
				location.reload(); // 为了重新实例化vue-router对象 避免bug
			});
		}
	}
});

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      notifyAllData: [],
      pageNo: 1,
      pageTotal: 0,
      c: null
    };
  },

  methods: {
    pageChange: function pageChange(val) {
      this.pageNo = val;
    },
    getData: function getData() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api__["a" /* ActnotifyList */])({
        pageNo: this.pageNo
      }).then(function (res) {
        if (res.ret === 0) {
          _this.notifyAllData = res.data.list;
          _this.pageTotal = res.data.count;
        }
      });
    },
    collapseChange: function collapseChange(id) {
      this.notifyAllData.forEach(function (v, i) {});
    }
  },
  watch: {
    pageNo: function pageNo(val) {
      this.getData();
    }
  },
  created: function created() {
    var vis = this;
    // Promise.all([partnerNotice(), notifyAll()])
    // .then(res => {
    //   res[0].ret === 0 ? vis.noticeData = res[0].data : console.log(res[0].msg);
    //   res[1].ret === 0 ? vis.notifyAllData = res[1].data : console.log(res[1].msg);
    // })
    this.getData();
  }
});

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_carousel__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_carousel__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      form: {
        number: '',
        flowType: '0',
        productName: '',
        moneyFlowType: '0',
        inOrOut: '0',
        time: ''
      },
      tableData: [],
      pageInfo: {
        pageSize: 20,
        total: 0,
        curPage: 1
      },
      accountInfo: {
        inventoryAmount: 0,
        returnAmount: 0,
        supportImprestAlbumCount: 0
      },
      dialogVisible: false,
      loading: true
    };
  },

  components: {
    myCarousel: __WEBPACK_IMPORTED_MODULE_4_components_carousel___default.a
  },
  computed: {
    moment: function moment() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a;
    }
  },
  methods: {
    doRecharge: function doRecharge() {
      this.$router.push('/advancepayment/recharge');
    },
    doDownload: function doDownload() {
      downLoadAccountList(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestParams));
    },
    doWithdrawals: function doWithdrawals() {
      //提现
      this.$alert('功能即将上线，请耐心等待', '标题名称', {
        confirmButtonText: '确定'
      });
    },
    goDefine: function goDefine() {
      //返还金额查看定义
      window.open('https://shimo.im/docs/e6iyTBgPb8cg1ezx/', '_blank');
    },
    showTips: function showTips() {
      //货款充值使用方法
      // this.$data.dialogVisible = true
      window.open('https://shimo.im/docs/wKWIR0wZIcYrqFqY/', '_blank');
    },
    toDetail: function toDetail(row) {
      //查看详情
      // 2 跳转到站外订单列表页
      // 1 跳转到合伙人申请记录列表页
      row.source == 2 ? this.$router.push({ path: '/ordermanager/index', query: { number: row.number } }) : this.$router.push({ path: '/advancepayment/rechargeList', query: { number: row.number } });
    },
    toRechargeList: function toRechargeList() {
      this.$router.push('/advancepayment/rechargelist');
    },
    handleCurrentChange: function handleCurrentChange(item) {
      //翻页
      // this.$data.pageInfo.curPage = item
      this.getAccountList(item);
    },
    getAccountList: function getAccountList(page) {
      //获取货款信息列表
      var _form = this.$data.form;
      var requestParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _form);
      this.requestParams = requestParams;
      if (requestParams.time && requestParams.time.length) {
        requestParams.from = requestParams.time[0] ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(requestParams.time[0]).format('YYYY-MM-DD HH:mm:ss') : '';
        requestParams.to = requestParams.time[1] ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(requestParams.time[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      } else {
        requestParams.from = '';
        requestParams.to = '';
      }
      requestParams.curPage = page || 1; //this.$data.pageInfo.curPage
      delete requestParams.time;

      // 下载地址拼接
      // let downLoadPath = ''
      // for(let item in requestParams) {
      //   if(item != 'curPage') {
      //     downLoadPath = downLoadPath ? downLoadPath + '&' + item + '=' + requestParams[item]: item + '=' + requestParams[item]
      //   }        
      // }
      // this.downLoadPath = downLoadPath

      var _me = this;
      _me.$data.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api__["S" /* getAccountList */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, requestParams)).then(function (res) {
        _me.$data.loading = false;
        if (res.ret == 0) {
          _me.$data.tableData = res.data.list;
          _me.$data.pageInfo.total = res.data.totalRecords;
          _me.$data.pageInfo.pageSize = res.data.pageSize;
          _me.$data.pageInfo.curPage = res.data.curPage;
        }
      }).catch(function (error) {
        _me.$data.loading = false;
      });
    },
    closeCarousel: function closeCarousel() {
      this.$data.dialogVisible = false;
    }
  },
  created: function created() {
    var _me = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api__["T" /* getAccountInfo */])({}).then(function (res) {
      if (res.ret == 0) {
        _me.$data.accountInfo.returnAmount = res.data.returnAmount;
        _me.$data.accountInfo.inventoryAmount = res.data.inventoryAmount;
        _me.$data.accountInfo.supportImprestAlbumCount = res.data.supportImprestAlbumCount;
        if (res.data.first) {
          //用户是否第一次进入预付款页面展示轮播图
          _me.$data.dialogVisible = true;
        }
      } else {
        console.log('数据请求出错');
      }
    });
    this.getAccountList();
  }
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rechargeSuccess_vue__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rechargeSuccess_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rechargeSuccess_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_cookie__ = __webpack_require__(508);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import {validateidCardNo} from 'utils/validate'
// const _uid = getCookie('4&_token').split('&')[0]
var _isOnline = window.location.host == 'partner.ximalaya.com';
var _token = _isOnline ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_cookie__["a" /* getCookie */])('1&_token') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_cookie__["a" /* getCookie */])('4&_token');
var _uploadUrl = _isOnline ? 'upload.ximalaya.com' : 'upload.test.ximalaya.com';

var _params = 'token=' + encodeURIComponent(_token);
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var checkBankCard = function checkBankCard(rule, value, callback) {
      if (!value) {
        return callback(new Error('账号不能为空'));
      }
      var pattern = /^([1-9]{1})(\d+)$/;
      if (!pattern.test(value)) {
        return callback(new Error('请输入正确的转账账号'));
      } else {
        callback();
      }
    };
    return {
      uploadUrl: _uploadUrl,
      uploadParam: _params,
      ruleForm: {
        amount: '', //充值金额  
        bankAccountNumber: '', //银行账户编号  
        bankAccountName: '', //银行账户名称  
        voucher: '' //凭据 
      },
      formRules: {
        amount: [{ required: true, message: '转账金额不能为空' }, { type: 'number', message: '请输入正确的转账金额', trigger: 'blur' }],
        bankAccountNumber: [{ validator: checkBankCard, trigger: 'blur' }],
        bankAccountName: [{ required: true, message: '银行账户名称不能为空' }]
      },
      uploadParams: {
        token: _token || ''
      },
      dialogVisible: false,
      // dialogImageUrl: '',
      succ: false,
      fileList: [],
      btnLoading: false
    };
  },

  components: {
    'recharge-success': __WEBPACK_IMPORTED_MODULE_2__rechargeSuccess_vue___default.a
  },
  methods: {
    handlePictureChange: function handlePictureChange(response, file, fileList) {
      var _this = this;

      this.$data.fileList = [];
      if (response.ret != 0) {
        this.$message({
          message: response.msg,
          type: 'error'
        });
        return false;
      }
      fileList.forEach(function (item) {
        _this.$data.fileList.push(item.response.data[0].url);
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      var _this2 = this;

      this.$data.fileList = [];
      fileList.forEach(function (item) {
        _this2.$data.fileList.push(item.response.data[0].url);
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      var requestParamter = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$data.ruleForm);
      requestParamter.voucher = this.$data.fileList.toString();
      var _me = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid && requestParamter.voucher) {
          _this3.$data.btnLoading = true;
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, requestParamter));
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api__["R" /* postRechargeApply */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, requestParamter)).then(function (res) {
            _this3.$data.btnLoading = false;
            if (res.ret == 0) {
              _me.$data.succ = true;
            } else {
              _me.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            _me.$data.btnLoading = false;
          });
        } else {
          var _msg = '请按要求填写正确的转账信息';
          if (!requestParamter.voucher) {
            _msg = '请上传转账凭证';
          }
          _this3.$message({
            message: _msg,
            type: 'warning'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(507);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      form: {
        number: '',
        type: '0',
        status: '0',
        time: []
      },
      tableData: [],
      pageInfo: {
        pageSize: 20,
        total: 0,
        curPage: 1
      },
      loading: true
    };
  },

  methods: {
    doCarousel: function doCarousel(imageList) {
      //查看图片
      var _carousel = new Carousel({
        imagesList: imageList,
        indexList: imageList
      });
      _carousel.show();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      // 翻页
      // this.$data.pageInfo.curPage = page
      this.getRechargeList(page);
    },
    getRechargeList: function getRechargeList(page) {
      //获取充值列表
      var _form = this.$data.form;
      var requestParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _form);
      if (requestParams.time.length) {
        requestParams.from = requestParams.time[0] ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(requestParams.time[0]).format('YYYY-MM-DD HH:mm:ss') : '';
        requestParams.to = requestParams.time[1] ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(requestParams.time[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      } else {
        requestParams.from = '';
        requestParams.to = '';
      }
      requestParams.curPage = page || 1; //this.$data.pageInfo.curPage
      delete requestParams.time;

      var _me = this;
      _me.$data.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api__["Q" /* getRechargeList */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, requestParams)).then(function (res) {
        _me.$data.loading = false;
        if (res.ret == 0) {
          _me.$data.tableData = res.data.list;
          _me.$data.pageInfo.total = res.data.totalRecords;
          _me.$data.pageInfo.pageSize = res.data.pageSize;
          _me.$data.pageInfo.curPage = res.data.curPage;
        }
      }).catch(function (error) {
        _me.$data.loading = false;
      });
    }
  },
  created: function created() {
    if (this.$route.query.number) {
      this.$data.form.number = this.$route.query.number;
    }
    this.getRechargeList();
  }
});

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    go: function go(route) {
      this.$router.push(route);
      if (route === 'recharge') {
        this.$parent.$data.succ = false;
        this.$parent.$data.ruleForm = {
          amount: '', //充值金额  
          bankAccountNumber: '', //银行账户编号  
          bankAccountName: '', //银行账户名称  
          voucher: '' //凭据 
        };
      }
    }
  }
});

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cityList: [],
      classify: [],
      tableData: [],
      sortTypes: [{
        key: '1',
        name: '按销量'
      }, {
        key: '2',
        name: '按销售额'
      }, {
        key: '3',
        name: '按收听时长'
      }],
      initLoading: false,
      curCityId: '',
      rankType: 'album',
      curClassIdx: '0',
      curClassName: '全部',
      searchKey: '',
      searchTabIdx: '',
      curSortType: '1',
      rankTime: '1',
      rankLoading: false,
      ret: '',
      dataMsg: ''
    };
  },

  computed: {
    onSearching: function onSearching() {
      var _this = this;
      var isExist = _this.classify.some(function (item) {
        return item === '搜索结果';
      });
      return isExist;
    }
  },
  methods: {
    goSearch: function goSearch() {
      var _this = this;
      _this.addSearchTab();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["g" /* searchRanking */])({
        name: _this.searchKey,
        city: _this.curCityId,
        type: _this.curSortType,
        time: _this.rankTime
      }).then(function (res) {
        _this.rankLoading = false;
        if (res.ret === 0) {
          _this.tableData = res.data;
        } else {
          console.log('列表搜索请求失败');
        }
      });
    },
    goRanking: function goRanking() {
      var _this = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["h" /* getRanking */])({
        city: _this.curCityId,
        category: _this.classify[_this.curClassIdx],
        type: _this.curSortType,
        time: _this.rankTime
      }).then(function (res) {
        _this.rankLoading = false;
        _this.ret = res.ret;
        if (res.ret === 0) {
          _this.tableData = res.data;
        } else {
          _this.dataMsg = res.msg;
        }
      });
    },
    addSearchTab: function addSearchTab() {
      var _this = this;
      if (!_this.onSearching) {
        _this.classify.push('搜索结果');
        _this.searchTabIdx = _this.classify.length - 1;
        _this.curClassIdx = _this.searchTabIdx.toString();
      }
    },
    delSearchTab: function delSearchTab(idx) {
      var _this = this;
      if (_this.onSearching) {
        _this.searchKey = '';
        _this.classify.pop();
        _this.curClassIdx = idx || '0';
      }
    },
    switchType: function switchType(type) {
      var _this = this;
      _this.rankTime = type === 'track' ? '3' : '1';
      _this.initFetch();
    },
    initFetch: function initFetch() {
      var _this = this;
      _this.delSearchTab();
      _this.getRankList();
    },
    switchTab: function switchTab(idx) {
      var _this = this;
      if (idx != _this.classify.length - 1 || _this.classify[idx] !== '搜索结果') {
        _this.delSearchTab(idx);
        // reset && fetch
        _this.rankLoading = true;
        _this.tableData = [];
        _this.goRanking();
      }
    },
    getRankList: function getRankList() {
      var _this = this;
      // reset && fetch
      _this.rankLoading = true;
      _this.tableData = [];
      _this.searchKey ? _this.goSearch() : _this.goRanking();
    }
  },
  created: function created() {
    var _this = this;
    _this.initLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["i" /* getRankCity */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["j" /* getRankClassify */])()]).then(function (res) {
      _this.initLoading = false;
      if (res[0].ret === 0) {
        _this.cityList = res[0].data;
        _this.curCityId = _this.cityList[0].cityId;
        if (res[1].ret === 0) {
          _this.classify = res[1].data;
          _this.goRanking();
        } else {
          console.log('分类列表请求失败');
        }
      } else {
        console.log('城市列表请求失败');
      }
    });
  }
});

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			lockData: null,
			dateRange: [null, null],
			lockDetailKey: [{
				key: 'nickName',
				label: '昵称',
				width: 150
			}, {
				key: 'uid',
				label: '用户id',
				width: 120
			}, {
				key: 'phoneNum',
				label: '手机号',
				width: 130
			}, {
				key: 'origin',
				label: '获取方式',
				width: 180
			}, {
				key: 'partnerName',
				label: '获取用户渠道',
				width: 200
			}, {
				key: 'displayTime',
				label: '获取时间',
				width: 180
			}]
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['promotorType'])),
	methods: {
		handleSizeChange: function handleSizeChange(pageSize) {
			var _this = this;
			if (_this.dateRange[0] && _this.dateRange[1]) {
				var curPage = _this.lockData.curPage;

				var _this$dateParse = _this.dateParse(),
				    from = _this$dateParse.from,
				    to = _this$dateParse.to;

				_this.fetchData({ from: from, to: to, curPage: curPage, pageSize: pageSize });
			} else {
				_this.fetchData({ pageSize: pageSize });
			}
		},
		handleCurrentChange: function handleCurrentChange(curPage) {
			var _this = this;

			if (_this.dateRange[0] && _this.dateRange[1]) {
				var pageSize = _this.lockData.pageSize;

				var _this$dateParse2 = _this.dateParse(),
				    from = _this$dateParse2.from,
				    to = _this$dateParse2.to;

				_this.fetchData({ from: from, to: to, curPage: curPage, pageSize: pageSize });
			} else {
				_this.fetchData({ curPage: curPage });
			}
		},
		dateParse: function dateParse() {
			var _this = this;
			var from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* parseTime */])(_this.dateRange[0]);
			var to = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* parseTime */])(_this.dateRange[1]).replace('00:00:00', '23:59:59');
			return { from: from, to: to };
		},
		dateFilter: function dateFilter() {
			var _this = this;
			if (_this.dateRange[0] && _this.dateRange[1]) {
				var _this$dateParse3 = _this.dateParse(),
				    from = _this$dateParse3.from,
				    to = _this$dateParse3.to;

				_this.fetchData({ from: from, to: to });
			} else {
				_this.fetchData({});
			}
		},
		exportParams: function exportParams() {
			var _this = this;
			var from = '',
			    to = '';
			if (_this.dateRange[0] && _this.dateRange[1]) {
				return _this.dateParse();
			}
			return { from: from, to: to };
		},
		fetchData: function fetchData(obj) {
			var _this = this;
			var params = {};
			if (!obj.from && !obj.to) {
				params['curPage'] = _this.lockData && _this.lockData.curPage || 1;
				params['pageSize'] = _this.lockData && _this.lockData.pageSize || 20;
			}
			for (var key in obj) {
				params[key] = obj[key];
			}
			// console.log(params)
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["d" /* authMobile */])(params).then(function (res) {
				if (res.ret === 0) {
					var _res$data = res.data,
					    curPage = _res$data.curPage,
					    pageSize = _res$data.pageSize,
					    total = _res$data.total;

					var maxPage = Math.ceil(total / pageSize);

					if (curPage > maxPage) {
						obj['curPage'] = maxPage;
						_this.fetchData(obj);
					} else {
						_this.lockData = res.data;
					}
				}
			});
		}
	},
	created: function created() {
		var _this = this;
		_this.fetchData({});
	}
});

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      numsKey: [{
        key: 'active',
        name: '活跃用户数',
        dateType: [{
          key: 'Day',
          name: '日'
        }, {
          key: 'Week',
          name: '周'
        }]
      }, {
        key: 'newUser',
        name: '新增用户数',
        dateType: [{
          key: 'Day',
          name: '日'
        }, {
          key: 'Week',
          name: '周'
        }]
      }],
      lineChart: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              show: true
            }
          }
        },
        xAxis: {
          name: '',
          type: 'category',
          axisLabel: {
            showMinLabel: true
          },
          axisTick: {
            length: 5
          },
          data: []
        },
        yAxis: {
          name: '',
          type: 'value'
        },
        series: [{
          name: '',
          type: 'line',
          data: [],
          label: {
            emphasis: {
              show: true
            }
          }
        }],
        animationDuration: 2000
      },
      incrementKey: [{
        key: 'date',
        label: '时间',
        width: 280
      }, {
        key: 'activeCount',
        label: '活跃用户数',
        width: 280
      }, {
        key: 'newUserCount',
        label: '新增用户数',
        width: 280
      }],
      initLoading: false,
      basicData: null,
      tableData: null,
      recentDataLen: null,
      dateRange: [],
      curCityId: '',
      curCityIdx: 0,
      curChart: 'active',
      curChartRegion: "7",
      chartLoading: false,
      tableLoading: false,
      dataMsg: ''
    };
  },

  components: {
    echarts: __WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts___default.a
  },
  methods: {
    hoverTip: function hoverTip(target, tip) {
      var oTarget = document.querySelectorAll(target);
      var oTip = document.querySelectorAll(tip);
      // console.log(oTarget, oTip)
      var hoverFn = function hoverFn(e) {
        var clientX = e.clientX,
            clientY = e.clientY;

        for (var i = 0; i < oTip.length; i++) {
          oTip[i].style.display = 'block';
          oTip[i].style.top = clientY - 130 + 'px';
          oTip[i].style.left = clientX - 135 + 'px';
        }
      };
      var outFn = function outFn() {
        for (var i = 0; i < oTip.length; i++) {
          oTip[i].style.display = 'none';
          oTip[i].style.top = 0;
          oTip[i].style.left = 0;
        }
      };
      for (var i = 0; i < oTarget.length; i++) {
        oTarget[i].onmouseover = hoverFn;
        oTarget[i].onmousemove = hoverFn;
        oTarget[i].onmouseout = outFn;
      }
    },
    fillChart: function fillChart(data) {
      var _this = this;
      // reset
      _this.lineChart.xAxis.data = [];
      _this.lineChart.series[0].data = [];

      var tmpX = [],
          tmpY = [];
      data.forEach(function (item, idx) {
        tmpX[idx] = item.date.replace('2017-', '');
        tmpY[idx] = item[_this.curChart + 'Count'];
      });
      // fill
      _this.lineChart.xAxis.data = tmpX;
      _this.lineChart.series[0].data = tmpY;
      _this.chartLoading = false;
    },
    fillTable: function fillTable(data) {
      var _this = this;
      _this.tableData = data;
      _this.tableLoading = false;
    },
    switchCity: function switchCity(curCityId) {
      var _this = this;
      _this.chartLoading = true;
      _this.tableLoading = true;
      // reset
      _this.curChart = 'active';
      _this.curChartRegion = '7';
      _this.basicData.forEach(function (item, idx) {
        if (item.cityId === curCityId) {
          _this.curCityIdx = idx;
          _this.recentDataLen = item.recentData.length;
        }
      });
      if (_this.recentDataLen) {
        _this.dateRange = [];
        _this.dateRange[0] = new Date(_this.basicData[_this.curCityIdx].recentData[0].date);
        _this.dateRange[1] = new Date(_this.basicData[_this.curCityIdx].recentData[_this.recentDataLen - 1].date);
      }
      _this.switchChart(_this.curChart);
      _this.fillTable(_this.basicData[_this.curCityIdx].recentData);
      _this.$nextTick(function () {
        _this.hoverTip('.oHelp.forTitle', '.oTip.forTitle');
        _this.hoverTip('.oHelp.forType', '.oTip.forType');
      });
    },
    switchChart: function switchChart(curChart) {
      var _this = this;
      _this.chartLoading = true;
      var chartName = _this.numsKey.filter(function (i) {
        return i.key === curChart;
      })[0].name;
      _this.lineChart.xAxis.name = '日期';
      _this.lineChart.yAxis.name = chartName;
      _this.lineChart.series[0].name = chartName;
      _this.switchChartRegion(_this.curChartRegion);
    },
    switchChartRegion: function switchChartRegion(curChartRegion) {
      var _this = this;
      _this.chartLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["k" /* chartRegionData */])({ city: _this.curCityId, region: curChartRegion }).then(function (res) {
        _this.fillChart(res.data);
      });
    },
    switchTableRegion: function switchTableRegion(dateRange) {
      var _this = this;
      _this.tableLoading = true;
      var city = _this.curCityId;
      var start = dateRange.split(' - ')[0] || '';
      var end = dateRange.split(' - ')[1] || '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["l" /* tableRegionData */])({ city: city, start: start, end: end }).then(function (res) {
        _this.fillTable(res.data);
      });
    },
    exportParams: function exportParams() {
      var _this = this;
      var city = _this.curCityId;
      var startDate = '',
          endDate = '';
      if (_this.dateRange.length) {
        startDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* parseTime */])(_this.dateRange[0]).replace(/\s\d+\:\d+\:\d+/g, '');
        endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* parseTime */])(_this.dateRange[1]).replace(/\s\d+\:\d+\:\d+/g, '');
      }
      return { city: city, startDate: startDate, endDate: endDate };
    }
  },
  created: function created() {
    var _this = this;
    _this.initLoading = true;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["m" /* incrementData */])().then(function (res) {
      _this.initLoading = false;
      // res.ret = 0;
      // res.data = [
      //   {
      //     date: "2017-11-14",
      //     cityId: "431100",
      //     cityName: "北京市市辖区",
      //     activeCount: 635105,
      //     activeCompareDay: "2.09%",
      //     activeCompareWeek: "5.67%",
      //     newUserCount: 2758,
      //     newUserCompareDay: "-16.60%",
      //     newUserCompareWeek: "-4.16%",
      //     recentData: [
      //     {
      //       date: "2017-11-08",
      //       activeCount: 623369,
      //       newUserCount: 2910,
      //       t: 1510070400000
      //     },
      //     {
      //       date: "2017-11-09",
      //       activeCount: 616944,
      //       newUserCount: 2306,
      //       t: 1510156800000
      //     },
      //     {
      //       date: "2017-11-10",
      //       activeCount: 593098,
      //       newUserCount: 2489,
      //       t: 1510243200000
      //     },
      //     {
      //       date: "2017-11-11",
      //       activeCount: 549228,
      //       newUserCount: 2517,
      //       t: 1510329600000
      //     },
      //     {
      //       date: "2017-11-12",
      //       activeCount: 577896,
      //       newUserCount: 3306,
      //       t: 1510416000000
      //     },
      //     {
      //       date: "2017-11-13",
      //       activeCount: 622082,
      //       newUserCount: 3307,
      //       t: 1510502400000
      //     },
      //     {
      //       date: "2017-11-14",
      //       activeCount: 635105,
      //       newUserCount: 2758,
      //       t: 1510588800000
      //     }
      //     ]
      //   }
      // ]
      if (res.ret === 0) {
        if (res.data.length) {
          _this.basicData = res.data;
          _this.curCityId = _this.basicData[_this.curCityIdx].cityId;
          _this.tableData = _this.basicData[_this.curCityIdx].recentData;
        }
      } else {
        _this.dataMsg = res.msg;
      }
    });
  }
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(55);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			lockData: null,
			dateRange: [null, null],
			lockDetailKey: [{
				key: 'nickName',
				label: '昵称',
				width: 120
			}, {
				key: 'uid',
				label: '用户id',
				width: 110
			}, {
				key: 'mobile',
				label: '手机号',
				width: 124
			}, {
				key: 'myAmount',
				// label: '我的渠道销售额',
				label: '站外销售额',
				width: 160
			}, {
				key: 'myBrokerage',
				// label: '我的渠道佣金',
				label: '站外佣金',
				width: 125
			}, {
				key: 'lockAmount',
				// label: '锁定销售额',
				label: 'APP内销售额',
				width: 120
			}, {
				key: 'lockBrokerage',
				// label: '锁定用户佣金',
				label: 'APP内订单佣金',
				width: 140
			}, {
				key: 'origin',
				label: '锁定方式',
				width: 150
			}, {
				key: 'promotorName',
				label: '锁定渠道',
				width: 200,
				template: 'extraChannelMsg'
			}, {
				key: 'lockDate',
				label: '锁定时间',
				width: 170
			}]
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['promotorType'])),
	methods: {
		handleSizeChange: function handleSizeChange(pageSize) {
			var _this = this;
			if (_this.dateRange[0] && _this.dateRange[1]) {
				var curPage = _this.lockData.curPage;

				var _this$dateParse = _this.dateParse(),
				    from = _this$dateParse.from,
				    to = _this$dateParse.to;

				_this.fetchData({ from: from, to: to, curPage: curPage, pageSize: pageSize });
			} else {
				_this.fetchData({ pageSize: pageSize });
			}
		},
		handleCurrentChange: function handleCurrentChange(curPage) {
			var _this = this;

			if (_this.dateRange[0] && _this.dateRange[1]) {
				var pageSize = _this.lockData.pageSize;

				var _this$dateParse2 = _this.dateParse(),
				    from = _this$dateParse2.from,
				    to = _this$dateParse2.to;

				_this.fetchData({ from: from, to: to, curPage: curPage, pageSize: pageSize });
			} else {
				_this.fetchData({ curPage: curPage });
			}
		},
		dateParse: function dateParse() {
			var _this = this;
			var from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* parseTime */])(_this.dateRange[0]);
			var to = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* parseTime */])(_this.dateRange[1]).replace('00:00:00', '23:59:59');
			return { from: from, to: to };
		},
		dateFilter: function dateFilter() {
			var _this = this;
			if (_this.dateRange[0] && _this.dateRange[1]) {
				var _this$dateParse3 = _this.dateParse(),
				    from = _this$dateParse3.from,
				    to = _this$dateParse3.to;

				_this.fetchData({ from: from, to: to });
			} else {
				_this.fetchData({});
			}
		},
		exportParams: function exportParams() {
			var _this = this;
			var from = '',
			    to = '';
			if (_this.dateRange[0] && _this.dateRange[1]) {
				return _this.dateParse();
			}
			return { from: from, to: to };
		},
		addTips: function addTips() {
			var oTarget = document.querySelector('.cell.myAmount');
			if (oTarget) {
				// tipIcon
				var oHelp = document.createElement('div');
				oHelp.innerHTML = '?';
				oHelp.style.cssText = 'position:absolute;top:50%;right:24px;transform:translateY(-50%);display:flex;justify-content:center;align-items:center;font-size:12px;color:#fff;width:15px;height:15px;border-radius:50%;background-color:#1f2d3d;cursor:pointer';
				oTarget.appendChild(oHelp);

				var oTip = document.querySelector('.oTip');
				var hoverFn = function hoverFn(e) {
					var clientX = e.clientX,
					    clientY = e.clientY;

					oTip.style.display = 'block';
					oTip.style.top = clientY - 130 + 'px';
					oTip.style.left = clientX - 135 + 'px';
				};
				var outFn = function outFn() {
					oTip.style.display = 'none';
					oTip.style.top = 0;
					oTip.style.left = 0;
				};
				oHelp.onmouseover = hoverFn;
				oHelp.onmousemove = hoverFn;
				oHelp.onmouseout = outFn;
			}
		},
		fetchData: function fetchData(obj) {
			var _this = this;
			var params = {};
			if (!obj.from && !obj.to) {
				params['curPage'] = _this.lockData && _this.lockData.curPage || 1;
				params['pageSize'] = _this.lockData && _this.lockData.pageSize || 20;
			}
			for (var key in obj) {
				params[key] = obj[key];
			}
			// console.log(params)
			if (this.promotorType == '1') {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["e" /* lockDetail */])(params).then(function (res) {
					if (res.ret === 0) {
						var _res$data = res.data,
						    curPage = _res$data.curPage,
						    pageSize = _res$data.pageSize,
						    total = _res$data.total;

						var maxPage = Math.ceil(total / pageSize);

						if (curPage > maxPage) {
							obj['curPage'] = maxPage;
							_this.fetchData(obj);
						} else {
							_this.lockData = res.data;
						}

						// 添加tip提示图标
						// _this.$nextTick(() => _this.addTips());
					}
				});
			} else {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["f" /* lockPromotorDetail */])(params).then(function (res) {
					if (res.ret === 0) {
						var _res$data2 = res.data,
						    curPage = _res$data2.curPage,
						    pageSize = _res$data2.pageSize,
						    total = _res$data2.total;

						var maxPage = Math.ceil(total / pageSize);

						if (curPage > maxPage) {
							obj['curPage'] = maxPage;
							_this.fetchData(obj);
						} else {
							_this.lockData = res.data;
						}

						// 添加tip提示图标
						// _this.$nextTick(() => _this.addTips());
					}
				});
			}
		}
	},
	created: function created() {
		var _this = this;
		_this.fetchData({});
	}
});

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_card__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_card__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      distributorKey: ['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount'],
      distributorData: {}
    };
  },

  components: {
    card: __WEBPACK_IMPORTED_MODULE_1_components_card___default.a
  },
  computed: {},
  mounted: function mounted() {
    this.distributorSearch();
  },

  methods: {
    distributorSearch: function distributorSearch() {
      var vis = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api__["M" /* distributorSaleInfo */])(arguments[0]).then(function (res) {
        if (res.ret == 0) {
          vis.distributorData = res.data;
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_validate__ = __webpack_require__(203);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var validateFun = function validateFun(valueRole) {
      var errorText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '不能为空';
      return function (rule, value, callback) {
        if (rule.required === true && (!value || typeof valueRole === "function" && !valueRole(value))) {
          callback(new Error(errorText));
        } else {
          callback();
        }
      };
    };
    var createRole = function createRole(obj) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        required: true, validator: validateFun()
      }, obj);
    };

    var percentData = [];
    for (var i = 0; i < 36; i++) {
      percentData.push(i + '%');
    }
    var percentData2 = [];
    for (var _i = 0; _i < 11; _i++) {
      percentData2.push(_i + '%');
    }

    return {
      tableData: [],
      loading: false,
      check: false,
      infoId: 0,
      keyTxt: {
        name: {
          txt: '姓名',
          placeholder: '请输入姓名'
        },
        mobile: {
          txt: '手机号',
          placeholder: '请输入手机号'
        },
        idCardNo: {
          txt: '身份证号',
          placeholder: '请输入身份证号'
        },
        brokerageRatio: {
          txt: '站外订单分成比例',
          placeholder: '请选择分成比例'
        },
        appRatio: {
          txt: 'APP站内订单分成比例',
          placeholder: '请选择分成比例'
        }
      },
      infoForm: {
        name: '',
        mobile: '',
        idCardNo: "",
        brokerageRatio: "",
        appRatio: "",
        needDisPlayPrivilege: 0
      },
      percentData: percentData,
      percentData2: percentData2,
      infoRules: {
        mobile: [
          // createRole({validator: validateFun(validatePhone, '请输入正确的手机号码')})
        ],
        name: [createRole()],
        idCardNo: [
          // createRole({validator: validateFun(validateidCardNo, '请输入正确的身份证号')})
        ]
      }
    };
  },

  props: [],
  components: {},
  computed: {},
  mounted: function mounted() {
    var params = this.$route.params;
    console.log(params);
    this.check = !!+params.check;
    this.infoId = +params.infoId;
    this.infoId && this.dataInit(this.infoId);
  },

  methods: {
    turnSwitch: function turnSwitch(val) {
      if (val == 0 || val == '0%') {
        this.$data.infoForm.needDisPlayPrivilege = 0;
      } else {
        this.$data.infoForm.needDisPlayPrivilege = 1;
      }
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      var vis = this;
      vis.$refs.infoForm.validate(function (valid) {
        if (valid) {
          vis.loading = true;
          if (_this.infoId) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api__["r" /* promotorUpdate */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: _this.infoId }, _this.infoForm)).then(function (res) {
              vis.loading = false;
              if (parseInt(res.ret) === 0) {
                _this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                vis.$router.push({ name: 'distributorManager' });
              }
            }).catch(function () {
              vis.loading = false;
            });
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api__["s" /* promotorCreate */])(_this.infoForm).then(function (res) {
              vis.loading = false;
              if (parseInt(res.ret) === 0) {
                _this.$message({
                  type: 'success',
                  message: '创建成功!'
                });
                vis.$router.push({ name: 'distributorManager' });
              } else {
                _this.$message({
                  type: 'error',
                  message: res.msg
                });
              }
            }).catch(function () {
              vis.loading = false;
            });
          }
        } else {
          //console.log('error submit')
          return false;
        }
      });
    },
    handleCancel: function handleCancel() {
      var vis = this;
      if (vis.infoId) {
        vis.dataInit(vis.infoId);
      } else {
        vis.$refs['infoForm'].resetFields();
      }
    },
    dataInit: function dataInit(promotorId) {
      var vis = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api__["t" /* promotorInfo */])(promotorId).then(function (res) {
        var resData = res.data;
        vis.infoForm = resData.promotor;
        vis.tableData = resData.ratios;
      }).catch(function () {});
    }
  },
  watch: {}
});

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_validate__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var tableProps = ['id', 'name', 'accountState', 'mobile', 'brokerageRatio', 'appRatio', 'orderAmount', 'brokerageAmount', 'createdAt', 'updatedAt'];
    var tableTitle = ['ID', '姓名', '状态', '手机号', '站外订单分成比例', 'APP内订单分成比例', '销售金额', '佣金', '创建时间', '操作时间'];
    var widths = [70, 110, 70, 130, 100, 110, 100, 120, 120, 130];
    var distriTableColumn = [];
    tableTitle.forEach(function (item, index) {
      var temp = {
        prop: tableProps[index],
        label: item,
        width: widths[index]
      };
      distriTableColumn.push(temp);
    });

    var validateMobile = function validateMobile(rule, value, callback) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_validate__["a" /* validatePhone */])(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      //控制distributorInfo页面
      infoData: {
        check: false,
        infoId: 1
      },
      filterTerm: {
        name: '',
        mobile: '',
        idCardNo: '',
        accountState: '',
        createdAtStart: '',
        createdAtEnd: ''
      },
      queryData: {
        curPage: 1,
        pageSize: 20,
        promotors: [],
        totalRecords: 1
      },
      distriTableColumn: distriTableColumn,
      loading: false,
      distributorStatus: [{
        value: "-1",
        label: "全部"
      }, {
        value: "1",
        label: "在职"
      }, {
        value: "2",
        label: "离职"
      }]
    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['promotorType', 'accountState'])),
  created: function created() {
    var vis = this;
    vis.loading = true;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["u" /* promotorSearch */])().then(function (res) {
      vis.loading = false;
      if (res.ret == 0) {
        var resData = res.data;
        var promotorsData = vis.handlePromotor(resData.promotors);
        var queryData = vis.queryData;
        queryData.curPage = resData.curPage;
        queryData.pageSize = resData.pageSize;
        queryData.totalRecords = resData.totalRecords;
        queryData.promotors = promotorsData;
      }
    }).catch(function () {});
  },

  methods: {
    bl: function bl() {},
    handlePromotor: function handlePromotor(data) {
      data.map(function (item) {
        for (var i in item) {
          if (i == 'accountState') {
            var t = item[i] == 1 ? '在职' : '离职';
            item[i] = t;
          }
        }
      });
      return data;
    },
    filter: function filter(bringPag) {
      var vis = this;
      var createdAtStart = vis.filterTerm.createdAtStart;
      var createdAtEnd = vis.filterTerm.createdAtEnd;

      var tempForm = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vis.filterTerm));

      if (createdAtStart || createdAtEnd) {
        tempForm.createdAtStart = createdAtStart && vis.filterTerm.createdAtStart.getTime();
        tempForm.createdAtEnd = createdAtEnd && vis.filterTerm.createdAtEnd.getTime() + (23 * 3600 + 59 * 60 + 59) * 1000;
        if (createdAtStart && createdAtEnd && tempForm.createdAtStart >= tempForm.createdAtEnd) {
          vis.$message({
            message: '终止日期需大于起始日期，请重新选择',
            type: 'warning'
          });
          vis.filterTerm.createdAtStart = '';
          vis.filterTerm.createdAtEnd = '';
          return;
        }
      }
      if (bringPag) {
        tempForm['pageSize'] = vis.queryData.pageSize;
        tempForm['curPage'] = vis.queryData.curPage;
      }
      for (var i in tempForm) {
        if (!tempForm[i]) {
          delete tempForm[i];
        }
      }
      vis.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["u" /* promotorSearch */])(tempForm).then(function (res) {
        vis.loading = false;
        var resData = res.data;
        var promotorsData = vis.handlePromotor(resData.promotors);
        var queryData = vis.queryData;
        queryData.curPage = resData.curPage;
        queryData.pageSize = resData.pageSize;
        queryData.totalRecords = resData.totalRecords;
        queryData.promotors = promotorsData;
      });
    },
    handleSizeChange: function handleSizeChange() {
      this.queryData.pageSize = arguments[0];
      this.filter(1);
    },
    handleCurrentChange: function handleCurrentChange() {
      this.queryData.curPage = arguments[0];
      this.filter(1);
    },
    dimission: function dimission(id) {
      var _this = this;

      var vis = this;
      this.$confirm('确定离职改用户吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["v" /* promotorLeaveJob */])(id).then(function (res) {
          _this.$message({
            type: 'success',
            message: '离职成功!'
          });
          vis.filter();
        });
      }).catch(function () {});
    },
    toInfo: function toInfo(infoId, check) {
      this.$router.push({ name: 'distributorDetail', params: { infoId: infoId, check: check } });
      //        this.$router.push({name: 'distributorDetail', params: {infoId, check: true}});
    }
  }
});

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_401_gif__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_401_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assets_401_gif__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      errGif: __WEBPACK_IMPORTED_MODULE_0_assets_401_gif___default.a + '?' + +new Date(),
      ewizardClap: 'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646',
      dialogVisible: false
    };
  },

  methods: {
    back: function back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/dashboard' });
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    message: function message() {
      return '特朗普说这个页面你不能进......';
    }
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppMain',
  data: function data() {
    return {
      activeName: 'first',
      children: [],
      parent_path: '',
      permission_routers: this.$store.getters.permission_routers
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isPromotorDisplay']), {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();
    }
  }),
  mounted: function mounted() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var vis = this;
      var route_path = this.$route.path;
      // let parent_path = `/${route_path.split('/')[1]}`
      var tmpIdx = route_path.lastIndexOf('/');
      var parent_path = route_path.slice(0, tmpIdx);
      vis.parent_path = parent_path;
      vis.permission_routers.forEach(function (item) {
        if (item.path == parent_path) {
          vis.children = item.children;
          item.children.forEach(function (child, index) {
            if (parent_path + '/' + child.path == route_path) {
              vis.activeName = child.activeName || child.path;
            }
          });
        }
      });
    },
    handleClick: function handleClick() {
      var props = arguments[0];
      this.$router.push(this.parent_path + '/' + props.name);
    }
  },
  watch: {
    '$route': 'fetchData'
  }
});

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_layout__ = __webpack_require__(510);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0_views_layout__["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_0_views_layout__["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_0_views_layout__["c" /* AppMain */]
  },
  computed: {}
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['name', 'avatar', 'AVATAR_LINK', 'PROTOCOL', 'uid', 'HOST'])),
  methods: {
    logout: function logout() {
      this.$store.dispatch('LogOut').then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['permission_routers', 'promotorType', 'isPromotorDisplay'])),
  mounted: function mounted() {}
});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_card__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_card__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      summaryData: {},
      realTimeData: {},
      subsiteData: {},
      distributorData: {},
      // subsiteKey:['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount'],
      subsiteKey: ['name', 'salesAmount', 'commission', 'paidOrderCount'],
      // distributorKey:['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount'],
      distributorKey: ['name', 'salesAmount', 'commission', 'paidOrderCount'],
      // distributorLockKey:['name','lockSalesAmount','lockCommission','lockPaidOrderCount','lockPaidUserCount'],
      // distributorLockKey:['name','lockSalesAmount','lockCommission','lockPaidOrderCount'],
      dialogVisible: false,
      addUrl: '',
      auroraDatas: [],
      recentList: [],
      profit: true //预付款余额是否充足
    };
  },

  components: {
    card: __WEBPACK_IMPORTED_MODULE_3_components_card___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['uid', 'promotorType', 'accountState'])),
  created: function created() {
    var vis = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api__["J" /* recent */])().then(function (res) {
      if (res.ret == 0) {
        vis.recentList = res.data;
      }
    }).catch(function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api__["K" /* opertionSummary */])().then(function (res) {
      if (res.ret == 0) {
        vis.summaryData = res.data;
      }
    }).catch(function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api__["L" /* realtimeInfo */])().then(function (res) {
      if (res.ret == 0) {
        vis.realTimeData = res.data;
      }
    }).catch(function () {});
    if (vis.promotorType == 1) {
      vis.distributorSearch();
    }
    vis.subsiteSearch();
  },

  methods: {
    distributorSearch: function distributorSearch() {
      var vis = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api__["M" /* distributorSaleInfo */])(arguments[0]).then(function (res) {
        if (res.ret == 0) {
          vis.distributorData = res.data;
        }
      }).catch(function () {});
    },
    subsiteSearch: function subsiteSearch() {
      var vis = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api__["N" /* subsiteSaleInfo */])(arguments[0]).then(function (res) {
        if (res.ret == 0) {
          vis.subsiteData = res.data;
        }
      }).catch(function () {});
    },
    auroraIndexUrl: function auroraIndexUrl() {
      var url = location.origin.indexOf('.test.') >= 0 ? 'http://aurora.test.ximalaya.com/back/config/backend/index' : 'http://aurora-plat.ximalaya.com/config/backend/index';
      window.open(url, '_blank');
    },
    goOut: function goOut(url) {
      window.open(url, '_blank');
    },
    getToken: function getToken(name) {
      var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return value ? value[2].split('&').length == 2 ? value[2].split('&')[1] : '' : '';
    },
    openModal: function openModal() {
      var _this = this;

      this.addUrl = location.origin.indexOf('.test.') >= 0 ? 'http://m.test.ximalaya.com/passport/auth/12/authorize/?fromUri=' + encodeURIComponent('http://aurora.test.ximalaya.com/back/config/backend/qrCodeBinding?bindingId=' + this.uid + '&cookie=' + this.getToken('4&_token')) : 'http://m.ximalaya.com/passport/auth/12/authorize/?fromUri=' + encodeURIComponent('http://aurora-plat.ximalaya.com/config/backend/qrCodeBinding?bindingId=' + this.uid + '&cookie=' + this.getToken('1&_token'));

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api__["O" /* auroraAccounts */])().then(function (res) {
        if (res.ret == 0) {
          _this.auroraDatas = res.data;
          _this.dialogVisible = true;
        }
      }).catch(function () {
        _this.$message({
          type: 'error',
          message: '服务异常！'
        });
      });
    },
    goAdvancepayment: function goAdvancepayment() {
      // 跳转预付款页面
      this.$router.push('/advancepayment/manager');
    }
  }
});

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filterTerm: {
        "orderNo": "", // 订单编号
        "commodityType": "", // 商品类型
        "commodityName": "", // 商品名称
        "promotorId": "", // 分销商名称
        "buyerNickName": "", // 用户昵称
        "buyerMobile": "", // 用户手机号
        "orderStatus": "", // 订单状态
        "sourceSubsiteId": "", // 子站Id
        "createdAtFrom": "", // 创建时间区间起始时间
        "createdAtTo": "", // 创建时间区间结束时间
        "pageNo": "", // 页码
        "pageSize": 20 // 分页大小
      },
      curPage: 1,
      totalRecords: 0,
      loading: false,
      goodsTypeOptions: [{
        id: 0,
        name: '全部'
      }, {
        id: 1,
        name: '单集购买'
      }, {
        id: 2,
        name: '付费订阅'
      }, {
        id: 4,
        name: '巅峰会员'
      }],
      orderChannelOptions: [],
      orderStatusOptions: [{
        id: 0,
        name: '全部'
      }, {
        id: 2,
        name: '订单成功'
      }, {
        id: 5,
        name: '已退款'
      }],
      sourceStationOptions: [],
      orderTableData: []
    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['HOST', 'PROTOCOL', 'promotorType']), {
    requireData: function requireData() {
      var vis = this;
      var temp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils__["b" /* deleteEmptyObj */])(vis.getSendData());
      var result = '';
      for (var i in temp) {
        var value = temp[i];
        result = result + '&' + i + '=' + value;
      }
      return result.substr(1);
    }
  }),
  created: function created() {
    var vis = this;
    if (this.$route.query.number) {
      this.$data.filterTerm.orderNo = this.$route.query.number;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["o" /* orderMgmtChannel */])().then(function (res) {
      if (res && res.ret == 0) {
        vis.orderChannelOptions = res.data;
        vis.orderChannelOptions.unshift({ id: 0, name: '全部' });
      }
    }).catch(function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["p" /* orderMgmtSubsite */])().then(function (res) {
      if (res && res.ret == 0) {
        vis.sourceStationOptions = res.data;
        vis.sourceStationOptions.unshift({ subSiteId: 0, subSiteName: '全部' });
      }
    }).catch(function () {});
    vis.handleSubmit();
  },

  methods: {
    handleSizeChange: function handleSizeChange() {
      this.filterTerm.pageSize = arguments[0];
      this.handleSubmit();
    },
    toOrderTips: function toOrderTips() {
      var _url = this.promotorType == '2' ? 'https://shimo.im/docs/WTtmdBMOjqAyRkgY/' : 'https://shimo.im/docs/Z8BPssACvkMPXyzF/';
      window.open(_url, '_blank');
    },
    handleCurrentChange: function handleCurrentChange() {
      this.curPage = arguments[0];
      this.handleSubmit();
    },
    getSendData: function getSendData() {
      var vis = this;

      var temp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vis.filterTerm));
      temp['curPage'] = vis.curPage;

      var createdAtFrom = vis.filterTerm.createdAtFrom;
      var createdAtTo = vis.filterTerm.createdAtTo;
      if (createdAtFrom || createdAtTo) {
        temp.createdAtFrom = createdAtFrom && vis.filterTerm.createdAtFrom.getTime();
        temp.createdAtTo = createdAtTo && vis.filterTerm.createdAtTo.getTime() + (23 * 3600 + 59 * 60 + 59) * 1000;
        if (createdAtFrom && createdAtTo && temp.createdAtFrom >= temp.createdAtTo) {
          vis.$message({
            message: '终止日期需大于起始日期，请重新选择',
            type: 'warning'
          });
          vis.filterTerm.createdAtFrom = '';
          vis.filterTerm.createdAtTo = '';
          return;
        }
      }
      return temp;
    },
    handleSubmit: function handleSubmit() {
      var vis = this;
      vis.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["q" /* orderMgmtOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils__["b" /* deleteEmptyObj */])(vis.getSendData())).then(function (res) {
        vis.loading = false;
        if (res.ret == 0) {
          var resData = res.data;
          var orders = vis.handleOrderData(resData.orders);
          vis.orderTableData = orders;
          vis.totalRecords = resData.totalRecords;
          // vis.curPage = resData.curPage
        }
      }).catch(function () {});
    },
    handleOrderData: function handleOrderData(data) {
      var _this = this;

      if (data) {
        data.map(function (item) {
          for (var i in item) {
            if (i == 'orderStatus') {
              item[i] = item[i] == 5 ? '已退款' : item[i] == 2 ? '订单成功' : '';
            } else if (i == 'commodityType') {
              item[i] = item[i] == 1 ? '单集购买' : item[i] == 2 ? '付费订阅' : '巅峰会员';
            } else if (i == 'promotorType') {
              if (item[i] == 1) {
                item[i] = '城市服务商';
              } else if (item[i] == 2) {
                _this.promotorType == 1 ? item[i] = '分销商' : item[i] = '';
              } else {
                item[i] = '';
              }
            } else if (i == 'createdAt') {
              item[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils__["c" /* getFormatTime */])(item[i]);
            }
          }
        });
      } else {
        data = [];
      }
      return data;
    }
  }
});

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pageSize: 20,
      curPage: 1,
      totalRecords: 0,
      loading: false,
      orderTableData: []
    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['HOST', 'PROTOCOL', 'promotorType'])),
  created: function created() {
    var vis = this;
    vis.handleSubmit();
  },

  methods: {
    handleSizeChange: function handleSizeChange() {
      this.pageSize = arguments[0];
      this.handleSubmit();
    },
    handleCurrentChange: function handleCurrentChange() {
      this.curPage = arguments[0];
      this.handleSubmit();
    },
    handleSubmit: function handleSubmit() {
      var vis = this;
      vis.loading = true;
      var temp = {};
      temp['curPage'] = vis.curPage;
      temp['pageSize'] = vis.pageSize;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api__["n" /* orderMgmtLock */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils__["b" /* deleteEmptyObj */])(temp)).then(function (res) {
        vis.loading = false;
        if (res.ret == 0) {
          var resData = res.data;
          var orders = vis.handleOrderData(resData.lockOrderList);
          vis.orderTableData = orders;
          vis.totalRecords = resData.totalRecords;
        }
      }).catch(function () {});
    },
    handleOrderData: function handleOrderData(data) {
      if (data) {
        data.map(function (item) {
          for (var i in item) {
            if (i == 'commodityType') {
              item[i] = item[i] == 1 ? '单集购买' : item[i] == 2 ? '付费订阅' : '巅峰会员';
            } else if (i == 'createdAt') {
              item[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils__["c" /* getFormatTime */])(item[i]);
            }
          }
        });
      } else {
        data = [];
      }
      return data;
    }
  }
});

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      notifyAllData: [],
      pageNo: 1,
      pageTotal: 0,
      c: null
    };
  },

  methods: {
    pageChange: function pageChange(val) {
      this.pageNo = val;
    },
    getData: function getData() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api__["b" /* notifyList */])({
        pageNo: this.pageNo
      }).then(function (res) {
        if (res.ret === 0) {
          _this.notifyAllData = res.data.list;
          _this.pageTotal = res.data.count;
        }
      });
    },
    collapseChange: function collapseChange(id) {
      this.notifyAllData.forEach(function (v, i) {
        if (v.id == id && !v.read) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api__["c" /* notifyRead */])({
            id: id
          }).then(function (res) {
            if (res.ret === 0) {
              v.read = true;
            }
          });
        }
      });
    }
  },
  watch: {
    pageNo: function pageNo(val) {
      this.getData();
    }
  },
  created: function created() {
    var vis = this;
    // Promise.all([partnerNotice(), notifyAll()])
    // .then(res => {
    //   res[0].ret === 0 ? vis.noticeData = res[0].data : console.log(res[0].msg);
    //   res[1].ret === 0 ? vis.notifyAllData = res[1].data : console.log(res[1].msg);
    // })
    this.getData();
  }
});

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currPage: 1,
      activeName: 'first',
      name: '',
      phone: '',
      idNumber: '',
      applyDate: '',
      loading: false,
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        phone: '15566666666',
        idNumber: '449999999999999',
        mark: '加我as阿斯顿发送到发送的'
      }]
    };
  },

  components: {},
  computed: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activeName: '0',
      loading: false,
      subSiteId: '',
      keyWord: '',
      pageSize: 20,
      listData: {
        list: [],
        curPage: 1,
        totalRecords: 0
      },
      tabList: [{
        txt: '付费专辑',
        key: 'paidAlbum'
      }, {
        txt: '付费声音',
        key: 'paidTrack'
      }],
      getFormatTime: __WEBPACK_IMPORTED_MODULE_3_utils__["c" /* getFormatTime */],
      options: [],
      showList: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['HOST', 'PROTOCOL', 'promotorType', 'accountState'])),
  created: function created() {
    this.getOptions();
  },

  methods: {
    tabClick: function tabClick() {
      this.subsiteAlbumSearch();
    },
    hasQRcode: function hasQRcode(row) {
      return Boolean(row.albumUrl || row.trackUrl || row.qrCodeUrl);
    },
    getOptions: function getOptions() {
      var vis = this;
      var temp = {
        "curPage": 1,
        "pageSize": 1000
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["w" /* subsiteList */])(temp).then(function (res) {
        vis.loading = false;
        if (res.ret == 0) {
          res.data.list.forEach(function (subsite) {
            var option = {
              label: subsite.subSiteName,
              value: subsite.subSiteId
            };
            vis.options.push(option);
          });
        }
      }).catch(function () {});
    },
    handleSizeChange: function handleSizeChange() {
      this.pageSize = arguments[0];
      this.subsiteAlbumSearch(1);
    },
    handleCurrentChange: function handleCurrentChange() {
      this.listData.curPage = arguments[0];
      this.subsiteAlbumSearch(1);
    },
    subsiteAlbumSearch: function subsiteAlbumSearch(bringPag) {
      var vis = this;
      var temp = {
        "subSiteId": vis.subSiteId, //子站编号  optional 与 子站名称 二选一，同时传以编号为准
        "keyWord": vis.keyWord //子站名称  optional 与 子站编号 二选一，同时传将被忽略
      };
      if (!/^[0-9]*[1-9][0-9]*$/.test(vis.subSiteId)) {
        vis.$message({
          type: 'warning',
          message: '请选择子站！'
        });
        return;
      }
      if (vis.keyWord.length == 0) {
        vis.$message({
          type: 'warning',
          message: '请填写专辑/声音名称！'
        });
        return;
      }
      if (bringPag) {
        temp['curPage'] = vis.listData.curPage;
        temp['pageSize'] = vis.pageSize;
      }
      vis.loading = true;
      // 声音/专辑
      if (vis.activeName == '1') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["x" /* subsiteTrackList */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils__["b" /* deleteEmptyObj */])(temp)).then(function (res) {
          vis.loading = false;
          vis.showList = true;
          if (res.ret == 0) {
            if (res.data) {
              vis.listData = res.data;
            } else {
              vis.$message({
                type: 'error',
                message: '数据异常！'
              });
            }
          }
        }).catch(function () {
          vis.loading = false;
          vis.$message({
            type: 'error',
            message: '服务异常！'
          });
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["y" /* subsiteAlbumList */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils__["b" /* deleteEmptyObj */])(temp)).then(function (res) {
          vis.loading = false;
          vis.showList = true;
          if (res.ret == 0) {
            if (res.data) {
              vis.listData = res.data;
            } else {
              vis.$message({
                type: 'error',
                message: '数据异常！'
              });
            }
          }
        }).catch(function () {
          vis.loading = false;
          vis.$message({
            type: 'error',
            message: '服务异常！'
          });
        });
      }
    },
    drawBeauty: function drawBeauty(beauty) {
      var mycv = document.getElementsByClassName("canvasQr");
      for (var i = 0, len = mycv.length; i < len; i++) {
        var child = mycv[i];
        var width = child.width;
        var myctx = child.getContext("2d");
        myctx.drawImage(beauty, 0, 0, width, width);
      }
    },
    GetUrlRelativePath: function GetUrlRelativePath(url) {
      var arrUrl = url.split("//");
      var start = arrUrl[1].indexOf("/");
      var relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符
      if (relUrl.indexOf("?") != -1) {
        relUrl = relUrl.split("?")[0];
      }
      return relUrl;
    },
    downloadQr: function downloadQr(qrUrl, subName) {
      var vis = this;
      if (qrUrl) {
        new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var beauty = new Image();
          beauty.setAttribute('crossOrigin', 'anonymous');
          /**
          let relativePath
          try{
            relativePath = vis.GetUrlRelativePath(qrUrl)
          }catch(err){
             reject('二维码地址有误')
          }
           console.log(relativePath)
          beauty.src = vis.PROTOCOL+vis.HOST+'/qrcode'+relativePath
          */
          beauty.src = qrUrl;
          if (beauty.complete) {
            vis.drawBeauty(beauty);
            resolve();
          } else {
            beauty.onload = function () {
              vis.drawBeauty(beauty);
              resolve();
            };
            beauty.onerror = function (error) {
              console.log(error);
              reject('图片加载失败，请重试');
            };
          }
        }).then(function (value) {
          var type = 'png';
          var fixtype = function fixtype(type) {
            type = type.toLocaleLowerCase().replace(/jpg/i, 'jpeg');
            var r = type.match(/png|jpeg|bmp|gif/)[0];
            return 'image/' + r;
          };
          var savaFile = function savaFile(data, filename) {
            var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
            save_link.href = data;
            save_link.download = filename;
            var event = document.createEvent('MouseEvents');
            event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            save_link.dispatchEvent(event);
          };

          var d = document.getElementsByClassName("canvasQr");
          for (var i = 0, len = d.length; i < len; i++) {
            var child = d[i];
            var imgdata = child.toDataURL(type);
            imgdata = imgdata.replace(fixtype(type), 'image/octet-stream');
            var w = child.width;
            var filename = '\u3010' + subName + '\u3011\u4E8C\u7EF4\u7801 - ' + w + 'x' + w + '.png';
            //我想用当前秒是可以解决重名的问题了 不行你就换成毫秒
            savaFile(imgdata, filename);
          }
        }).catch(function (error) {
          console.log(error);
          vis.$message({
            message: error,
            type: 'error'
          });
        });
      }
    },

    onCopy: function onCopy() {
      //console.log('copy')
      this.$message({
        message: '链接复制成功',
        type: 'success'
      });
    },
    onError: function onError(e) {
      alert('Failed to copy texts');
    }
  }
});

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_card__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_card__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      subsiteData: {},
      subsiteKey: ['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount']
    };
  },

  components: {
    card: __WEBPACK_IMPORTED_MODULE_1_components_card___default.a
  },
  computed: {},
  mounted: function mounted() {
    this.subsiteSearch();
  },

  methods: {
    subsiteSearch: function subsiteSearch() {
      var vis = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api__["N" /* subsiteSaleInfo */])(arguments[0]).then(function (res) {
        if (res.ret == 0) {
          vis.subsiteData = res.data;
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activeName: 'first',
      loading: false,
      subSiteId: '',
      subSiteName: '',
      pageSize: 20,
      listData: {
        list: [],
        curPage: 1,
        totalRecords: 0
      },
      getFormatTime: __WEBPACK_IMPORTED_MODULE_3_utils__["c" /* getFormatTime */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['HOST', 'PROTOCOL', 'promotorType', 'accountState'])),
  created: function created() {
    var _this = this;

    this.subsiteListSearch();
    this.downloadQr();
    this.$nextTick(function () {
      return _this.addTips();
    });
  },

  methods: {
    handleSizeChange: function handleSizeChange() {
      this.pageSize = arguments[0];
      this.subsiteListSearch(1);
    },
    handleCurrentChange: function handleCurrentChange() {
      this.listData.curPage = arguments[0];
      this.subsiteListSearch(1);
    },
    subsiteListSearch: function subsiteListSearch(bringPag) {
      var vis = this;
      var temp = {
        "subSiteId": vis.subSiteId, //子站编号  optional 与 子站名称 二选一，同时传以编号为准
        "subSiteName": vis.subSiteName //子站名称  optional 与 子站编号 二选一，同时传将被忽略
      };
      if (!/^[0-9]*[1-9][0-9]*$/.test(vis.subSiteId) && vis.subSiteId) {
        vis.$message({
          type: 'warning',
          message: '子站编号只能为正整数，请重新输入'
        });
        return;
      }
      if (bringPag) {
        temp['curPage'] = vis.listData.curPage;
        temp['pageSize'] = vis.pageSize;
      }
      vis.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["w" /* subsiteList */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils__["b" /* deleteEmptyObj */])(temp)).then(function (res) {
        vis.loading = false;
        if (res.ret == 0) {
          vis.listData = res.data;
        }
      }).catch(function () {});
    },
    changeName: function changeName(subSiteId, index) {
      var _this2 = this;

      var vis = this;
      this.$prompt('请输入子站名字', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (_ref) {
        var value = _ref.value;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_api__["I" /* changeSubsiteName */])({ subSiteId: subSiteId, subSiteName: value }).then(function (res) {
          if (res.ret == 0) {
            _this2.$message({
              type: 'success',
              message: '修改成功'
            });
            vis.listData.list[index].subSiteName = value;
          }
        }).catch(function () {});
      }).catch(function () {});
    },
    drawBeauty: function drawBeauty(beauty) {
      var mycv = document.getElementsByClassName("canvasQr");
      for (var i = 0, len = mycv.length; i < len; i++) {
        var child = mycv[i];
        var width = child.width;
        var myctx = child.getContext("2d");
        myctx.drawImage(beauty, 0, 0, width, width);
      }
    },
    GetUrlRelativePath: function GetUrlRelativePath(url) {
      var arrUrl = url.split("//");
      var start = arrUrl[1].indexOf("/");
      var relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符
      if (relUrl.indexOf("?") != -1) {
        relUrl = relUrl.split("?")[0];
      }
      return relUrl;
    },
    downloadQr: function downloadQr(qrUrl, subName) {
      var vis = this;
      if (qrUrl) {
        new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var beauty = new Image();
          beauty.setAttribute('crossOrigin', 'anonymous');
          var relativePath = void 0;
          try {
            relativePath = vis.GetUrlRelativePath(qrUrl);
          } catch (err) {
            reject('二维码地址有误');
          }

          console.log(relativePath);
          beauty.src = vis.PROTOCOL + vis.HOST + '/qrcode' + relativePath;
          if (beauty.complete) {
            vis.drawBeauty(beauty);
            resolve();
          } else {
            beauty.onload = function () {
              vis.drawBeauty(beauty);
              resolve();
            };
            beauty.onerror = function (error) {
              console.log(error);
              reject('图片加载失败，请重试');
            };
          }
        }).then(function (value) {
          var type = 'png';
          var fixtype = function fixtype(type) {
            type = type.toLocaleLowerCase().replace(/jpg/i, 'jpeg');
            var r = type.match(/png|jpeg|bmp|gif/)[0];
            return 'image/' + r;
          };
          var savaFile = function savaFile(data, filename) {
            var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
            save_link.href = data;
            save_link.download = filename;
            var event = document.createEvent('MouseEvents');
            event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            save_link.dispatchEvent(event);
          };

          var d = document.getElementsByClassName("canvasQr");
          for (var i = 0, len = d.length; i < len; i++) {
            var child = d[i];
            var imgdata = child.toDataURL(type);
            imgdata = imgdata.replace(fixtype(type), 'image/octet-stream');
            var w = child.width;
            var filename = '\u3010' + subName + '\u3011\u4E8C\u7EF4\u7801 - ' + w + 'x' + w + '.png';
            //我想用当前秒是可以解决重名的问题了 不行你就换成毫秒
            savaFile(imgdata, filename);
          }
        }).catch(function (error) {
          console.log(error);
          vis.$message({
            message: error,
            type: 'error'
          });
        });
      }
    },

    onCopy: function onCopy() {
      //console.log('copy')
      this.$message({
        message: '链接复制成功',
        type: 'success'
      });
    },
    addTips: function addTips() {
      var oTarget = document.querySelector('.cell.codeTip');
      // tipIcon
      var oHelp = document.createElement('div');
      oHelp.innerHTML = '?';
      oHelp.style.cssText = 'position:absolute;top:50%;right:14px;transform:translateY(-50%);display:flex;justify-content:center;align-items:center;font-size:12px;color:#fff;width:15px;height:15px;border-radius:50%;background-color:#1f2d3d;cursor:pointer';
      oTarget.appendChild(oHelp);

      var oTip = document.querySelector('.oTip');
      var hoverFn = function hoverFn(e) {
        var clientX = e.clientX,
            clientY = e.clientY;

        oTip.style.display = 'block';
        oTip.style.top = clientY - 130 + 'px';
        oTip.style.left = clientX - 135 + 'px';
      };
      var outFn = function outFn() {
        oTip.style.display = 'none';
        oTip.style.top = 0;
        oTip.style.left = 0;
      };
      oHelp.onmouseover = hoverFn;
      oHelp.onmousemove = hoverFn;
      oHelp.onmouseout = outFn;
    },

    onError: function onError(e) {
      alert('Failed to copy texts');
    }
  }
});

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sortablejs__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_cookie__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subSet',
  data: function data() {
    return {
      componentsChoose: [{
        txt: "轮播图片",
        value: 1,
        key: 'carouseOn' //此key是给iframe发消息用
      }, {
        txt: "分类导航",
        value: 1,
        key: 'tabOn'
      }, {
        txt: "专栏橱窗",
        value: 1,
        key: 'categoryListOn'
      }],
      submitLoading: false,
      addContentSearchLoading: false,
      addPicLoading: false,
      onlinePageUrl: "",
      addContentForm: {
        "searchType": 1, //搜索内容的类型 1-声音， 2-专辑
        "searchKeyword": "", //搜索关键字
        "curPage": 1, //页号
        "pageSize": 10 //每页大小
      },
      //iframe is load
      homePreviewWindowBool: false,
      currPreviewWindowBool: false,
      addContentVisible: false,
      carouselContentIndex: 0, //添加多图时候
      radioValue: '',
      fixed: true,
      step: 1,
      activeName: 'first',
      options: [],
      value: this.$route.query.sid || '', //子站id
      subSiteName: '', //子站名称
      //轮播图片数据
      carousels: [],
      urlAddress: [{
        value: 1,
        label: '声音'
      }, {
        value: 2,
        label: '专辑'
      }, {
        value: 3,
        label: '自定义链接'
      }],
      classifySelect: [],
      //分类设置数据
      categorys: [],
      //添加内容的搜索数据
      contentResult: {},
      // 专栏置顶专辑
      categoryAlbumVisible: false,
      categoryAlbumInfo: {},
      curCategoryId: '',
      curSubSiteCategoryId: '',
      curSubSiteCategoryName: '',
      userAlbumList: [],
      userAlbumIdList: [],
      searchAlbumList: [],
      initAlbumList: [],
      searching: false,
      cateChanging: '',
      cateChangeEnd: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['uid', 'FILE_UPLOAD_PATH', 'SUB_SITE_HOST', 'SUB_PREVIEW_ID', 'FILE_UPLOAD_TOEKN', 'PROTOCOL'])),
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.removeMessageEvent();
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.removeMessageEvent();
    next();
  },
  created: function created() {
    var vis = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["z" /* subsiteSelectList */])().then(function (res) {
      if (parseInt(res.ret) === 0) {
        var data = res.data;
        vis.options = data || [];
        var query = vis.$route.query;
        var sid = query.sid;
        if (+sid && +sid > 0) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["A" /* subsiteConf */])({ subSiteId: sid }).then(function (res) {
            if (parseInt(res.ret) === 0) {
              var _data = res.data;
              vis.value = _data.subSiteId;
              vis.subSiteName = _data.subSiteName;
              vis.componentsChoose[0].value = _data.isCarouselOpen;
              vis.componentsChoose[1].value = _data.isTabOpen;
              vis.componentsChoose[2].value = _data.isCategoryListOpen;
              vis.carousels = _data.carousels;
              ////
              _data.categorys.forEach(function (item) {
                vis.getUserAlbumList({ subSiteId: vis.value, subSiteCategoryId: item.id }).then(function (res) {
                  if (res.ret === 0) {
                    var tmpIds = [],
                        tmps = [];
                    for (var i = 0; i < res.data.list.length; i++) {
                      tmpIds[i] = res.data.list[i].contentId;
                      tmps[i] = res.data.list[i];
                    }
                    item['albumIds'] = tmpIds;
                    item['albums'] = tmps;
                    vis.categoryAlbumInfo['cateData_' + item.subSiteDisplayName] = {};
                    vis.categoryAlbumInfo['cateData_' + item.subSiteDisplayName]['albums'] = tmps;
                    vis.categoryAlbumInfo['cateData_' + item.subSiteDisplayName]['albumIds'] = tmpIds;
                  }
                });
                delete item.contentList;
              });
              vis.categorys = _data.categorys;
            }
          }).catch(function () {});
        } else if (parseInt(sid) === -1) {
          vis.options.push({
            "subSiteId": -1, "subSiteName": '\u5B50\u7AD9' + (vis.options.length + 1), "subSiteUrl": null, "subSiteQRCode": null
          });
          vis.value = -1;
        }
      }
    }).catch(function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["B" /* partnerCategoryList */])().then(function (res) {
      if (parseInt(res.ret) === 0) {
        vis.classifySelect = res.data;
      }
    }).catch(function () {});
    vis.homePreviewReadyEvent = function (event) {
      // console.log(event);
      vis.homePreviewWindowBool = true;
    };
    window.addEventListener('message', vis.homePreviewReadyEvent, false);
  },
  mounted: function mounted() {},

  methods: {
    submitFile: function submitFile() {
      var vis = this;
      var file = document.getElementsByClassName('file-upload')[0].files[0];
      var temp = {
        fileSize: file.size,
        token: encodeURIComponent(__WEBPACK_IMPORTED_MODULE_8_js_cookie___default.a.get(vis.FILE_UPLOAD_TOEKN)),
        // token: encodeURIComponent(Cookies.get(vis.FILE_UPLOAD_TOEKN)),
        rememberMe: 'y'
      };
      var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils__["d" /* originAddParam */])(vis.FILE_UPLOAD_PATH, temp);
      var formData = new FormData();
      formData.append('file', file, 'file.png');
      vis.addPicLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["C" /* fileUpload */])(url, formData).then(function (res) {
        vis.addPicLoading = false;
        if (parseInt(res.ret) === 0) {
          var img_url = res.data[0].url;
          vis.carousels.push({
            imgUrl: img_url,
            contentType: '',
            contentId: 0,
            contentVoiceName: '',
            contentColumnName: '',
            contentUrl: ''
          });
        }
      }).catch(function () {});
    },
    chooseFile: function chooseFile() {
      var vis = this;
      if (vis.carousels.length < 5) {
        var eleFile = document.getElementsByClassName('file-upload')[0];
        eleFile.click();
      } else {
        vis.$message({
          message: '最多添加5张广告图片',
          type: 'warning'
        });
      }
    },
    changeStep: function changeStep(number) {
      var vis = this;
      //操作是否符合规范验证
      if (number === 1 && vis.step === 1) {
        var closeCount = 0;
        vis.componentsChoose.forEach(function (item) {
          !item['value'] && closeCount++;
        });
        if (closeCount === 3) {
          vis.$message({
            type: 'warning',
            message: '至少开启一个组件！'
          });
          return;
        }
      } else if (number === 1 && vis.step === 2) {
        //第二步空值校验
        var componentsChoose = vis.componentsChoose;
        var carousels = vis.carousels;
        var categorys = vis.categorys;
        var isHalt = false;
        for (var i = 0, len = componentsChoose.length; i < len; i++) {
          if (isHalt) {
            break;
          }
          var item = componentsChoose[i];
          if (item['key'] === 'carouseOn' && item.value === 1) {
            if (!carousels.length) {
              vis.$message({
                message: '轮播图片不能为空',
                type: 'warning'
              });
              isHalt = true;
              break;
            }
            for (var _i = 0, _len = carousels.length; _i < _len; _i++) {
              var _item = carousels[_i];

              if (!_item.contentType || (parseInt(_item.contentType) === 1 || parseInt(_item.contentType) === 2) && !_item.contentId || parseInt(_item.contentType) === 3 && !_item.contentUrl) {
                vis.$message({
                  message: '轮播图片的链接地址不能为空',
                  type: 'warning'
                });
                isHalt = true;
                break;
              }
            }
          } else if (item['key'] === 'categoryListOn' && item.value === 1) {
            if (!categorys.length) {
              vis.$message({
                message: '专栏不能为空',
                type: 'warning'
              });
              isHalt = true;
              break;
            }
            for (var _i2 = 0, _len2 = categorys.length; _i2 < _len2; _i2++) {
              var _item2 = categorys[_i2];
              if (!_item2.categoryId) {
                vis.$message({
                  message: '专栏选项不能为空',
                  type: 'warning'
                });
                isHalt = true;
                break;
              } else if (!_item2.subSiteDisplayName) {
                vis.$message({
                  message: '专栏显示名称不能为空',
                  type: 'warning'
                });
                isHalt = true;
                break;
              } else if (!_item2.albumIds.length && !_item2.contentCount) {
                vis.$message({
                  message: _item2.subSiteDisplayName + '\u4E13\u680F\u672A\u8BBE\u7F6E\u9996\u9875\u663E\u793A\u4E13\u8F91\uFF0C\u8BF7\u8BBE\u7F6E\u540E\u518D\u70B9\u51FB\u4E0B\u4E00\u6B65\u3002',
                  type: 'warning'
                });
                isHalt = true;
                break;
              }
            }
            if (vis.checkSameName()) isHalt = true;
          }
        }
        if (isHalt) {
          return;
        }
      }

      // 先让iframe加载，v-if 是 没有这个节点
      // console.log('change-step');
      vis.removeMessageEvent();
      this.step = this.step + number;
      if (number === -1 && vis.step === 1) {
        window.addEventListener('message', vis.homePreviewReadyEvent, false);
      } else if (parseInt(number) === 1 && parseInt(vis.step) === 3) {
        var temp = {
          tabs: [{ name: '畅销' }, { name: '新品' }, { name: '分类' }, { name: '已购' }],
          promotorId: vis.uid,
          name: vis.subSiteName,
          id: vis.value
        };
        var keyArr = ['carouseOn', 'tabOn', 'categoryListOn'];
        vis.componentsChoose.forEach(function (item, index) {
          temp[keyArr[index]] = item.value;
        });

        var carouselsTemp = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(vis.carousels));
        var categorysTemp = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(vis.categorys));
        carouselsTemp = carouselsTemp.map(function (item, index) {
          item['orderNum'] = index + 1;
          for (var _i3 in item) {
            if (_i3 === 'contentColumnName' || _i3 === 'contentVoiceName') {
              delete item[_i3];
            } else if (_i3 === 'contentUrl') {
              item['linkUrl'] = item[_i3];
              delete item[_i3];
            } else if (_i3 === 'imgUrl') {
              item['coverUrl'] = item[_i3];
              item['coverUrlLarger'] = item[_i3];
              item['coverUrlMiddle'] = item[_i3];
              item['coverUrlSmall'] = item[_i3];
            }
          }
          return item;
        });
        categorysTemp.map(function (item, index) {
          item['orderNum'] = index + 1;
          var categoryId = item['categoryId'];
          var classifySelect = vis.classifySelect;
          for (var _i4 = 0, _len3 = classifySelect.length; _i4 < _len3; _i4++) {
            var tp = classifySelect[_i4];
            if (tp['categoryId'] === categoryId) {
              item['name'] = tp['category'];
              break;
            }
          }

          var itemTemp = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item));
          for (var _i5 in itemTemp) {
            if (_i5 === 'contentCount') {
              item['displayQuantiny'] = itemTemp[_i5];
              delete item[_i5];
            } else if (_i5 === 'albumIds') {
              item['displayAlbumIds'] = itemTemp[_i5];
              delete item[_i5];
            } else if (_i5 === 'subSiteDisplayName') {
              item['displayName'] = itemTemp[_i5];
              delete item[_i5];
            } else if (_i5 === 'categoryId') {
              item['id'] = itemTemp[_i5];
              delete item[_i5];
            } else if (_i5 === 'category') {
              delete item[_i5];
            }
          }
          return item;
        });
        temp['carouses'] = carouselsTemp;
        temp['categories'] = categorysTemp;

        vis.currPreviewSendEvent = function (event) {
          if (event.origin !== '' + vis.PROTOCOL + vis.SUB_SITE_HOST) return;
          vis.currPreviewWindowBool = true;
          var currPreviewWindow = document.getElementsByClassName('currPreview')[0].contentWindow;
          currPreviewWindow.postMessage(temp, event.origin);
        };
        if (vis.currPreviewWindowBool) {
          var currPreviewWindow = document.getElementsByClassName('currPreview')[0].contentWindow;
          currPreviewWindow.postMessage(temp, '' + vis.PROTOCOL + vis.SUB_SITE_HOST);
        } else {
          //listener
          window.addEventListener('message', vis.currPreviewSendEvent, false);
        }
      }
    },
    carChangePos: function carChangePos(data, index, num) {
      var vis = this;
      if (num) {
        vis.cateChanging = 'move';
        vis.cateChangeEnd = 2;
        data.splice.apply(data, [index, 1].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.splice(index + num, 1, data[index]))));
      } else {
        //删除
        vis.cateChanging = 'del';
        vis.cateChangeEnd = vis.categorys.length - index - 1;
        data.splice(index, 1);
      }
    },
    subSiteChange: function subSiteChange() {
      var curOption = arguments[0];
      this.$router.push({ name: 'substationSet', query: { sid: curOption } });
    },
    inputAddress: function inputAddress(index) {
      var vis = this;
      vis.$prompt('请输入链接地址', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (_ref) {
        var value = _ref.value;

        vis.carousels[index].contentUrl = value;
        vis.clearContent();
      }).catch(function () {
        vis.clearContent();
      });
    },
    clearContent: function clearContent() {
      this.contentResult = {};
    },
    addContent: function addContent() {
      var vis = this;
      if (vis.addContentVisible) {
        vis.addContentSearchLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["D" /* addContentSub */])(vis.addContentForm).then(function (res) {
          vis.addContentSearchLoading = false;
          if (parseInt(res.ret) === 0) {
            vis.contentResult = res.data;
          }
        }).catch(function () {});
      }
    },
    changeContentType: function changeContentType() {
      this.addContentForm.searchType = arguments[0];
    },
    handleSizeChange: function handleSizeChange() {
      this.addContentForm.pageSize = arguments[0];
      this.addContent();
    },
    handleCurrentChange: function handleCurrentChange() {
      this.addContentForm.curPage = arguments[0];
      this.addContent();
    },
    chooseContent: function chooseContent() {
      var vis = this;
      vis.addContentVisible = false;
      var is_checked = document.querySelector('.show_result .is-checked');
      vis.carousels[vis.carouselContentIndex].contentId = is_checked.querySelector('input').value;
      var key = parseInt(vis.addContentForm.searchType) === 1 ? 'contentVoiceName' : 'contentColumnName';
      vis.carousels[vis.carouselContentIndex][key] = is_checked.parentNode.querySelector('.column-name').innerHTML;
      //vis.clearContent()
    },
    addClassifyData: function addClassifyData() {
      var vis = this;
      if (vis.categorys.length < 10) {
        var len = vis.categorys.length + 1;
        vis.categorys.push({
          "albumIds": [],
          "albums": [],
          "category": "", //分类名(付费精品分类下的标签/热词)，比如商业、新知等
          "categoryId": "", //喜马拉雅分类的ID
          "subSiteDisplayName": "", //子站上显示的分类名称
          "contentCount": "", //该分类下显示的条目数量
          "serialNumber": len
        });
      } else {
        vis.$message({
          type: 'warning',
          message: '最多添加10个专栏'
        });
      }
    },
    submit: function submit() {
      var _this = this;

      var vis = this;

      var temp = {
        subSiteId: vis.value,
        subSiteName: vis.subSiteName
      };
      var keyArr = ['isCarouselOpen', 'isTabOpen', 'isCategoryListOpen'];
      vis.componentsChoose.forEach(function (item, index) {
        temp[keyArr[index]] = item.value;
      });
      var carouselsTemp = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(vis.carousels));
      var categorysTemp = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(vis.categorys));
      carouselsTemp = carouselsTemp.map(function (item, index) {
        item['serialNumber'] = index + 1;
        for (var i in item) {
          if (i === 'contentColumnName' || i === 'contentVoiceName') {
            delete item[i];
          }
        }
        return item;
      });
      categorysTemp.map(function (item, index) {
        item['serialNumber'] = index + 1;
        delete item.id;
        delete item.albums;
        var categoryId = item['categoryId'];
        var classifySelect = vis.classifySelect;

        for (var i = 0, len = classifySelect.length; i < len; i++) {
          var tp = classifySelect[i];
          if (tp['categoryId'] === categoryId) {
            item['category'] = tp['category'];
            return false;
          }
        }
        return item;
      });
      temp['carousels'] = carouselsTemp;
      temp['categorys'] = categorysTemp;

      //category 为空的
      //去掉 contentColumnName contentVoiceName
      //两者都加上serialNumber = index+1  本来有的就修改
      vis.submitLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["E" /* createUpdateSubsite */])(temp).then(function (res) {
        vis.submitLoading = false;
        if (parseInt(res.ret) === 0) {
          _this.$message({
            type: 'success',
            message: '发布成功'
          });
          vis.$router.push({ name: "SubManager" });
        }
      }).catch(function () {
        vis.submitLoading = false;
      });
    },
    quit: function quit() {
      var vis = this;
      this.$confirm('退出设置，编辑的内容将不保存, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        vis.$router.push({ name: 'substationSet' });
      }).catch(function () {});
    },
    homeSendMessage: function homeSendMessage(key, value) {
      var vis = this;
      if (vis.homePreviewWindowBool) {
        var temp = {};
        if (key) {
          temp[key] = value;
        } else {
          vis.componentsChoose.forEach(function (item) {
            temp[item.key] = item.value;
          });
        }
        var homePreviewWindow = document.getElementsByClassName('homePreview')[0].contentWindow;
        console.log(temp);
        homePreviewWindow.postMessage(temp, "*");
      } else {
        console.log('homeBool:false');
      }
    },

    //
    removeMessageEvent: function removeMessageEvent() {
      // console.log('removeEvent');
      var vis = this;
      vis.homePreviewWindowBool = false;
      vis.currPreviewWindowBool = false;
      window.removeEventListener('message', vis.homePreviewReadyEvent, false);
      //window.removeEventListener('message', vis.homePreviewEvent, false);
      window.removeEventListener('message', vis.currPreviewSendEvent, false);
    },
    getUserAlbumList: function getUserAlbumList(params) {
      var vis = this;
      var subSiteCategoryId = params.subSiteCategoryId,
          subSiteCategoryName = params.subSiteCategoryName,
          subSiteId = params.subSiteId;

      if (!subSiteCategoryName) {
        delete params.subSiteCategoryName;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["F" /* userAlbumStick */])(params);
      } else if (vis.categoryAlbumInfo['cateData_' + subSiteCategoryName]) {
        return {
          data: {
            list: vis.categoryAlbumInfo['cateData_' + subSiteCategoryName].albums
          }
        };
      } else {
        return {
          data: {
            list: []
          }
        };
      }
    },
    switchCategory: function switchCategory(id, name) {
      var vis = this;
      var len = vis.categorys.length;
      if (vis.cateChanging === 'move' || vis.cateChanging === 'del') {
        if (vis.cateChangeEnd === 1) vis.cateChanging = '';
        vis.cateChangeEnd--;
      } else if (name) {
        vis.categorys.forEach(function (item) {
          if (item.subSiteDisplayName === name) {
            item.albums = [];
            item.albumIds = [];
          }
        });
        vis.categoryAlbumInfo['cateData_' + name].albums = [];
        vis.categoryAlbumInfo['cateData_' + name].albumIds = [];
      }
    },
    upUserAlbumList: function upUserAlbumList() {
      var _arguments = arguments;

      var vis = this;
      var curLen = arguments[0].length;
      if (curLen > 6) {
        // prevent
        vis.userAlbumIdList = vis.userAlbumIdList.filter(function (item) {
          var notExist = _arguments[2].indexOf(item) === -1;
          return notExist;
        });
        vis.$message({
          message: '最多设置6个首页专栏显示专辑，请删除不需要的专辑。',
          type: 'warning'
        });
      } else {
        vis.userAlbumList = vis.searchAlbumList.filter(function (item) {
          var isExist = _arguments[0].indexOf(item.contentId) !== -1;
          if (isExist) {
            return item;
          } else {
            return false;
          }
        });
        vis.$nextTick(function () {
          return vis.delDrag();
        });
      }
    },
    delDrag: function delDrag() {
      var oRmDrags = document.querySelectorAll('.el-transfer-panel:first-child .transfer-item-drag');
      for (var i = 0; i < oRmDrags.length; i++) {
        oRmDrags[i].remove();
      }
    },
    albumSearch: function albumSearch(searchKeyword) {
      var vis = this;
      if (!searchKeyword) {
        vis.$message({
          message: '请输入任意名称或id',
          type: 'warning'
        });
        return false;
      }
      vis.searching = true;
      var searchType = 2;
      var params = { searchKeyword: searchKeyword, categoryId: vis.curCategoryId, searchType: searchType };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["G" /* albumSearch */])(params).then(function (res) {
        if (res.ret === 0) {
          vis.searchAlbumList = res.data.list;
          vis.userAlbumList.forEach(function (item) {
            var isExist = false;
            for (var i = 0; i < vis.searchAlbumList.length; i++) {
              isExist = item.contentId === vis.searchAlbumList[i].contentId;
              if (isExist) break;
            }
            !isExist && vis.searchAlbumList.push(item);
          });
          vis.$nextTick(function () {
            // dom style
            var oUserAlbumList = document.querySelectorAll('.el-dialog-album-stick .el-transfer-panel__list');
            oUserAlbumList[1].style.height = '346px';
            var oSearchIcon = document.querySelector('.el-dialog-album-stick .el-transfer-panel__filter .el-input__icon');
            oSearchIcon.classList.remove('el-icon-search');
            oSearchIcon.classList.add('el-icon-circle-close');
            var oClearIcon = document.querySelector('.el-dialog-album-stick .el-transfer-panel__filter .el-icon-circle-close');
            oClearIcon.onclick = function (e) {
              var oTarget = e.target;
              oTarget.nextSibling.value = '';
              oTarget.classList.remove('el-icon-circle-close');
              oTarget.classList.add('el-icon-search');
              oTarget.onclick = function () {
                return vis.albumSearch(oTarget.nextSibling.value);
              };
              // 还原总列表
              vis.searchAlbumList = vis.initAlbumList;
              // 用户选项
              vis.userAlbumList.forEach(function (m) {
                var isExist = vis.searchAlbumList.some(function (n) {
                  return m.contentId == n.contentId;
                });
                !isExist && vis.searchAlbumList.push(m);
              });
              vis.$nextTick(function () {
                return vis.delDrag();
              });
            };
            vis.delDrag();
          });

          vis.searching = false;
        } else {
          vis.searching = false;
          console.log(res.message);
        }
      });
    },
    albumStickReset: function albumStickReset() {
      var vis = this;
      vis.searching = false;
      vis.userAlbumList = [];
      vis.userAlbumIdList = [];
      vis.searchAlbumList = [];
      vis.initAlbumList = [];
    },
    saveCategory: function saveCategory() {
      var vis = this;
      var userAlbumList = vis.userAlbumList,
          userAlbumIdList = vis.userAlbumIdList;

      vis.categoryAlbumInfo['cateData_' + vis.curSubSiteCategoryName] = { albums: userAlbumList, albumIds: userAlbumIdList

        // add albumIds
      };vis.categorys.forEach(function (item) {
        if (item.subSiteDisplayName === vis.curSubSiteCategoryName) {
          var cateAlbumInfo = vis.categoryAlbumInfo['cateData_' + vis.curSubSiteCategoryName];
          item['albumIds'] = cateAlbumInfo && cateAlbumInfo.albumIds || [];
          item['albums'] = cateAlbumInfo && cateAlbumInfo.albums || [];
        }
      });

      vis.$message({
        message: '配置成功',
        type: 'success',
        duration: 1500,
        onClose: function onClose() {
          vis.categoryAlbumVisible = false;
          vis.albumStickReset();
        }
      });
    },
    checkSameName: function checkSameName() {
      var vis = this;
      var hasSame = false;
      for (var i = 0; i < vis.categorys.length; i++) {
        for (var j = 0; j < vis.categorys.length; j++) {
          if (vis.categorys[i].subSiteDisplayName && vis.categorys[j].subSiteDisplayName && vis.categorys[i].subSiteDisplayName === vis.categorys[j].subSiteDisplayName && i !== j) {
            vis.$message({
              message: '请勿输入重复名称',
              type: 'warning'
            });
            hasSame = true;
            break;
          }
        }
      }
      return hasSame;
    },
    specialManage: function specialManage(e) {
      var vis = this;
      var _e$target$dataset = e.target.dataset,
          id = _e$target$dataset.id,
          cateid = _e$target$dataset.cateid,
          name = _e$target$dataset.name,
          order = _e$target$dataset.order;

      if (!cateid) {
        vis.$message({
          message: '请选择专栏类别',
          type: 'warning'
        });
        return false;
      } else if (!name) {
        vis.$message({
          message: '专栏显示名称不能为空',
          type: 'warning'
        });
        return false;
      }
      if (vis.checkSameName()) return false;
      vis.curCategoryId = cateid - 0;
      vis.curSubSiteCategoryId = id - 0;
      vis.curSubSiteCategoryName = name;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([vis.getUserAlbumList({
        subSiteId: vis.value,
        subSiteCategoryId: vis.curSubSiteCategoryId,
        subSiteCategoryName: vis.curSubSiteCategoryName
      }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_api__["H" /* initAlbumList */])({ categoryId: cateid, hotWord: '' })]).then(function (res) {
        vis.userAlbumList = res[0].data.list;
        vis.searchAlbumList = res[1].data.list;
        vis.userAlbumList.forEach(function (m) {
          var isIdExist = vis.userAlbumIdList.some(function (o) {
            return o === m.contentId;
          });
          !isIdExist && vis.userAlbumIdList.push(m.contentId);
          var isExist = vis.searchAlbumList.some(function (n) {
            return m.contentId === n.contentId;
          });
          !isExist && vis.searchAlbumList.push(m);
        });
        // vis.categorys.forEach(item => {
        //   if(item.subSiteDisplayName === vis.curSubSiteCategoryName){
        //     item.albumIds = [...vis.userAlbumIdList];
        //     item.albums = [...vis.userAlbumList];
        //   }
        // })
        // console.log(vis.categorys);
        vis.initAlbumList = vis.searchAlbumList;

        vis.$nextTick(function () {
          var oBody = document.querySelectorAll('.el-transfer-panel__body');
          var oFooter = document.querySelector('.el-transfer-panel:first-child .el-transfer-panel__footer');
          oFooter && oFooter.remove();
          var oFilter = document.querySelectorAll('.el-dialog-album-stick .el-transfer-panel__filter');
          oFilter.length > 1 && oFilter[1].remove();
          var oUserAlbumList = document.querySelectorAll('.el-dialog-album-stick .el-transfer-panel__list');
          oUserAlbumList[1].style.height = '346px';
          // sort
          if (vis.userAlbumIdList.length) {
            for (var i = 0; i < oUserAlbumList[1].children.length; i++) {
              var itemId = oUserAlbumList[1].children[i].lastChild.children[0].dataset.id - 0;
              var newIdx = vis.userAlbumIdList.indexOf(itemId);
              if (newIdx != i) {
                oUserAlbumList[1].insertBefore(oUserAlbumList[1].children[i], oUserAlbumList[1].children[newIdx]);
              }
            }
          }
          // del
          vis.$nextTick(function () {
            return vis.delDrag();
          });

          // search
          var cFilter = document.createElement('div');
          cFilter.className = 'el-transfer-panel__filter el-input el-input--small';
          cFilter.innerHTML = '<i class="el-input__icon el-icon-search"></i><input autocomplete="off" placeholder="请输入搜索内容" size="small" icon="search" type="text" class="el-input__inner">';
          oBody[0].insertBefore(cFilter, oFilter[0]);
          oFilter[0].remove();

          var oIcon = cFilter.firstChild;
          var oInput = cFilter.lastChild;
          oIcon.onclick = function () {
            return vis.albumSearch(oInput.value);
          };
          oInput.onkeyup = function (e) {
            return e.key === 'Enter' && vis.albumSearch(oInput.value);
          };

          // drag
          var oDragBox = document.querySelector('.el-transfer-panel:last-child .el-transfer-panel__list');
          oDragBox && __WEBPACK_IMPORTED_MODULE_6_sortablejs___default.a.create(oDragBox, {
            handle: '.transfer-item-drag',
            animation: 100,
            // Called by any change to the list (add / update / remove)
            onSort: function onSort(e) {
              var target = e.target,
                  oldIndex = e.oldIndex,
                  newIndex = e.newIndex;

              var tmpIdArr = [];
              var tmpArr = [];
              for (var i = 0; i < target.children.length; i++) {
                var _itemId = target.children[i].lastChild.children[0].dataset.id - 0;
                tmpIdArr[i] = _itemId;
                for (var j = 0; j < vis.userAlbumList.length; j++) {
                  if (_itemId === vis.userAlbumList[j].contentId) {
                    tmpArr[i] = vis.userAlbumList[j];
                  }
                }
              }
              vis.userAlbumIdList = tmpIdArr;
              vis.userAlbumList = tmpArr;
            }
          });
        });

        vis.categoryAlbumVisible = true;
      });
    },
    transferRender: function transferRender(h, option) {
      return h(
        'div',
        { 'class': 'transfer-list-item', attrs: { 'data-id': option.contentId }
        },
        [h(
          'a',
          {
            attrs: { href: 'http://www.ximalaya.com/album/' + option.contentId + '/', target: '_blank' }
          },
          [option.contentName]
        ), h(
          'div',
          { 'class': 'transfer-item-drag' },
          [h(
            'i',
            { 'class': 'el-icon-caret-top' },
            []
          ), h(
            'i',
            { 'class': 'el-icon-caret-bottom' },
            []
          )]
        )]
      );
    }
  },
  watch: {
    addContentVisible: function addContentVisible() {
      var vis = this;
      if (vis.addContentVisible) {
        vis.clearContent();
      }
    },
    categorys: {
      handler: function handler(now, old) {
        var vis = this;
        vis.categoryAlbumInfo = {};
        now.forEach(function (item) {
          // console.log(item)
          vis.categoryAlbumInfo['cateData_' + item.subSiteDisplayName] = {};
          vis.categoryAlbumInfo['cateData_' + item.subSiteDisplayName]['albums'] = item.albums;
          vis.categoryAlbumInfo['cateData_' + item.subSiteDisplayName]['albumIds'] = item.albumIds;
        });
      },
      deep: true
    }
  }
});

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addResizeListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeResizeListener; });
/* Modified from https://github.com/sdecima/javascript-detect-element-resize
 * version: 0.5.3
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2013 Sebastián Décima
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */
var isServer = typeof window === 'undefined';

/* istanbul ignore next */
var requestFrame = function () {
  if (isServer) return;
  var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
    return window.setTimeout(fn, 20);
  };
  return function (fn) {
    return raf(fn);
  };
}();

/* istanbul ignore next */
var cancelFrame = function () {
  if (isServer) return;
  var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
  return function (id) {
    return cancel(id);
  };
}();

/* istanbul ignore next */
var resetTrigger = function resetTrigger(element) {
  var trigger = element.__resizeTrigger__;
  var expand = trigger.firstElementChild;
  var contract = trigger.lastElementChild;
  var expandChild = expand.firstElementChild;

  contract.scrollLeft = contract.scrollWidth;
  contract.scrollTop = contract.scrollHeight;
  expandChild.style.width = expand.offsetWidth + 1 + 'px';
  expandChild.style.height = expand.offsetHeight + 1 + 'px';
  expand.scrollLeft = expand.scrollWidth;
  expand.scrollTop = expand.scrollHeight;
};

/* istanbul ignore next */
var checkTriggers = function checkTriggers(element) {
  return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
};

/* istanbul ignore next */
var scrollListener = function scrollListener(event) {
  var _this = this;

  resetTrigger(this);
  if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
  this.__resizeRAF__ = requestFrame(function () {
    if (checkTriggers(_this)) {
      _this.__resizeLast__.width = _this.offsetWidth;
      _this.__resizeLast__.height = _this.offsetHeight;
      _this.__resizeListeners__.forEach(function (fn) {
        fn.call(_this, event);
      });
    }
  });
};

/* Detect CSS Animations support to detect element display/re-attach */
var attachEvent = isServer ? {} : document.attachEvent;
var DOM_PREFIXES = 'Webkit Moz O ms'.split(' ');
var START_EVENTS = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' ');
var RESIZE_ANIMATION_NAME = 'resizeanim';
var animation = false;
var keyFramePrefix = '';
var animationStartEvent = 'animationstart';

/* istanbul ignore next */
if (!attachEvent && !isServer) {
  var testElement = document.createElement('fakeelement');
  if (testElement.style.animationName !== undefined) {
    animation = true;
  }

  if (animation === false) {
    var prefix = '';
    for (var i = 0; i < DOM_PREFIXES.length; i++) {
      if (testElement.style[DOM_PREFIXES[i] + 'AnimationName'] !== undefined) {
        prefix = DOM_PREFIXES[i];
        keyFramePrefix = '-' + prefix.toLowerCase() + '-';
        animationStartEvent = START_EVENTS[i];
        animation = true;
        break;
      }
    }
  }
}

var stylesCreated = false;
/* istanbul ignore next */
var createStyles = function createStyles() {
  if (!stylesCreated && !isServer) {
    var animationKeyframes = '@' + keyFramePrefix + 'keyframes ' + RESIZE_ANIMATION_NAME + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyFramePrefix + 'animation: 1ms ' + RESIZE_ANIMATION_NAME + ';';

    // opacity: 0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
    var css = animationKeyframes + '\n      .resize-triggers { ' + animationStyle + ' visibility: hidden; opacity: 0; }\n      .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1 }\n      .resize-triggers > div { background: #eee; overflow: auto; }\n      .contract-trigger:before { width: 200%; height: 200%; }';

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
    stylesCreated = true;
  }
};

/* istanbul ignore next */
var addResizeListener = function addResizeListener(element, fn) {
  if (isServer) return;
  if (attachEvent) {
    element.attachEvent('onresize', fn);
  } else {
    if (!element.__resizeTrigger__) {
      if (getComputedStyle(element).position === 'static') {
        element.style.position = 'relative';
      }
      createStyles();
      element.__resizeLast__ = {};
      element.__resizeListeners__ = [];

      var resizeTrigger = element.__resizeTrigger__ = document.createElement('div');
      resizeTrigger.className = 'resize-triggers';
      resizeTrigger.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
      element.appendChild(resizeTrigger);

      resetTrigger(element);
      element.addEventListener('scroll', scrollListener, true);

      /* Listen for a css animation to detect element display/re-attach */
      if (animationStartEvent) {
        resizeTrigger.addEventListener(animationStartEvent, function (event) {
          if (event.animationName === RESIZE_ANIMATION_NAME) {
            resetTrigger(element);
          }
        });
      }
    }
    element.__resizeListeners__.push(fn);
  }
};

/* istanbul ignore next */
var removeResizeListener = function removeResizeListener(element, fn) {
  if (attachEvent) {
    element.detachEvent('onresize', fn);
  } else {
    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
    if (!element.__resizeListeners__.length) {
      element.removeEventListener('scroll', scrollListener);
      element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
    }
  }
};

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  uid: function uid(state) {
    return state.user.uid;
  },
  name: function name(state) {
    return state.user.name;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  hasRole: function hasRole(state) {
    return state.user.hasRole;
  },
  promotorType: function promotorType(state) {
    return state.user.promotorType;
  },
  accountState: function accountState(state) {
    return state.user.accountState;
  },
  permission_routers: function permission_routers(state) {
    return state.permission.routers;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  },
  isPromotorDisplay: function isPromotorDisplay(state) {
    return state.user.isPromotorDisplay;
  },

  //测试，线上路径相关
  FILE_UPLOAD_PATH: function FILE_UPLOAD_PATH(state) {
    return state.config.FILE_UPLOAD_PATH;
  },
  FILE_UPLOAD_TOEKN: function FILE_UPLOAD_TOEKN(state) {
    return state.config.FILE_UPLOAD_TOEKN;
  },
  SUB_SITE_HOST: function SUB_SITE_HOST(state) {
    return state.config.SUBSITE_HOST;
  },
  SUB_PREVIEW_ID: function SUB_PREVIEW_ID(state) {
    return state.config.SUB_PREVIEW_ID;
  },
  PROTOCOL: function PROTOCOL(state) {
    return state.config.PROTOCOL;
  },
  HOST: function HOST(state) {
    return state.config.HOST;
  },
  AVATAR_LINK: function AVATAR_LINK(state) {
    return state.config.AVATAR_LINK;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var app = {
  state: {
    theme: 'default',
    livenewsChannels: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('livenewsChannels') || '[]'
  },
  mutations: {},
  actions: {}
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProd = window.location.host === 'partner.ximalaya.com';
var baseHost = !isProd ? '.test' : '';

var config = {
  state: {
    FILE_UPLOAD_PATH: '//upload' + baseHost + '.ximalaya.com/dtres/picture/upload',
    FILE_UPLOAD_TOEKN: isProd ? '1&_token' : '4&_token',
    SUBSITE_HOST: 'subsite' + baseHost + '.ximalaya.com',
    SUB_PREVIEW_ID: isProd ? 1 : 199,
    PROTOCOL: "https:" == document.location.protocol ? "https://" : "http://",
    HOST: 'partner' + (!isProd ? '.test' : '') + '.ximalaya.com',
    AVATAR_LINK: (isProd ? 'www' : 'test') + '.ximalaya.com/zhubo/'
  },
  mutations: {},
  actions: {}
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_router__ = __webpack_require__(135);



function hasPermission(permission, route) {
  if (route.permission) {
    return route.permission.indexOf(permission) > -1 ? true : false;
  } else {
    return true;
  }
}

var permission = {
  state: {
    routers: __WEBPACK_IMPORTED_MODULE_1_src_router__["b" /* constantRouterMap */],
    addRouters: []
  },

  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = __WEBPACK_IMPORTED_MODULE_1_src_router__["b" /* constantRouterMap */].concat(routers);
    }
  },

  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, data) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var promotorType = data.promotorType;
        var accountState = data.accountState;
        // console.log(promotorType, accountState)

        var permission = promotorType * 10 + accountState;
        if (promotorType) {
          var accessedRouters = __WEBPACK_IMPORTED_MODULE_1_src_router__["c" /* asyncRouterMap */].filter(function (v) {
            if (hasPermission(permission, v)) {
              if (v.children && v.children.length > 0) {
                v.children = v.children.filter(function (child) {
                  if (hasPermission(permission, child)) {
                    return child;
                  }
                  return false;
                });
                return v;
              } else {
                return v;
              }
            }
          });
          commit('SET_ROUTERS', accessedRouters);
        }
        resolve();
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permission);

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);




var user = {
  state: {
    name: '',
    uid: '',
    avatar: '',
    promotorType: '',
    accountState: '',
    hasRole: 0,
    isPromotorDisplay: false
  },

  mutations: {
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_PROMOTORTYPE: function SET_PROMOTORTYPE(state, promotorType) {
      state.promotorType = promotorType;
    },
    SET_ISPROMOTORDISPLAY: function SET_ISPROMOTORDISPLAY(state, isPromotorDisplay) {
      state.isPromotorDisplay = isPromotorDisplay;
    },
    SET_ACCOUNTSTATE: function SET_ACCOUNTSTATE(state, accountState) {
      state.accountState = accountState;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_UID: function SET_UID(state, uid) {
      state.uid = uid;
    },
    SET_HASROLE: function SET_HASROLE(state, hasRole) {
      state.hasRole = hasRole;
    },
    LOGIN_SUCCESS: function LOGIN_SUCCESS() {
      //console.log('login success')
    }
  },

  actions: {
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit;

      var username = userInfo.username.trim();
      var password = userInfo.password;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api__["U" /* login */])(username, password).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    Choose: function Choose(_ref2, id) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api__["P" /* chooseAccount */])(id).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 获取用户信息
    GetInfo: function GetInfo(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        /* const data = {
           promotorType:1,
           nickName:'adf',
           id:22,
           avatar:'asd',
           hasRole:0
         }
         resolve({data});*/
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api__["V" /* getInfo */])().then(function (response) {
          var data = response.data;
          commit('SET_ACCOUNTSTATE', data.accountState);
          commit('SET_ISPROMOTORDISPLAY', data.isPromotorDisplay);
          commit('SET_PROMOTORTYPE', data.promotorType);
          commit('SET_NAME', data.nickName);
          commit('SET_UID', data.id);
          commit('SET_AVATAR', data.avatar);
          commit('SET_HASROLE', data.hasRole);
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 登出
    LogOut: function LogOut(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api__["W" /* logout */])().then(function (res) {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

function Carousel(options) {
  this.imagesList = options.imagesList || [];
  this.indexList = options.indexList || [];
  createdStyle();
  return this;
}
Carousel.prototype.show = function () {
  this.ele = createE(this.imagesList, this.indexList);
  return this;
};
Carousel.prototype.close = function () {
  document.removeChild(this.ele);
  return this;
};
function createdStyle() {
  if (window.carouselFlag == true) {
    //避免重复创建style标签
    return;
  }
  var style = document.createElement('style');
  style.type = 'text/css';
  style.flag = 1;
  style.innerHTML = "@keyframes show-carousel { from {opacity: 0;} to {opacity: 1;} }" + ".q-wrapper .index{height: 80px; position: relative; top: 20px;}" + ".q-wrapper .content-wrapper{background-color: #000;}.q-wrapper .list-wrapper {height: 120px; max-width: 980px; overflow: scroll;}.q-wrapper .carousel img { width: 480px; height: 480px; float: left; }" + ".q-wrapper .carousel-wrapper { height: 480px; width: 480px; position: relative; left: calc(50% - 240px); overflow: hidden; }" + ".q-wrapper {animation: show-carousel 500ms; z-index: 1001; position: absolute; left: calc(50% - 490px); top: calc(50% - 300px); width: 980px; background-color: #2F2F2F;}" + ".q-wrapper .mask { background: rgba(0,0,0,.7); position: fixed; left: 0; top: 0; width: 100%; height: 100%; }" + ".q-wrapper .index .active { border-color: #5294FA; opacity: 1; }" + ".q-wrapper .index img{ border:  2px solid #7A7A7A; width: 76px; height: 76px; opacity: .5; margin-right: 20px; float: left; }" + ".q-wrapper .btn-left { position: absolute; top: 240px; left: 78px; } .q-wrapper .btn-left::before { content: ''; display: block; width: 56px; height: 56px; border-radius: 28px; background-color: #666; position: relative; top: -28px; left: -28px; } .btn-left::after { content: ''; display: block; width: 10px; height: 10px; border: 2px solid #FFF; border-right: transparent; border-bottom: transparent; transform: rotate(-45deg); position: relative; top: -63px; left: -5px; }" + ".q-wrapper .btn-right { position: absolute; top: 240px; left: 892px; } .q-wrapper .btn-right::before { content: ''; display: block; width: 56px; height: 56px; border-radius: 28px; background-color: #666; position: relative; top: -28px; left: -28px; } .btn-right::after { content:''; display: block; width: 10px; height: 10px; border: 2px solid #FFF; border-right: transparent; border-bottom: transparent; transform: rotate(135deg); position: relative; top: -63px; left: -9px; } " + ".q-wrapper .btn-close { position: absolute; top: 20px; left: 940px; cursor: pointer;} .q-wrapper .btn-close::before { content: ''; width: 15px; height:15px; display: block; border: 2px solid #CCC; border-right: transparent; border-bottom: transparent; border-top: transparent; transform: rotate(45deg); position: relative; } .q-wrapper .btn-close::after { content:''; width: 15px; height:15px; display: block; border: 2px solid #CCC; border-right: transparent; border-bottom: transparent; " + "border-top: transparent; transform: rotate(-45deg); position: relative; top: -24px; left: 0px; } .q-wrapper .btn-left:hover::before, .q-wrapper .btn-right:hover::before { background-color: #5294FA; } .q-wrapper .btn-close:hover::after, .btn-close:hover::before { border-color: #fff; }";

  document.head.appendChild(style);
  window.carouselFlag = true;
}
function createE(image, index) {
  // mask
  var mask = document.createElement('div');
  mask.setAttribute('class', 'mask');
  // 最外层容器
  var itemWrap = document.createElement('div');
  itemWrap.setAttribute('class', 'q-wrapper');

  itemWrap.appendChild(mask);

  document.body.appendChild(itemWrap);
  // 创建轮播外层容器
  var contentWrapper = document.createElement('div');
  contentWrapper.setAttribute('class', 'content-wrapper');
  itemWrap.appendChild(contentWrapper);

  // 创建轮播轮播容器
  var carouselWrapper = document.createElement('div');
  carouselWrapper.setAttribute('class', 'carousel-wrapper');
  contentWrapper.appendChild(carouselWrapper);

  var carousel = document.createElement('div');
  carousel.setAttribute('class', 'carousel');
  setCss(carousel, {
    height: 480,
    width: 480 * (image.length + 1),
    position: 'relative'
  });
  carouselWrapper.appendChild(carousel);
  //创建轮播图片列表
  for (var i = 0; i < image.length; i++) {
    var newBigImg = document.createElement('img');
    newBigImg.src = image[i];
    newBigImg.setAttribute('class', 'img');
    carousel.appendChild(newBigImg);
  }
  var bigImgs = carousel.querySelectorAll('img');
  var firstBigImg = bigImgs[0].cloneNode(true);
  carousel.appendChild(firstBigImg);

  // 创建轮播index
  var listWrapper = document.createElement('div');
  listWrapper.setAttribute('class', 'list-wrapper');
  itemWrap.appendChild(listWrapper);

  //created index-wapper
  var indexE = document.createElement('div');
  indexE.setAttribute('class', 'index');
  if (index.length <= 9) {
    setCss(indexE, {
      width: 100 * index.length,
      left: 490 - 100 * index.length / 2
    });
  } else {
    setCss(indexE, {
      width: 100 * index.length,
      left: 10
    });
  }
  listWrapper.appendChild(indexE);
  // created index image list
  for (var j = 0; j < index.length; j++) {
    var indexImg = document.createElement('img');
    indexImg.src = index[j];
    indexImg.setAttribute('class', 'img-index');
    indexImg.setAttribute('data-index', j);
    indexE.appendChild(indexImg);
  }
  // created left arrow
  var btnL = document.createElement('span');
  btnL.setAttribute('class', 'btn-left');
  itemWrap.appendChild(btnL);
  // created right arrow
  var btnR = document.createElement('span');
  btnR.setAttribute('class', 'btn-right');
  itemWrap.appendChild(btnR);
  // created close button
  var btnClose = document.createElement('span');
  btnClose.setAttribute('class', 'btn-close');
  itemWrap.appendChild(btnClose);

  var num = 0;
  var indexList = indexE.querySelectorAll('.img-index');
  indexList[0].classList.add('active');

  btnR.onclick = function (e) {
    var e = e || window.event;
    e.stopPropagation();
    num++;
    if (num > bigImgs.length) {
      num = 1;
      carousel.style.left = 0;
    }
    for (var m = 0, len = indexList.length; m < len; m++) {

      indexList[m].classList.remove('active');
      if (m == num) {
        indexList[m].classList.add('active');
      }
      if (num == len) {
        indexList[0].classList.add('active');
      }
    }
    go(carousel, -480 * num);
  };

  btnL.onclick = function (e) {
    var e = e || window.event;
    e.stopPropagation();
    num--;
    if (num < 0) {
      num = bigImgs.length - 1;
      carousel.style.left = -480 * bigImgs.length + 'px';
    }
    for (var m = 0, len = indexList.length; m < len; m++) {

      indexList[m].classList.remove('active');
      if (m === num) {
        indexList[m].classList.add('active');
      }
    }
    go(carousel, -480 * num);
  };

  btnClose.onclick = function () {
    document.body.removeChild(itemWrap);
  };

  indexE.onclick = function (e) {
    var _index = e.target.getAttribute('data-index');
    for (var m = 0, len = indexList.length; m < len; m++) {
      indexList[m].classList.remove('active');
    }
    e.target.classList.add('active');
    num = _index;
    go(carousel, -480 * _index);
  };
  return itemWrap;
};
function go(obj, target) {
  clearInterval(obj.timer);
  var speed = obj.offsetLeft < target ? 30 : -30;
  obj.timer = setInterval(function () {
    var result = obj.offsetLeft - target;
    obj.style.left = obj.offsetLeft + speed + "px";
    if (Math.abs(result) <= 30) {
      clearInterval(obj.timer);
      obj.style.left = target + "px";
    }
  }, 10);
}
function setCss(ele, options) {
  //设置多个css样式
  if (!options instanceof Object) {
    return;
  }
  for (var key in options) {
    if (options.hasOwnProperty(key)) {
      setStyle(ele, key, options[key]);
    }
  }
}
function setStyle(ele, attr, value) {
  //设置单个css样式
  if (attr === 'float') {
    ele['style']['cssFloat'] = value;
    ele['style']['styleFloat'] = value;
    return;
  };
  if (attr === 'opacity') {
    ele['style']['opacity'] = value;
    ele['style']['filter'] = 'alpha(opacity=' + value * 100 + ')';
    return;
  };
  var reg = /^(width|height|top|bottom|left|right|((margin|pading)(Top|Bottom|Left|Right)?))$/;
  if (reg.test(attr)) {
    if (!isNaN(value)) {
      value += 'px';
    }
  }
  ele['style'][attr] = value;
}
// module.exports.Carousel = Carousel;
window.Carousel = Carousel;

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
function getCookie(name) {
  var strcookie = document.cookie; //获取cookie字符串
  var arrcookie = strcookie.split("; "); //分割

  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(135);





// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  //baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
});
// request拦截器
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  //console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// respone拦截器
service.interceptors.response.use(function (response) {
  //相当于给所有请求统一做了错误处理
  //下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
  //如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
  var status = response.status;
  if (status === 200) {
    var url = response.config && response.config.url;
    var data = response.data;
    var ret = data.ret ? data.ret : 0;
    return data;
  } else {
    return response;
  }
}, function (error) {
  var response = error.response;
  console.log(error);
  if (response) {
    var status = response.status;
    var data = response.data;
    var ret = data.ret;
    if (status === 400) {//param error

    } else if (status === 401) {
      if (ret === 1) {
        location.href = "/login";
        return false;
      } else if (ret === 2) {
        data.msg = "您不是城市合伙人或者分销商";
      } else if (ret === 3) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: "Account" });
      } else if (ret === 6) {
        location.href = "/login";
        return false;
      }
    } else if (status === 500) {}

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
      message: data.msg,
      type: 'error'
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });

//这个js 的作用就是简化 三个组件的引用







/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export jqueryConfirm */
/* unused harmony export jqueryAlert */
/* unused harmony export addExtraParam */
/* unused harmony export isUrl */
/* harmony export (immutable) */ __webpack_exports__["d"] = originAddParam;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteEmptyObj;
/* unused harmony export getDashTime */
/* unused harmony export formatTime */
/* unused harmony export getQueryObject */
/* harmony export (immutable) */ __webpack_exports__["c"] = getFormatTime;
/* unused harmony export createUniqueString */
/* unused harmony export getByteLen */
/* unused harmony export cleanArray */
/* unused harmony export param */
/* unused harmony export param2Obj */
/* unused harmony export html2Text */
/* unused harmony export objectMerge */
/* unused harmony export scrollTo */
/* unused harmony export toggleClass */
/* unused harmony export pickerOptions */
/* unused harmony export getTime */
/* unused harmony export zfill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


/**
 * Created by caleb on 17/06/.
 */

//

function jqueryConfirm(others, opts) {
  var selfTitle = others.title || '';
  var selfPlaceholder = others.placeholder || '';
  var submitText = others.submitText || '提交';
  var cancelText = others.cancelText || '取消';
  var submitFun = others.submitFun || function () {};
  var cancelFun = others.cancelFun || function () {};
  var content = others.content || '';

  var opts = $.extend({
    closeIcon: true,
    boxWidth: "25%",
    useBootstrap: false,
    title: '',
    content: content ? content : '<form action="" class="formName">' + '<div class="form-group">' + '<label style="margin-bottom:15px;">' + selfTitle + '</label>' + '<input type="text" placeholder=' + selfPlaceholder + ' class="name form-control" required />' + '</div>' + '</form>',
    buttons: {
      formSubmit: {
        text: submitText,
        btnClass: 'btn-blue',
        action: submitFun
      },
      cancel: {
        text: cancelText,
        action: cancelFun
      }
    },
    onContentReady: function onContentReady() {
      // bind to events
      var jc = this;
      this.$content.find('form').on('submit', function (e) {
        // if the user submits the form by pressing enter in the field.
        e.preventDefault();
        jc.$$formSubmit.trigger('click'); // reference the button and click it
      });
    }
  }, opts);
  $.confirm(opts);
}

function jqueryAlert(others, opts) {
  var selfTitle = others.title || '';
  var selfContent = others.content || '';
  var submitText = others.submitText || '确定';
  var submitFun = others.submitFun || function () {};
  var opts = $.extend({
    closeIcon: true,
    title: selfTitle,
    content: selfContent,
    buttons: {
      formSubmit: {
        text: submitText,
        btnClass: 'btn-blue',
        action: submitFun
      }
    }
  }, opts);
  $.alert(opts);
}

function addExtraParam(url, p) {
  var index = url.indexOf('?'),
      setSearchStr = function setSearchStr(str, p) {
    var refes = str.split("&"),
        item = null,
        sp = {};

    for (var i = 0; i < refes.length; i++) {
      item = refes[i];
      var iArr = item.split("=");
      if (iArr[0]) {
        sp[iArr[0]] = iArr[1];
      }
    };
    return $.param($.extend(sp, p));
  };

  if (index === -1) {
    //var arr = url.split('#');
    //return arr[0] + '?' + $.param(p) + ((arr[1] && arr[1].length > 0) ? '#' + arr[1] : '');
    return url + '?' + $.param(p);
  } else {
    var arr = url.split('?'),
        tem = arr[1];

    if (tem && tem !== '') {
      var arr3 = tem.split('#'),
          search = '';
      if (arr3.length > 1) {
        return arr[0] + '?' + setSearchStr(arr3[0], p) + '#' + arr3[1];
      } else {
        return arr[0] + '?' + setSearchStr(arr3[0], p);
      }
    }
    return arr[0];
  }
  return url;
}

function isUrl() {
  var url = arguments[0];
  var reg = ['/^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#\/%?=~_|!:,.;]+[-A-Za-z0-9+&@#\/%=~_|]/'];
  var isUrl = true;
  for (var i = 0, len = reg.length; i < len; i++) {
    var strRegex = reg[i];
    var re = new RegExp(strRegex);
    isUrl = re.test(url);
    if (!isUrl) {
      return false;
    }
  }

  return isUrl;
}

function originAddParam(url, obj) {
  var result = '';
  for (var i in obj) {
    var value = obj[i];
    result = result + '&' + i + '=' + value;
  }
  return url + '?' + result.substr(1);
}

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(time)) == 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

function deleteEmptyObj(obj) {
  for (var i in obj) {
    if (!obj[i]) {
      delete obj[i];
    }
  }
  return obj;
}

function getDashTime(date) {
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    a: date.getDate()
  };
  return formatObj.y + '-' + formatObj.m + '-' + formatObj.a;
}

function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

// 格式化时间
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

function getFormatTime(time) {
  var t = new Date(time);
  var y = t.getFullYear();
  var M = zfill(t.getMonth() + 1, 2);
  var d = t.getDate();
  var h = t.getHours();
  var m = t.getMinutes();
  var s = t.getSeconds();
  return y + '/' + M + '/' + (d >= 10 ? d : '0' + d) + ' ' + (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s);
}

function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
function getByteLen(val) {
  var len = 0;
  for (var i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return Math.floor(len);
}

function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

function param(json) {
  if (!json) return '';
  return cleanArray(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

function param2Obj(url) {
  var search = url.split('?')[1];
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

function objectMerge(target, source) {
  /* Merges two  objects,
   giving the last one precedence */

  if ((typeof target === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(target)) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  for (var property in source) {
    if (source.hasOwnProperty(property)) {
      var sourceProperty = source[property];
      if ((typeof sourceProperty === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(sourceProperty)) === 'object') {
        target[property] = objectMerge(target[property], sourceProperty);
        continue;
      }
      target[property] = sourceProperty;
    }
  }
  return target;
}

function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  setTimeout(function () {
    //console.log(new Date())
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
}

function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

var pickerOptions = [{
  text: '今天',
  onClick: function onClick(picker) {
    var end = new Date();
    var start = new Date(new Date().toDateString());
    end.setTime(start.getTime());
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一周',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近三个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
    picker.$emit('pick', [start, end]);
  }
}];

function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * zfill 用0向前填充，并返回指定位数的数字
 * @param {Number} num 原数字
 * @param {Number} length 返回数字位数
 * return {Number} 如 zfill(123, 6) 返回 000123
 */
function zfill(num, length) {
  return (Array(length).join('0') + num).slice(-length);
}

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 837:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 851:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 853:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 854:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 857:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 281,
	"./af.js": 281,
	"./ar": 288,
	"./ar-dz": 282,
	"./ar-dz.js": 282,
	"./ar-kw": 283,
	"./ar-kw.js": 283,
	"./ar-ly": 284,
	"./ar-ly.js": 284,
	"./ar-ma": 285,
	"./ar-ma.js": 285,
	"./ar-sa": 286,
	"./ar-sa.js": 286,
	"./ar-tn": 287,
	"./ar-tn.js": 287,
	"./ar.js": 288,
	"./az": 289,
	"./az.js": 289,
	"./be": 290,
	"./be.js": 290,
	"./bg": 291,
	"./bg.js": 291,
	"./bm": 292,
	"./bm.js": 292,
	"./bn": 293,
	"./bn.js": 293,
	"./bo": 294,
	"./bo.js": 294,
	"./br": 295,
	"./br.js": 295,
	"./bs": 296,
	"./bs.js": 296,
	"./ca": 297,
	"./ca.js": 297,
	"./cs": 298,
	"./cs.js": 298,
	"./cv": 299,
	"./cv.js": 299,
	"./cy": 300,
	"./cy.js": 300,
	"./da": 301,
	"./da.js": 301,
	"./de": 304,
	"./de-at": 302,
	"./de-at.js": 302,
	"./de-ch": 303,
	"./de-ch.js": 303,
	"./de.js": 304,
	"./dv": 305,
	"./dv.js": 305,
	"./el": 306,
	"./el.js": 306,
	"./en-au": 307,
	"./en-au.js": 307,
	"./en-ca": 308,
	"./en-ca.js": 308,
	"./en-gb": 309,
	"./en-gb.js": 309,
	"./en-ie": 310,
	"./en-ie.js": 310,
	"./en-il": 311,
	"./en-il.js": 311,
	"./en-nz": 312,
	"./en-nz.js": 312,
	"./eo": 313,
	"./eo.js": 313,
	"./es": 316,
	"./es-do": 314,
	"./es-do.js": 314,
	"./es-us": 315,
	"./es-us.js": 315,
	"./es.js": 316,
	"./et": 317,
	"./et.js": 317,
	"./eu": 318,
	"./eu.js": 318,
	"./fa": 319,
	"./fa.js": 319,
	"./fi": 320,
	"./fi.js": 320,
	"./fo": 321,
	"./fo.js": 321,
	"./fr": 324,
	"./fr-ca": 322,
	"./fr-ca.js": 322,
	"./fr-ch": 323,
	"./fr-ch.js": 323,
	"./fr.js": 324,
	"./fy": 325,
	"./fy.js": 325,
	"./gd": 326,
	"./gd.js": 326,
	"./gl": 327,
	"./gl.js": 327,
	"./gom-latn": 328,
	"./gom-latn.js": 328,
	"./gu": 329,
	"./gu.js": 329,
	"./he": 330,
	"./he.js": 330,
	"./hi": 331,
	"./hi.js": 331,
	"./hr": 332,
	"./hr.js": 332,
	"./hu": 333,
	"./hu.js": 333,
	"./hy-am": 334,
	"./hy-am.js": 334,
	"./id": 335,
	"./id.js": 335,
	"./is": 336,
	"./is.js": 336,
	"./it": 337,
	"./it.js": 337,
	"./ja": 338,
	"./ja.js": 338,
	"./jv": 339,
	"./jv.js": 339,
	"./ka": 340,
	"./ka.js": 340,
	"./kk": 341,
	"./kk.js": 341,
	"./km": 342,
	"./km.js": 342,
	"./kn": 343,
	"./kn.js": 343,
	"./ko": 344,
	"./ko.js": 344,
	"./ky": 345,
	"./ky.js": 345,
	"./lb": 346,
	"./lb.js": 346,
	"./lo": 347,
	"./lo.js": 347,
	"./lt": 348,
	"./lt.js": 348,
	"./lv": 349,
	"./lv.js": 349,
	"./me": 350,
	"./me.js": 350,
	"./mi": 351,
	"./mi.js": 351,
	"./mk": 352,
	"./mk.js": 352,
	"./ml": 353,
	"./ml.js": 353,
	"./mr": 354,
	"./mr.js": 354,
	"./ms": 356,
	"./ms-my": 355,
	"./ms-my.js": 355,
	"./ms.js": 356,
	"./mt": 357,
	"./mt.js": 357,
	"./my": 358,
	"./my.js": 358,
	"./nb": 359,
	"./nb.js": 359,
	"./ne": 360,
	"./ne.js": 360,
	"./nl": 362,
	"./nl-be": 361,
	"./nl-be.js": 361,
	"./nl.js": 362,
	"./nn": 363,
	"./nn.js": 363,
	"./pa-in": 364,
	"./pa-in.js": 364,
	"./pl": 365,
	"./pl.js": 365,
	"./pt": 367,
	"./pt-br": 366,
	"./pt-br.js": 366,
	"./pt.js": 367,
	"./ro": 368,
	"./ro.js": 368,
	"./ru": 369,
	"./ru.js": 369,
	"./sd": 370,
	"./sd.js": 370,
	"./se": 371,
	"./se.js": 371,
	"./si": 372,
	"./si.js": 372,
	"./sk": 373,
	"./sk.js": 373,
	"./sl": 374,
	"./sl.js": 374,
	"./sq": 375,
	"./sq.js": 375,
	"./sr": 377,
	"./sr-cyrl": 376,
	"./sr-cyrl.js": 376,
	"./sr.js": 377,
	"./ss": 378,
	"./ss.js": 378,
	"./sv": 379,
	"./sv.js": 379,
	"./sw": 380,
	"./sw.js": 380,
	"./ta": 381,
	"./ta.js": 381,
	"./te": 382,
	"./te.js": 382,
	"./tet": 383,
	"./tet.js": 383,
	"./tg": 384,
	"./tg.js": 384,
	"./th": 385,
	"./th.js": 385,
	"./tl-ph": 386,
	"./tl-ph.js": 386,
	"./tlh": 387,
	"./tlh.js": 387,
	"./tr": 388,
	"./tr.js": 388,
	"./tzl": 389,
	"./tzl.js": 389,
	"./tzm": 391,
	"./tzm-latn": 390,
	"./tzm-latn.js": 390,
	"./tzm.js": 391,
	"./ug-cn": 392,
	"./ug-cn.js": 392,
	"./uk": 393,
	"./uk.js": 393,
	"./ur": 394,
	"./ur.js": 394,
	"./uz": 396,
	"./uz-latn": 395,
	"./uz-latn.js": 395,
	"./uz.js": 396,
	"./vi": 397,
	"./vi.js": 397,
	"./x-pseudo": 398,
	"./x-pseudo.js": 398,
	"./yo": 399,
	"./yo.js": 399,
	"./zh-cn": 400,
	"./zh-cn.js": 400,
	"./zh-hk": 401,
	"./zh-hk.js": 401,
	"./zh-tw": 402,
	"./zh-tw.js": 402
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 873;

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/401.089007e.gif";

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.a57b6f3.png";

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(850)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(933),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(864)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(947),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(841)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(924),
  /* scopeId */
  "data-v-0fbdcd8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(857)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(940),
  /* scopeId */
  "data-v-457edcce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(929),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(855)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(938),
  /* scopeId */
  "data-v-3e31c780",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(846)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(928),
  /* scopeId */
  "data-v-21633aea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(835)
__webpack_require__(836)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(919),
  /* scopeId */
  "data-v-074731f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(844)
__webpack_require__(843)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(926),
  /* scopeId */
  "data-v-17e5bffc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(859)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(942),
  /* scopeId */
  "data-v-62cbf0c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(862)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(945),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(860)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(943),
  /* scopeId */
  "data-v-708ba120",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(867)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(950),
  /* scopeId */
  "data-v-df7ee256",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(863)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(946),
  /* scopeId */
  "data-v-764cd629",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(861)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(944),
  /* scopeId */
  "data-v-7212ad47",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return chooseAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return promotorCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return promotorUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return promotorLeaveJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return promotorSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return promotorInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return orderMgmtOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return orderMgmtLock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return orderMgmtChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return orderMgmtSubsite; });
/* unused harmony export orderMgmtExport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return opertionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return subsiteSaleInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return distributorSaleInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return realtimeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return auroraAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return subsiteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return subsiteAlbumList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return subsiteTrackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return subsiteSelectList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return subsiteConf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return createUpdateSubsite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return changeSubsiteName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fileUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return addContentSub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return userAlbumStick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return initAlbumList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return albumSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return partnerCategoryList; });
/* unused harmony export partnerNotice */
/* unused harmony export notifyAll */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notifyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return notifyRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActnotifyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return incrementData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return chartRegionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tableRegionData; });
/* unused harmony export exportTable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getRankCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getRankClassify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getRanking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return searchRanking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return lockDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return lockPromotorDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return authMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return recent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getAccountInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getAccountList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getRechargeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return postRechargeApply; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_fetch__ = __webpack_require__(509);


var qs = __webpack_require__(874);

var setContentType = function setContentType() {
  var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'application/x-www-form-urlencoded; charset=UTF-8';

  __WEBPACK_IMPORTED_MODULE_1_utils_fetch__["a" /* default */].defaults.headers.post['Content-Type'] = txt;
};

var sendRequire = function sendRequire(obj, txt) {
  setContentType(txt);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_fetch__["a" /* default */])(obj);
};

//账号相关
var chooseAccount = function chooseAccount(id) {
  return sendRequire({
    url: '/choose',
    method: 'get',
    params: { id: id }
  });
};
var login = function login() {
  return sendRequire({
    url: '/login'
  });
};
var logout = function logout() {
  return sendRequire({
    url: '/logout'
  });
};
var getInfo = function getInfo() {
  return sendRequire({
    url: '/user_info'
  });
};

//Promotor_manage_service
var promotorCreate = function promotorCreate(data) {
  return sendRequire({
    url: '/promotor/create',
    method: 'post',
    data: qs.stringify(data)
  });
};

var promotorUpdate = function promotorUpdate(data) {
  return sendRequire({
    url: '/promotor/update',
    method: 'post',
    data: qs.stringify(data)
  });
};

var promotorLeaveJob = function promotorLeaveJob(promotorId) {
  return sendRequire({
    url: '/promotor/leaveJob',
    method: 'post',
    data: qs.stringify({ promotorId: promotorId })
  });
};

var promotorSearch = function promotorSearch(data) {
  return sendRequire({
    url: '/promotor/search',
    method: 'get',
    params: data
  });
};

var promotorInfo = function promotorInfo(id) {
  return sendRequire({
    url: '/promotor/' + id,
    method: 'get'
  });
};

//订单管理
var orderMgmtOrder = function orderMgmtOrder(data) {
  return sendRequire({
    url: '/orderMgmt/order',
    method: 'get',
    params: data
  });
};

//订单管理
var orderMgmtLock = function orderMgmtLock(data) {
  return sendRequire({
    url: '/orderMgmt/lockOrderList',
    method: 'get',
    params: data
  });
};

var orderMgmtChannel = function orderMgmtChannel() {
  return sendRequire({
    url: '/orderMgmt/listOrderChannel',
    method: 'get'
  });
};

var orderMgmtSubsite = function orderMgmtSubsite() {
  return sendRequire({
    url: '/orderMgmt/listSubsite',
    method: 'get'
  });
};

var orderMgmtExport = function orderMgmtExport() {
  return sendRequire({
    url: '/orderMgmt/order/export',
    method: 'get'
  });
};

//各销售数据
var opertionSummary = function opertionSummary() {
  return sendRequire({
    url: '/kpi/opertion_summary',
    method: 'get'
  });
};

var subsiteSaleInfo = function subsiteSaleInfo(data) {
  return sendRequire({
    url: '/kpi/subsite_sale_info',
    method: 'get',
    params: data
  });
};

var distributorSaleInfo = function distributorSaleInfo(data) {
  return sendRequire({
    url: '/kpi/distributor_sale_info',
    method: 'get',
    params: data
  });
};

var realtimeInfo = function realtimeInfo() {
  return sendRequire({
    url: '/partner/realtime_info',
    method: 'get'
  });
};

//有关子站
var subsiteList = function subsiteList(data) {
  return sendRequire({
    url: '/partner/subsite_list',
    method: 'get',
    params: data
  });
};

var subsiteSelectList = function subsiteSelectList(data) {
  return sendRequire({
    url: '/partner/subsite_select_list',
    method: 'get'
  });
};

var subsiteConf = function subsiteConf(data) {
  return sendRequire({
    url: '/partner/subsite_conf',
    method: 'get',
    params: data
  });
};

var createUpdateSubsite = function createUpdateSubsite(data) {
  return sendRequire({
    url: '/partner/create_or_update_subsite',
    method: 'post',
    data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)
  }, 'application/json; charset=UTF-8');
};

var changeSubsiteName = function changeSubsiteName(data) {
  return sendRequire({
    url: '/partner/change_subsite_name',
    method: 'post',
    data: qs.stringify(data)
  });
};

var addContentSub = function addContentSub(data) {
  return sendRequire({
    url: '/partner/content_search',
    method: 'get',
    params: data
  });
};

//合伙人/分销商后台-子站管理-分类设置中的分类列表
var partnerCategoryList = function partnerCategoryList() {
  return sendRequire({
    url: '/partner/category_list',
    method: 'get'
  });
};

// 图片上传
var fileUpload = function fileUpload(url, data) {
  return sendRequire({
    url: url,
    method: 'post',
    data: data
  }, 'Multipart/form-data');
};

// 合伙人通知
var partnerNotice = function partnerNotice() {
  return sendRequire({
    url: '/announcement',
    method: 'get'
  });
};
var notifyAll = function notifyAll() {
  return sendRequire({
    url: '/notify/all',
    method: 'get'
  });
};
var notifyList = function notifyList(data) {
  return sendRequire({
    url: '/notify/list',
    method: 'get',
    params: data
  });
};
var notifyRead = function notifyRead(data) {
  return sendRequire({
    url: '/notify/read',
    method: 'get',
    params: data
  });
};
//活动通知
var ActnotifyList = function ActnotifyList(data) {
  return sendRequire({
    url: '/activity/notify/list',
    method: 'get',
    params: data
  });
};

//子站专辑
var subsiteAlbumList = function subsiteAlbumList(data) {
  return sendRequire({
    url: '/partner/subsite_album_list',
    method: 'get',
    params: data
  });
};

//子站声音
var subsiteTrackList = function subsiteTrackList(data) {
  return sendRequire({
    url: '/partner/subsite_track_list',
    method: 'get',
    params: data
  });
};

// 子站分类置顶专辑信息（user's）
var userAlbumStick = function userAlbumStick(params) {
  return sendRequire({
    url: '/partner/subsite_category_album_list',
    method: 'get',
    params: params
  });
};

// 子站分类置顶专辑信息（init）
var initAlbumList = function initAlbumList(params) {
  return sendRequire({
    url: '/partner/content_search_by_category',
    method: 'get',
    params: params
  });
};

// 子站分类置顶专辑信息（search）
var albumSearch = function albumSearch(params) {
  return sendRequire({
    url: '/partner/content_search',
    method: 'get',
    params: params
  });
};

// 数据中心-用户增长详情
var incrementData = function incrementData() {
  return sendRequire({
    url: '/report/active/index',
    method: 'get'
  });
};

// 数据中心-用户增长详情-折线图(日期跨度)数据速查
var chartRegionData = function chartRegionData(params) {
  return sendRequire({
    url: '/report/active/choose',
    method: 'get',
    params: params
  });
};

// 数据中心-用户增长详情-表格(日期跨度)数据速查
var tableRegionData = function tableRegionData(params) {
  return sendRequire({
    url: '/report/active/search',
    method: 'get',
    params: params
  });
};

// 数据中心-用户增长详情-表格导出excel
var exportTable = function exportTable(params) {
  return sendRequire({
    url: '/report/active/export',
    method: 'get',
    params: params
  });
};

// 数据中心-专辑排行-获取城市列表
var getRankCity = function getRankCity() {
  return sendRequire({
    url: '/report/my/city',
    method: 'get'
  });
};

// 数据中心-专辑排行-获取分类
var getRankClassify = function getRankClassify() {
  return sendRequire({
    url: '/report/all/category',
    method: 'get'
  });
};

// 数据中心-专辑排行-获取排行列表
var getRanking = function getRanking(data) {
  return sendRequire({
    url: '/report/album/ranking',
    method: 'post',
    data: qs.stringify(data)
  });
};

// 数据中心-专辑排行-获取排行列表
var searchRanking = function searchRanking(data) {
  return sendRequire({
    url: '/report/album/search',
    method: 'post',
    data: qs.stringify(data)
  });
};

// 数据中心-锁定用户详情
var lockDetail = function lockDetail(params) {
  return sendRequire({
    url: '/lock/detail/list',
    method: 'get',
    params: params
  });
};

// 数据中心-分销商锁定用户详情
var lockPromotorDetail = function lockPromotorDetail(params) {
  return sendRequire({
    url: '/lock/detail/promotor/list',
    method: 'get',
    params: params
  });
};

// 数据中心-授权手机号用户
var authMobile = function authMobile(params) {
  return sendRequire({
    url: '/kpi/partner_listen_book_list',
    method: 'get',
    params: params
  });
};

// 极光账号信息
var auroraAccounts = function auroraAccounts(params) {
  return sendRequire({
    url: '/aurora/accounts',
    method: 'get',
    params: params
  });
};

var recent = function recent() {
  return sendRequire({
    url: '/notify/recent',
    method: 'get'
  });
};

// 获取预付款相关信息
var getAccountInfo = function getAccountInfo() {
  return sendRequire({
    url: '/imprest/balance',
    method: 'get'
  });
};
var getAccountList = function getAccountList(params) {
  return sendRequire({
    url: '/imprest/flowList',
    method: 'get',
    params: params
  });
};
var getRechargeList = function getRechargeList(params) {
  return sendRequire({
    url: '/imprest/rechargeList',
    method: 'get',
    params: params
  });
};
var postRechargeApply = function postRechargeApply(params) {
  return sendRequire({
    url: '/imprest/recharge',
    method: 'post',
    params: params
  });
};


/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(854)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(937),
  /* scopeId */
  "data-v-3d8ef2c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(856)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(939),
  /* scopeId */
  "data-v-44f17478",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(838)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(921),
  /* scopeId */
  "data-v-0a7a1587",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(840)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(923),
  /* scopeId */
  "data-v-0fa10904",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(839)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(922),
  /* scopeId */
  "data-v-0f4c7bfe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(834)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(918),
  /* scopeId */
  "data-v-033f1955",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(853)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(936),
  /* scopeId */
  "data-v-3c45bc1f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(845)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(927),
  /* scopeId */
  "data-v-1b46fa05",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(866)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(949),
  /* scopeId */
  "data-v-829f2f92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(848)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(931),
  /* scopeId */
  "data-v-296e0c21",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(852)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(935),
  /* scopeId */
  "data-v-392f84a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(868)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  "data-v-e42d3dea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(865)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(948),
  /* scopeId */
  "data-v-7b8fd613",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(849)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(932),
  /* scopeId */
  "data-v-31e4b570",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(851)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(934),
  /* scopeId */
  "data-v-382f57ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(837)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(920),
  /* scopeId */
  "data-v-08ceb4af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(858)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(941),
  /* scopeId */
  "data-v-5b035938",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(842)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(925),
  /* scopeId */
  "data-v-0fff54ed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 918:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [(_vm.children && _vm.children.length > 0) ? _c('el-tabs', {
    staticStyle: {
      "width": "1105px"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_vm._l((_vm.children), function(item) {
    return (!item.hidden && !(item.path == 'lock' && !_vm.isPromotorDisplay)) ? _c('el-tab-pane', {
      key: item.path,
      attrs: {
        "label": item.text,
        "name": item.path
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "bread-crumb"
  }, [_c('span', [_vm._v("进货款管理")]), _c('span', {
    staticClass: "fr",
    staticStyle: {
      "font-size": "14px",
      "color": "#4990E2",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.showTips
    }
  }, [_vm._v("进货款充值使用方法")])]), _vm._v(" "), _c('el-row', {
    staticClass: "data-card",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', [_vm._v("进货款余额")]), _vm._v(" "), _c('div', {
    staticClass: "card-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.accountInfo.inventoryAmount))]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.toRechargeList
    }
  }, [_vm._v("查看充值申请")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doRecharge
    }
  }, [_vm._v("充值")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("返还金额")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.goDefine
    }
  }, [_vm._v("查看定义")]), _vm._v(" "), _c('div', {
    staticClass: "card-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.accountInfo.returnAmount))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doWithdrawals
    }
  }, [_vm._v("提现")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', [_vm._v("适用本规则的商品")]), _vm._v(" "), _c('div', {
    staticClass: "card-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.accountInfo.supportImprestAlbumCount))]), _vm._v(" "), _c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "right",
      "width": "200",
      "trigger": "hover",
      "content": "部分商品因进货款余额不足，不能适用高分成比例"
    }
  }, [_c('a', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("仅部分商品适用")])])], 1), _vm._v(" "), _c('a', {
    staticClass: "el-button el-button--primary",
    attrs: {
      "target": "_blank",
      "href": "/imprest/export"
    }
  }, [_c('span', {
    staticClass: "exportText",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("导出商品列表")])])])])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "search-form white-box",
    attrs: {
      "model": _vm.form,
      "inline": true,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "交易编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入编号"
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", $$v)
      },
      expression: "form.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.form.productName),
      callback: function($$v) {
        _vm.$set(_vm.form, "productName", $$v)
      },
      expression: "form.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "交易时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": "请选择时间"
    },
    model: {
      value: (_vm.form.time),
      callback: function($$v) {
        _vm.$set(_vm.form, "time", $$v)
      },
      expression: "form.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "交易类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.form.flowType),
      callback: function($$v) {
        _vm.$set(_vm.form, "flowType", $$v)
      },
      expression: "form.flowType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "充值",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户购买",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户退款",
      "value": "5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资金流向"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择资金流向"
    },
    model: {
      value: (_vm.form.inOrOut),
      callback: function($$v) {
        _vm.$set(_vm.form, "inOrOut", $$v)
      },
      expression: "form.inOrOut"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "流入",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "流出",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "余额变动类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择金额变动类型"
    },
    model: {
      value: (_vm.form.moneyFlowType),
      callback: function($$v) {
        _vm.$set(_vm.form, "moneyFlowType", $$v)
      },
      expression: "form.moneyFlowType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "进货款余额",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "返还金额",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getAccountList()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "table-name white-box"
  }, [_vm._v("进货款交易明细")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "search-table",
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "编号",
      "show-overflow-tooltip": "",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "日期",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.moment(scope.row.date).format('YYYY-MM-DD HH:mm:ss')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inventoryAmount",
      "label": "进货款余额变动",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "afterInventoryAmount",
      "label": "变动后金额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "returnAmount",
      "label": "返还金额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "afterReturnAmount",
      "label": "返还金额余额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.toDetail(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageInfo.curPage,
      "page-size": _vm.pageInfo.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.pageInfo.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "my-dialog",
    attrs: {
      "show-close": false,
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "dialog-title",
    on: {
      "click": _vm.closeCarousel
    }
  }, [_vm._v("跳过")]), _vm._v(" "), _c('my-carousel', {
    staticStyle: {
      "width": "680px"
    },
    attrs: {
      "trigger": "click",
      "height": "500px",
      "loop": false,
      "arrow": "always",
      "autoplay": false,
      "indicator-position": "outside"
    }
  }, [_c('el-carousel-item', [_c('div', {
    staticClass: "carousel list-1"
  })]), _vm._v(" "), _c('el-carousel-item', [_c('div', {
    staticClass: "carousel list-2"
  })]), _vm._v(" "), _c('el-carousel-item', [_c('div', {
    staticClass: "carousel list-3"
  })]), _vm._v(" "), _c('el-carousel-item', [_c('div', {
    staticClass: "carousel list-4"
  })]), _vm._v(" "), _c('el-carousel-item', [_c('div', {
    staticClass: "carousel list-5"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.closeCarousel
    }
  })])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('card', {
    attrs: {
      "cardData": {
        title: '各子站销售情况',
        type: 'table',
        data: _vm.subsiteData,
        key: _vm.subsiteKey
      }
    },
    on: {
      "pagSearch": _vm.subsiteSearch
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "distributor-manager"
  }, [_c('div', {
    staticClass: "dis-manager-search white-box"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.filterTerm.name),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "name", $$v)
      },
      expression: "filterTerm.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": _vm.bl
    },
    model: {
      value: (_vm.filterTerm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "mobile", $$v)
      },
      expression: "filterTerm.mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择起始日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtStart),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtStart", $$v)
      },
      expression: "filterTerm.createdAtStart"
    }
  }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择终止日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtEnd),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtEnd", $$v)
      },
      expression: "filterTerm.createdAtEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("状态")]), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.filterTerm.accountState),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "accountState", $$v)
      },
      expression: "filterTerm.accountState"
    }
  }, _vm._l((_vm.distributorStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("身份证")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.filterTerm.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "idCardNo", $$v)
      },
      expression: "filterTerm.idCardNo"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.filter(0)
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.accountState === 1 && _vm.promotorType === 1) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.toInfo(0, 0)
      }
    }
  }, [_vm._v("添加分销商")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dis-manager-table white-box"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-class-name": "dis-manager-table-tr",
      "data": _vm.queryData.promotors
    }
  }, [_vm._l((_vm.distriTableColumn), function(item) {
    return _c('el-table-column', {
      key: item.prop,
      attrs: {
        "prop": item.prop,
        "label": item.label,
        "width": item.width
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.toInfo(scope.row.id, 1)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), (scope.row.accountState == '在职' && _vm.accountState === 1 && _vm.promotorType === 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.toInfo(scope.row.id, 0)
            }
          }
        }, [_vm._v("编辑\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.accountState == '在职' && _vm.accountState === 1 && _vm.promotorType === 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.dimission(scope.row.id)
            }
          }
        }, [_vm._v("离职\n          ")]) : _vm._e()]
      }
    }])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dis-manager-pag column-content"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.queryData.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.queryData.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.queryData, "curPage", $event)
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#f0f2f5",
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "wscn-http404"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bullshit"
  }, [_c('div', {
    staticClass: "bullshit__oops"
  }, [_vm._v("OOPS!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bullshit__headline"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "bullshit__info"
  }, [_vm._v("请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告")]), _vm._v(" "), _c('a', {
    staticClass: "bullshit__return-home",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("返回首页")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic-404"
  }, [_c('img', {
    staticClass: "pic-404__parent",
    attrs: {
      "src": __webpack_require__(883),
      "alt": "404"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-404__child left",
    attrs: {
      "src": __webpack_require__(190),
      "alt": "404"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-404__child mid",
    attrs: {
      "src": __webpack_require__(190),
      "alt": "404"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-404__child right",
    attrs: {
      "src": __webpack_require__(190),
      "alt": "404"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bullshit__info"
  }, [_vm._v("版权所有"), _c('a', {
    staticClass: "link-type",
    attrs: {
      "href": "http://www.ximalaya.com/",
      "target": "_blank"
    }
  }, [_vm._v("喜马拉雅")])])
}]}

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errPage-container"
  }, [_c('el-button', {
    staticClass: "pan-back-btn",
    attrs: {
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h1', {
    staticClass: "text-jumbo text-ginormous"
  }, [_vm._v("Oops!")]), _vm._v("\n       gif来源"), _c('a', {
    attrs: {
      "href": "https://zh.airbnb.com/",
      "target": "_blank"
    }
  }, [_vm._v("airbnb")]), _vm._v(" 页面\n      "), _c('h2', [_vm._v("你没有权限去该页面")]), _vm._v(" "), _c('h6', [_vm._v("如有不满请联系你领导")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("或者你可以去:")]), _vm._v(" "), _c('li', {
    staticClass: "link-type"
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("回首页")])], 1), _vm._v(" "), _c('li', {
    staticClass: "link-type"
  }, [_c('a', {
    attrs: {
      "href": "https://www.taobao.com/"
    }
  }, [_vm._v("随便看看")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("点我看图")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.errGif,
      "width": "313",
      "height": "428",
      "alt": "Girl has dropped her ice cream."
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "随便看",
      "visible": _vm.dialogVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticClass: "pan-img",
    attrs: {
      "src": _vm.ewizardClap
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-number"
  }, [_c('ul', {
    staticClass: "xmly-table-part"
  }, _vm._l((_vm.txtArray), function(item) {
    return (!!(_vm.numberData.data && _vm.numberData.data[item.key] != undefined) && item.role.indexOf(_vm.promotorType) !== -1) ? _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('router-link', {
      attrs: {
        "to": item.key == 'inServiceDistributerCount' ? {
          name: 'distributorManager'
        } : item.key == 'subSiteCount' ? {
          name: 'SubManager'
        } : ''
      }
    }, [_c('p', {
      staticClass: "count"
    }, [_vm._v(_vm._s(_vm.numberData.data[item.key]))]), _vm._v(" "), _c('p', {
      staticClass: "tit"
    }, [_vm._v(" " + _vm._s(item.txt) + " ")]), _vm._v(" "), (!_vm.numberData.model && item.key == 'lockUserCount') ? _c('p', {
      staticClass: "toDataCenter",
      on: {
        "click": _vm.toLockDetail
      }
    }, [_vm._v("查看详情")]) : _vm._e()])], 1) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-set"
  }, [_c('div', {
    staticClass: "sub"
  }, [_c('el-select', {
    staticClass: "sub-select",
    attrs: {
      "disabled": _vm.step > 1,
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.subSiteChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.subSiteId,
      attrs: {
        "label": item.subSiteName,
        "value": item.subSiteId
      }
    })
  })), _vm._v(" "), (!_vm.value) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'substationSet',
        query: {
          sid: -1
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.step > 1
    }
  }, [_vm._v("添加新子站")])], 1) : _vm._e(), _vm._v(" "), (!_vm.value) ? _c('div', {
    staticClass: "mind"
  }, [_vm._v("请选择子站或添加新子站！")]) : _c('div', [_c('div', {
    staticClass: "set-step white-box"
  }, [_c('ul', {
    staticClass: "xmly-step"
  }, [_c('li', {
    class: ("item step1 " + (_vm.step>=1 && 'on'))
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v("设置显示模块")]), _vm._v(" "), _c('li', {
    class: ("item step2 " + (_vm.step>=2 && 'on'))
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v("配置模块展示内容")]), _vm._v(" "), _c('li', {
    class: ("item step3 " + (_vm.step==3 && 'on'))
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v("预览和发布")])])]), _vm._v(" "), (_vm.step === 1) ? _c('div', {
    staticClass: "set-main"
  }, [_c('div', {
    staticClass: "home-page-pre"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("首页预览")]), _vm._v(" "), _c('iframe', {
    staticClass: "homePreview",
    attrs: {
      "name": "homePreview",
      "src": ("" + _vm.PROTOCOL + _vm.SUB_SITE_HOST + "/index/" + (_vm.value>0 ? _vm.value:_vm.SUB_PREVIEW_ID) + "?preview=1")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "show-component"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("展示组件")]), _vm._v(" "), _c('div', {
    staticClass: "components-choose"
  }, [_c('p', [_vm._v("手机端只展示开启状态的组件")]), _vm._v(" "), _vm._l((_vm.componentsChoose), function(item, index) {
    return _c('div', {
      staticClass: "components-radios"
    }, [_c('span', [_vm._v(_vm._s(item.txt))]), _vm._v(" "), _c('el-radio-group', {
      on: {
        "change": function($event) {
          _vm.homeSendMessage(item.key, _vm.componentsChoose[index].value)
        }
      },
      model: {
        value: (_vm.componentsChoose[index].value),
        callback: function($$v) {
          _vm.$set(_vm.componentsChoose[index], "value", $$v)
        },
        expression: "componentsChoose[index].value"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 0
      }
    }, [_vm._v("关闭")])], 1)], 1)
  })], 2)])]) : (_vm.step === 2) ? _c('div', {
    staticClass: "set-main"
  }, [(_vm.componentsChoose[0].value) ? _c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("轮播图片")]), _vm._v(" "), _c('div', {
    staticClass: "add column-content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addPicLoading
    },
    on: {
      "click": _vm.chooseFile
    }
  }, [_vm._v("添加图片")]), _vm._v(" "), _c('input', {
    staticClass: "file-upload",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.submitFile
    }
  }), _vm._v(" "), _c('span', [_vm._v("最多添加5张广告图片（图片尺寸：750x330）")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.carousels,
      "row-class-name": "carousel-table-tr"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "82"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "picture",
      "label": "图片",
      "width": "188"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "column-content carousel-img"
        }, [_c('img', {
          staticClass: "img",
          attrs: {
            "src": scope.row.imgUrl
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "链接地址",
      "width": "276"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-select', {
          staticClass: "carousel-select-address",
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.changeContentType
          },
          model: {
            value: (scope.row.contentType),
            callback: function($$v) {
              _vm.$set(scope.row, "contentType", $$v)
            },
            expression: "scope.row.contentType"
          }
        }, _vm._l((_vm.urlAddress), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }))], 1), _vm._v(" "), _c('div', {
          staticClass: "add-address"
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!(scope.row.contentType == 3 ? scope.row.contentUrl : (scope.row.contentType == 2 ? scope.row.contentColumnName : scope.row.contentVoiceName))),
            expression: "!!(scope.row.contentType==3 ? scope.row.contentUrl : (scope.row.contentType==2 ? scope.row.contentColumnName : scope.row.contentVoiceName))"
          }],
          staticClass: "address-input"
        }, [_vm._v(_vm._s(scope.row.contentType == 3 ? scope.row.contentUrl : (scope.row.contentType == 2 ? scope.row.contentColumnName : scope.row.contentVoiceName)))]), _vm._v(" "), (scope.row.contentType == 2) ? _c('el-button', {
          staticClass: "carousel-select-column",
          on: {
            "click": function($event) {
              _vm.addContentVisible = true;
              _vm.carouselContentIndex = scope.$index;
              _vm.changeContentType(2);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.contentColumnName ? '更改' : '选择专辑') + "\n                  ")]) : _vm._e(), _vm._v(" "), (scope.row.contentType == 1) ? _c('el-button', {
          staticClass: "carousel-select-voice",
          on: {
            "click": function($event) {
              _vm.addContentVisible = true;
              _vm.carouselContentIndex = scope.$index;
              _vm.changeContentType(1);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.contentVoiceName ? '更改' : '选择声音') + "\n                  ")]) : _vm._e(), _vm._v(" "), (scope.row.contentType == 3) ? _c('el-button', {
          staticClass: "carousel-select-address",
          on: {
            "click": function($event) {
              _vm.inputAddress(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(scope.row.contentUrl ? '更改' : '输入地址') + "\n                  ")]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "198"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "move-operate"
        }, [(scope.$index > 0) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.carousels, scope.$index, -1)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (scope.$index < _vm.carousels.length - 1) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.carousels, scope.$index, 1)
            }
          }
        }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.carousels, scope.$index, 0)
            }
          }
        }, [_vm._v("删除")])])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.componentsChoose[2].value) ? _c('div', {
    staticClass: "classify-set"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("专栏橱窗设置")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "add column-content"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addClassifyData
    }
  }, [_vm._v("添加专栏")]), _vm._v(" "), _c('span', [_vm._v("最多添加10个专栏")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.categorys,
      "row-class-name": "classify-table-tr"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "97"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "classify",
      "label": "专栏",
      "width": "214"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticClass: "classify-select",
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              _vm.switchCategory(scope.row.categoryId, scope.row.subSiteDisplayName)
            }
          },
          model: {
            value: (scope.row.categoryId),
            callback: function($$v) {
              _vm.$set(scope.row, "categoryId", $$v)
            },
            expression: "scope.row.categoryId"
          }
        }, _vm._l((_vm.classifySelect), function(item) {
          return _c('el-option', {
            key: item.categoryId,
            attrs: {
              "label": item.category,
              "value": item.categoryId
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "专栏显示名称（最多四个字）",
      "width": "194"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "sub-show-name",
          attrs: {
            "maxlength": 4
          },
          model: {
            value: (scope.row.subSiteDisplayName),
            callback: function($$v) {
              _vm.$set(scope.row, "subSiteDisplayName", $$v)
            },
            expression: "scope.row.subSiteDisplayName"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "239"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "move-operate"
        }, [(scope.$index > 0) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.categorys, scope.$index, -1)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (scope.$index < _vm.categorys.length - 1) ? _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.categorys, scope.$index, 1)
            }
          }
        }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "orange",
          on: {
            "click": function($event) {
              _vm.carChangePos(_vm.categorys, scope.$index, 0)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('span', {
          staticClass: "orange cateManage",
          attrs: {
            "data-id": scope.row.id,
            "data-cateId": scope.row.categoryId,
            "data-name": scope.row.subSiteDisplayName,
            "data-order": scope.row.serialNumber
          },
          on: {
            "click": _vm.specialManage
          }
        }, [_vm._v("专栏管理")])])]
      }
    }])
  })], 1)], 1)]) : _vm._e()]) : _c('div', {
    class: 'set-main' + ' ' + (_vm.value <= 0 ? 'NoneOnline' : '')
  }, [(_vm.value > 0) ? _c('div', {
    staticClass: "online-page-pre"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("线上")]), _vm._v(" "), _c('iframe', {
    staticClass: "onlinePreview",
    attrs: {
      "name": "onlinePreview",
      "src": ("" + _vm.PROTOCOL + _vm.SUB_SITE_HOST + "/index/" + (_vm.value>0 ? _vm.value:_vm.SUB_PREVIEW_ID) + "?preview=1")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "current-page-pre"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("当前")]), _vm._v(" "), _c('iframe', {
    staticClass: "currPreview",
    attrs: {
      "name": "currPreview",
      "src": ("" + _vm.PROTOCOL + _vm.SUB_SITE_HOST + "/index/" + (_vm.value>0 ? _vm.value:_vm.SUB_PREVIEW_ID) + "?preview=1")
    }
  })])]), _vm._v(" "), (_vm.step == 3) ? _c('div', {
    staticClass: "set-main column-content add-sub-name white-box"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("子站名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "subStation-name",
    model: {
      value: (_vm.subSiteName),
      callback: function($$v) {
        _vm.subSiteName = $$v
      },
      expression: "subSiteName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "set-main bottom-operate column-content"
  }, [_c('el-button', {
    staticClass: "quit-set",
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("退出设置")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step >= 2),
      expression: "step>=2"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeStep(-1)
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step < 3),
      expression: "step<3"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeStep(1)
      }
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step==3"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("发布")])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "el-dialog-album-stick",
      "visible": _vm.categoryAlbumVisible,
      "top": "5%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.categoryAlbumVisible = $event
      },
      "close": _vm.albumStickReset
    }
  }, [_c('el-transfer', {
    directives: [{
      name: "loading",
      rawName: "v-loading.lock",
      value: (_vm.searching),
      expression: "searching",
      modifiers: {
        "lock": true
      }
    }],
    attrs: {
      "titles": ['专辑库', '首页专栏显示专辑'],
      "data": _vm.searchAlbumList,
      "props": {
        key: 'contentId',
        label: 'contentName'
      },
      "button-texts": ['删除', '添加'],
      "filterable": "",
      "footer-format": {
        noChecked: '${total} / 6',
        hasChecked: '已选 ${checked} 项'
      },
      "render-content": _vm.transferRender
    },
    on: {
      "change": _vm.upUserAlbumList
    },
    model: {
      value: (_vm.userAlbumIdList),
      callback: function($$v) {
        _vm.userAlbumIdList = $$v
      },
      expression: "userAlbumIdList"
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCategory
    }
  }, [_vm._v("保存设置")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加内容",
      "visible": _vm.addContentVisible,
      "size": "add-content"
    },
    on: {
      "update:visible": function($event) {
        _vm.addContentVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-content-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("关键字")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.addContentForm,
      "onsubmit": "return false;"
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入关键字"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addContent($event)
      }
    },
    model: {
      value: (_vm.addContentForm.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.addContentForm, "searchKeyword", $$v)
      },
      expression: "addContentForm.searchKeyword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addContentSearchLoading
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "show_result"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.radioValue),
      callback: function($$v) {
        _vm.radioValue = $$v
      },
      expression: "radioValue"
    }
  }, _vm._l((_vm.contentResult.list), function(radio) {
    return _c('el-radio', {
      key: radio.contentId,
      staticClass: "classify-radio column-content",
      attrs: {
        "label": radio.contentId
      }
    }, [_c('span', {
      staticClass: "column-content"
    }, [_c('img', {
      staticClass: "column-img",
      attrs: {
        "src": radio.contentCover
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "column-name",
      attrs: {
        "title": radio.contentName
      }
    }, [_vm._v(_vm._s(radio.contentName))])])])
  })), _vm._v(" "), (_vm.contentResult.list && _vm.contentResult.list.length === 0) ? _c('div', [_vm._v("暂无搜索到匹配内容")]) : _vm._e()], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.addContentForm.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.addContentForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.contentResult.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.addContentForm, "curPage", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.chooseContent
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addContentVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread-crumb",
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/advancepayment/manager'
      }
    }
  }, [_vm._v("进货款管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("充值")])], 1), _vm._v(" "), (!_vm.succ) ? _c('div', {
    staticClass: "white-box content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("请将进货款转账至")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("填写转账信息")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "form",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.formRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "amount",
      "label": "转账金额"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请填写整数或小数"
    },
    model: {
      value: (_vm.ruleForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "amount", _vm._n($$v))
      },
      expression: "ruleForm.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "prop": "bankAccountNumber",
      "label": "转出账号"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请填写账号"
    },
    model: {
      value: (_vm.ruleForm.bankAccountNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "bankAccountNumber", $$v)
      },
      expression: "ruleForm.bankAccountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "bankAccountName",
      "label": "转出账号名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "如上海证大喜马拉雅网络科技有限公司"
    },
    model: {
      value: (_vm.ruleForm.bankAccountName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "bankAccountName", $$v)
      },
      expression: "ruleForm.bankAccountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "上传凭证"
    }
  }, [_c('el-upload', {
    staticClass: "form-upload",
    attrs: {
      "accept": "image/png,image/jpg,image/jpeg",
      "action": ("http://" + _vm.uploadUrl + "/dtres/picture/upload?" + _vm.uploadParam),
      "data": _vm.uploadParams,
      "list-type": "picture-card",
      "on-success": _vm.handlePictureChange,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("上传您的银行或支付宝等渠道的转账回单")])], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-submit"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交申请")])], 1)], 1)], 1) : (_vm.succ) ? _c('recharge-success') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-info"
  }, [_c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v("银行账号")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("97160154740012579")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v("账号名称")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("上海证大喜马拉雅网络科技有限公司")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v("开户行名称")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("上海浦东发展银行张江科技支行")])])])
}]}

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xmly-nav-right navbar"
  }, [_c('ul', {
    staticClass: "nav-right"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ("" + _vm.PROTOCOL + _vm.AVATAR_LINK + _vm.uid + "/")
    }
  }, [_c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tit elli"
  }, [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ("" + _vm.PROTOCOL + _vm.HOST + "/doc/help/download"),
      "target": "_blank",
      "download": "城市合伙人系统使用手册.pdf"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACPElEQVRYR8WX7VEVQRBF741AjUCJAIlAjUCJQI1AMxAywAjECMQI1AiECMQIlAjaOtQMtT5mp2e2iqKr3g/evu050337A+uezfd8vjYDRMSJpJflAqe2j7dcZhNAOfzdzoHHto9mIbYC/JX0QNJBOfCnpEvbe3cOEBEPJf1ZOeiF7e8zENMRiIjnkr51DgHg0DZRSm0aAI8FgpBflr+fSHolCQ2QmnNJRCOFGAKICBzv2z7sXamkhwjsS/po+30WghQgIrjdLxzZnvq9pL0apTWQEYfUOyX32fab7EYlJaeSXo9EYQSAkD4rwjobBEAPXyT9sI1oV20EIMrbj0ZEVSJwU6pZ2oYBMke7V4yIa/DsvS7Asulkju4KoDadNJcNgKqdbnfMIoDqP0n6ahthDVtEIFim5VvbVEXTMoAhJy3PETEEvwqwbECShiugwoy+3wOg/X6YaUANHdQIru4KTYCiftov9Tw9YhdRqCJmKNGWbw2nNYDaSqfV36mG5nC6BbAz79NhkpXFjhYObDOqb6wFwA8Yp2fZ+M0OX6Si9oRz23WNu37cA+A5OSMdTML/yLPDI+JpmYiUI1rCLmzz/XoEeFJqmGWCSFRj++EmgPC5qlAlzI8l4ZwP4mOPqHYh6aTVkLJGhDNuQBfkgBn7TRqJYC966TRc5BEYQOgNPeMfFPQzlLJhgJagWFLK9ywfAE6X7RYAcsvt2H6XdkXeR5eW+uI0QBEpELTqOiHJ9VG2gLbytglgRonZb/8BTHX7IaSG5rQAAAAASUVORK5CYII="
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit elli"
  }, [_vm._v("帮助")])])]), _vm._v(" "), _c('li', {
    staticClass: "item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABQklEQVRYR+WX/VECMRDF36tAqESpAOjEDrQDsQPtwE6ECsBOoILnPCbOHNxX7pLMoe5fmblL9pe3m82GmNg4sX/cHoCkGYAXAI8APE61I4APAK8kPb6wmgKS3gA8pXptmP9O8jkGwJR3ABYkD6kgkh4A7AEcSc5jAOSfSGbLD0mtazaF4E8CnENJ0uHoTcLsCnTlUbEQSNqGZF43Hb8fqNIASwCWvxWiJICLmFW474IoBmCJQ1XthCgKEAORBCDJ8bXEQ2xLcp0lCUcC7EiusgDEbDvkwScAF6EvAKvqsUwKQR9An/NzdbxepOvi6HNY/R7jvDSAj58LUU32KmhJBQzgYnQR8/9zGV3lg+uFSC4mUeDXdUSlmtITyVqbf5NtuSk34WHi9jzVTuFhsol6mKR6Gzo/W+8/1HHrbTh2obHzvgGJ3dkh/zGD/AAAAABJRU5ErkJggg=="
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit elli"
  }, [_vm._v("退出")])])
}]}

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partner-notice"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.collapseChange
    }
  }, [_vm._l((_vm.notifyAllData), function(item) {
    return _c('el-collapse-item', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "item-date"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })], 2)
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-carousel",
    class: {
      'el-carousel--card': _vm.type === 'card'
    },
    on: {
      "mouseenter": function($event) {
        $event.stopPropagation();
        _vm.handleMouseEnter($event)
      },
      "mouseleave": function($event) {
        $event.stopPropagation();
        _vm.handleMouseLeave($event)
      }
    }
  }, [_c('div', {
    staticClass: "el-carousel__container",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "carousel-arrow-left"
    }
  }, [(_vm.arrow !== 'never') ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.arrow === 'always' || _vm.hover) && _vm.left),
      expression: "(arrow === 'always' || hover) && left"
    }],
    staticClass: "el-carousel__arrow el-carousel__arrow--left",
    on: {
      "mouseenter": function($event) {
        _vm.handleButtonEnter('left')
      },
      "mouseleave": _vm.handleButtonLeave,
      "click": function($event) {
        $event.stopPropagation();
        _vm.throttledArrowClick(_vm.activeIndex - 1)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "carousel-arrow-right"
    }
  }, [(_vm.arrow !== 'never') ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.arrow === 'always' || _vm.hover) && _vm.right),
      expression: "(arrow === 'always' || hover) && right"
    }],
    staticClass: "el-carousel__arrow el-carousel__arrow--right",
    on: {
      "mouseenter": function($event) {
        _vm.handleButtonEnter('right')
      },
      "mouseleave": _vm.handleButtonLeave,
      "click": function($event) {
        $event.stopPropagation();
        _vm.throttledArrowClick(_vm.activeIndex + 1)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.indicatorPosition !== 'none') ? _c('ul', {
    staticClass: "el-carousel__indicators",
    class: {
      'el-carousel__indicators--labels': _vm.hasLabel, 'el-carousel__indicators--outside': _vm.indicatorPosition === 'outside' || _vm.type === 'card'
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "el-carousel__indicator",
      class: {
        'is-active': index === _vm.activeIndex
      },
      on: {
        "mouseenter": function($event) {
          _vm.throttledIndicatorHover(index)
        },
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleIndicatorClick(index)
        }
      }
    }, [_c('button', {
      staticClass: "el-carousel__button"
    }, [(_vm.hasLabel) ? _c('span', [_vm._v(_vm._s(item.label))]) : _vm._e()])])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card white-box"
  }, [(_vm.cardData.model !== 'lockDetail') ? _c('div', {
    staticClass: "title-con"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cardData.title))]), _vm._v(" "), (_vm.cardData.model !== 'real_time') ? _c('p', {
    staticClass: "sign"
  }, [_vm._v("以下统计数据截止到昨天\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cardData.model && _vm.cardData.model == 'real_time') ? _c('card-number', {
    attrs: {
      "numberData": {
        model: _vm.cardData.model,
        data: _vm.cardData.data
      },
      "promotorType": _vm.promotorType
    }
  }) : _c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(tab, index) {
    return _c('el-tab-pane', {
      key: tab.key,
      attrs: {
        "label": tab.txt,
        "name": index.toString()
      }
    }, [(_vm.cardData.type === 'number') ? _c('card-number', {
      attrs: {
        "numberData": {
          data: _vm.cardData.data[tab.key]
        }
      }
    }) : _c('card-table', {
      attrs: {
        "tableData": _vm.propstable[tab.key] || {}
      }
    })], 1)
  })), _vm._v(" "), (_vm.cardData.type == 'table') ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.cardData.data.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.cardData.data.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.cardData.data, "curPage", $event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 931:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "operate-data"
  }, [_c('card', {
    attrs: {
      "cardData": {
        title: '概况',
        type: 'number',
        data: _vm.summaryData
      }
    }
  }), _vm._v(" "), (_vm.promotorType == 1) ? _c('div', {
    staticClass: "convenience white-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "xmly-table-part",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "item list1",
    on: {
      "click": function($event) {
        _vm.goOut('https://shimo.im/sheet/RUJcVXsVISA5BL6z?r=G7E5EE/%E3%80%8C%E7%AB%99%E5%86%85%E7%A7%81%E4%BF%A1%E3%80%8D')
      }
    }
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("申请主站流量")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "item list2",
    on: {
      "click": _vm.auroraIndexUrl
    }
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("发布活动")]), _vm._v(" "), _c('p', {
    staticClass: "subtit"
  }, [_vm._v("喜马城市服务商账号要绑定极光账号才能锁定用户")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "item list3",
    on: {
      "click": _vm.openModal
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("绑定极光账号")])])], 1)])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('card', {
    attrs: {
      "cardData": {
        title: '实时数据',
        type: 'number',
        model: 'real_time',
        data: _vm.realTimeData
      }
    }
  }), _vm._v(" "), _c('card', {
    attrs: {
      "cardData": {
        title: '我的销售情况',
        type: 'table',
        data: _vm.subsiteData,
        key: _vm.subsiteKey
      }
    },
    on: {
      "pagSearch": _vm.subsiteSearch
    }
  }), _vm._v(" "), (_vm.promotorType == 1) ? _c('card', {
    attrs: {
      "cardData": {
        title: '各分销商销售情况',
        type: 'table',
        data: _vm.distributorData,
        key: _vm.distributorKey
      }
    },
    on: {
      "pagSearch": _vm.distributorSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "极光账号",
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("您的城市服务商喜马账号当前绑定的极光账号（微信）为：")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.auroraDatas.length == 0) ? _c('li', {
    staticStyle: {
      "display": "block",
      "padding": "20px 10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#d82b04",
      "font-size": "13px",
      "padding-left": "10px"
    }
  }, [_vm._v("未绑定账号")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.auroraDatas), function(auroraData) {
    return _c('li', {
      staticStyle: {
        "display": "inline-block",
        "padding": "10px 10px",
        "width": "210px"
      }
    }, [_c('span', {
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "overflow": "hidden",
        "border-radius": "16px",
        "display": "inline-block",
        "vertical-align": "middle"
      }
    }, [_c('img', {
      attrs: {
        "src": auroraData.headImageUrl,
        "width": "32"
      }
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#d88c04",
        "font-size": "13px",
        "padding-left": "10px"
      }
    }, [_vm._v(_vm._s(("" + (auroraData.nickName))))])])
  })], 2), _vm._v(" "), _c('p', [_vm._v("如账号有误，请"), _c('a', {
    attrs: {
      "href": _vm.addUrl,
      "target": "_blank"
    }
  }, [_vm._v("点击添加")]), _vm._v("，绑定新的极光账号。如需让员工或分销商使用，请在极光中为分销商创建子账号。")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "notice-center"
  }, [_c('div', {
    staticClass: "notice-header"
  }, [_c('h2', [_vm._v("最新通知")]), _vm._v(" "), _c('router-link', {
    staticClass: "more-notice",
    attrs: {
      "to": "/partnernotice/index"
    }
  }, [_vm._v("查看更多")])], 1), _vm._v(" "), _c('div', {
    staticClass: "notice-body"
  }, _vm._l((_vm.recentList), function(item) {
    return _c('router-link', {
      key: item.id,
      class: {
        read: !item.read
      },
      attrs: {
        "tag": "li",
        "to": "/partnernotice/index"
      }
    }, [_vm._v(_vm._s(item.title))])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-con"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("快捷操作")])])
}]}

/***/ }),

/***/ 932:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pend-check"
  }, [_c('div', {
    staticClass: "pend-check-search white-box column-content"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-14"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-14"
  }, [_vm._v("身份证")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.idNumber),
      callback: function($$v) {
        _vm.idNumber = $$v
      },
      expression: "idNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-14"
  }, [_vm._v("申请日期")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.applyDate),
      callback: function($$v) {
        _vm.applyDate = $$v
      },
      expression: "applyDate"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "search"
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pend-check-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "row-class-name": "pend-table-tr"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mark",
      "label": "备注",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "日期",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handle",
      "label": "操作",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("不通过")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "penk-check-pag column-content white-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currPage,
      "page-sizes": [100, 200, 300, 400],
      "page-size": 100,
      "layout": "total, sizes, prev, pager, next",
      "total": 1000
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currPage = $event
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  })
},staticRenderFns: []}

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-album"
  }, [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "227",
      "height": "227"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "425",
      "height": "425"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "850",
      "height": "850"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "white-box sub-album-search column-content"
  }, [_c('span', {
    staticClass: "sub-id-txt span-14"
  }, [_vm._v("在")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.subSiteId),
      callback: function($$v) {
        _vm.subSiteId = $$v
      },
      expression: "subSiteId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "sub-name-txt span-14"
  }, [_vm._v("子站中销售")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    staticStyle: {
      "width": "54%"
    },
    attrs: {
      "placeholder": "请输入你想分销的专辑/声音名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.subsiteAlbumSearch()
      }
    },
    model: {
      value: (_vm.keyWord),
      callback: function($$v) {
        _vm.keyWord = $$v
      },
      expression: "keyWord"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        _vm.subsiteAlbumSearch()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    staticClass: "white-box sub-list"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(tab, index) {
    return _c('el-tab-pane', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      key: tab.key,
      attrs: {
        "label": tab.txt,
        "name": index.toString()
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.listData.list
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "contentId",
        "label": _vm.activeName == '1' ? '声音编号' : '专辑编号',
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "contentName",
        "label": _vm.activeName == '1' ? '声音名称' : '专辑名称',
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": _vm.activeName == '1' ? '声音封面' : '专辑封面',
        "width": "220"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('img', {
            staticClass: "cover",
            attrs: {
              "src": scope.row.contentCover,
              "width": "86"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": _vm.activeName == '1' ? '子站声音二维码' : '子站专辑二维码',
        "width": "144"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(_vm.hasQRcode(scope.row)) ? _c('el-popover', {
            attrs: {
              "trigger": "hover",
              "placement": "left"
            }
          }, [_c('div', {
            staticClass: "preQr"
          }, [_c('p', [_vm._v(_vm._s(("" + (scope.row.contentName))))]), _vm._v(" "), _c('img', {
            attrs: {
              "src": scope.row.qrCodeUrl
            }
          }), _vm._v(" "), _c('p', [_vm._v("可使用手机扫码，查看子站在手机上的展示效果")])]), _vm._v(" "), _c('div', {
            staticClass: "name-wrapper column-content qr-wrapper",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          }, [_c('img', {
            staticClass: "qrImg",
            attrs: {
              "src": scope.row.qrCodeUrl
            }
          })])]) : _vm._e()]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "分销人",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            style: ({
              color: _vm.hasQRcode(scope.row) ? '' : '#f66549'
            })
          }, [_vm._v(_vm._s(scope.row.ownerDesc))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "handle",
        "label": "操作",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(_vm.hasQRcode(scope.row)) ? _c('div', {
            staticClass: "operate-button"
          }, [_c('el-button', {
            directives: [{
              name: "clipboard",
              rawName: "v-clipboard:copy",
              value: (("" + (_vm.activeName=='1'?scope.row.trackUrl:scope.row.albumUrl))),
              expression: "`${activeName=='1'?scope.row.trackUrl:scope.row.albumUrl}`",
              arg: "copy"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:success",
              value: (_vm.onCopy),
              expression: "onCopy",
              arg: "success"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:error",
              value: (_vm.onError),
              expression: "onError",
              arg: "error"
            }],
            staticClass: "copy-url",
            attrs: {
              "type": "text",
              "size": "small"
            }
          }, [_vm._v("复制链接")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.downloadQr(scope.row.qrCodeUrl, scope.row.contentName)
              }
            }
          }, [_vm._v("保存二维码")])], 1) : _vm._e()]
        }
      }])
    })], 1)], 1)
  })), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.listData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.listData.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.listData, "curPage", $event)
      }
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-manager"
  }, [_c('div', {
    staticClass: "order-manager-search white-box"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入订单编号"
    },
    model: {
      value: (_vm.filterTerm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "orderNo", $$v)
      },
      expression: "filterTerm.orderNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.filterTerm.commodityName),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "commodityName", $$v)
      },
      expression: "filterTerm.commodityName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "commodityType", $$v)
      },
      expression: "filterTerm.commodityType"
    }
  }, _vm._l((_vm.goodsTypeOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("订单渠道")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.promotorId),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "promotorId", $$v)
      },
      expression: "filterTerm.promotorId"
    }
  }, _vm._l((_vm.orderChannelOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.orderStatus),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "orderStatus", $$v)
      },
      expression: "filterTerm.orderStatus"
    }
  }, _vm._l((_vm.orderStatusOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("来源子站")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.sourceSubsiteId),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "sourceSubsiteId", $$v)
      },
      expression: "filterTerm.sourceSubsiteId"
    }
  }, _vm._l((_vm.sourceStationOptions), function(item) {
    return _c('el-option', {
      key: item.subSiteId,
      attrs: {
        "label": item.subSiteName,
        "value": item.subSiteId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("用户昵称")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入用户昵称"
    },
    model: {
      value: (_vm.filterTerm.buyerNickName),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "buyerNickName", $$v)
      },
      expression: "filterTerm.buyerNickName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("用户手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入用户手机号"
    },
    model: {
      value: (_vm.filterTerm.buyerMobile),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "buyerMobile", $$v)
      },
      expression: "filterTerm.buyerMobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part choose-time"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择起始日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtFrom),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtFrom", $$v)
      },
      expression: "filterTerm.createdAtFrom"
    }
  }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择终止日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtTo),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtTo", $$v)
      },
      expression: "filterTerm.createdAtTo"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('a', {
    staticClass: "order-export",
    attrs: {
      "href": ("" + _vm.PROTOCOL + _vm.HOST + "/orderMgmt/order/export?" + _vm.requireData),
      "target": "_blank",
      "download": "订单.xlsx"
    }
  }, [_c('el-button', [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box order-manager-table"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v("订单列表")]), _vm._v(" "), _c('span', {
    staticClass: "order-tips",
    on: {
      "click": _vm.toOrderTips
    }
  }, [_vm._v("佣金和分成比例不吻合？")])]), _vm._v(" "), _c('table', {
    staticClass: "xmly-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderTableData), function(order) {
    return _c('tbody', {
      key: order.orderNo
    }, [_c('tr', {
      staticClass: "order"
    }, [_c('td', [_vm._v(_vm._s(("订单编号：" + (order.orderNo))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "column-content"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": order.coverUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h2', {
      staticClass: "tit elli"
    }, [_vm._v(_vm._s(order.commodityName))]), _vm._v(" "), _c('p', {
      staticClass: "price elli"
    }, [_vm._v(_vm._s(("售价：￥" + (order.commodityPrice))))]), _vm._v(" "), _c('p', {
      staticClass: "count elli"
    }, [_vm._v(_vm._s(("数量：" + (order.commodityAmount))))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.commodityType))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "name elli"
    }, [_vm._v(_vm._s(order.buyerNickName))]), _vm._v(" "), _c('p', {
      staticClass: "tel elli"
    }, [_vm._v(_vm._s(order.buyerMobile))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.orderAmount))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.orderStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.brokerageRatios))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.brokerageAmount))))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "elli"
    }, [_vm._v(_vm._s(order.promotorType))]), _vm._v(" "), _c('p', {
      staticClass: "elli"
    }, [_vm._v(_vm._s(order.promotorName))])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "elli"
    }, [_vm._v(_vm._s(order.sourceSubsiteName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.createdAt))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "order-manager-pag column-content white-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.filterTerm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.curPage = $event
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('th', [_vm._v("用户")]), _vm._v(" "), _c('th', [_vm._v("订单金额（元）")]), _vm._v(" "), _c('th', [_vm._v("订单状态")]), _vm._v(" "), _c('th', [_vm._v("分成比例")]), _vm._v(" "), _c('th', [_vm._v("佣金（元）")]), _vm._v(" "), _c('th', [_vm._v("订单渠道")]), _vm._v(" "), _c('th', [_vm._v("来源")]), _vm._v(" "), _c('th', [_vm._v("创建时间")])])])
}]}

/***/ }),

/***/ 936:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper"
  }, [_c('Sidebar'), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('Navbar'), _vm._v(" "), _c('App-main')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('card', {
    attrs: {
      "cardData": {
        title: '各分销商销售情况',
        type: 'table',
        data: _vm.distributorData,
        key: _vm.distributorKey
      }
    },
    on: {
      "pagSearch": _vm.distributorSearch
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xmly-masker"
  }, [_c('div', {
    staticClass: "xmly-pop"
  }, [_c('div', {
    staticClass: "title-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "name elli"
  }, [_vm._v(_vm._s(_vm.nickName))]), _vm._v(" 您好！")])]), _vm._v(" "), _c('h2', {
    staticClass: "choose-tit"
  }, [_vm._v(_vm._s(_vm.role ? '请选择您需要的账号角色' : '您的账号没有角色'))]), _vm._v(" "), _c('ul', {
    staticClass: "xmly-account-list"
  }, _vm._l((_vm.accounts), function(account) {
    return _c('li', {
      key: account.id,
      staticClass: "xmly-account-item",
      on: {
        "click": function($event) {
          _vm.chooseRole(account.id)
        }
      }
    }, [_c('a', [_c('div', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "xmly-account-info elli"
    }, [_c('label', [_vm._v("区域：")]), _vm._v(_vm._s(account.provinceName + account.cityName + account.areaNames))]), _vm._v(" "), _c('div', {
      staticClass: "xmly-account-info elli"
    }, [_c('label', [_vm._v("身份：")]), _vm._v(_vm._s(account.promotorType == 1 ? '城市合伙人' : '分销商'))]), _vm._v(" "), _c('div', {
      staticClass: "xmly-account-info elli"
    }, [_c('label', [_vm._v("登录时间：")]), _vm._v(_vm._s(_vm.format(account.lastLoginAt) + ' 登录过'))])])])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "xmly-account-logout",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("切换账号")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": "http://fdfs.xmcdn.com/group31/M03/1E/C4/wKgJSVmBaJ-CjgQUAAOU3Y8Z6M8121_mobile_medium.jpg",
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "distributor-info"
  }, [_c('router-link', {
    staticClass: "back-to-list",
    attrs: {
      "to": {
        name: 'distributorManager'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "arrow-left"
    }
  }, [_vm._v("返回分销商列表")])], 1), _vm._v(" "), _c('div', {
    staticClass: "edit-info"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s((_vm.check ? '分销商信息' : (!_vm.infoId ? '添加' : '编辑') + '分销商')))]), _vm._v(" "), _c('el-form', {
    ref: "infoForm",
    staticClass: "items",
    attrs: {
      "model": _vm.infoForm,
      "rules": _vm.infoRules,
      "label-width": "93px",
      "label-position": "right"
    }
  }, [_vm._l((_vm.keyTxt), function(item, key) {
    return _c('el-form-item', {
      key: key,
      staticClass: "item",
      attrs: {
        "prop": key,
        "label": item.txt
      }
    }, [(key === 'brokerageRatio') ? _c('el-select', {
      attrs: {
        "name": key,
        "placeholder": item.placeholder,
        "disabled": !!_vm.check
      },
      model: {
        value: (_vm.infoForm[key]),
        callback: function($$v) {
          _vm.$set(_vm.infoForm, key, $$v)
        },
        expression: "infoForm[key]"
      }
    }, _vm._l((_vm.percentData), function(percent) {
      return _c('el-option', {
        key: percent,
        attrs: {
          "label": percent,
          "value": percent
        }
      })
    })) : _vm._e(), _vm._v(" "), (key === 'appRatio') ? _c('el-select', {
      attrs: {
        "name": key,
        "placeholder": item.placeholder,
        "disabled": !!_vm.check
      },
      on: {
        "change": _vm.turnSwitch
      },
      model: {
        value: (_vm.infoForm[key]),
        callback: function($$v) {
          _vm.$set(_vm.infoForm, key, $$v)
        },
        expression: "infoForm[key]"
      }
    }, _vm._l((_vm.percentData2), function(percent) {
      return _c('el-option', {
        key: percent,
        attrs: {
          "label": percent,
          "value": percent
        }
      })
    })) : _vm._e(), _vm._v(" "), (key != 'appRatio' && key != 'brokerageRatio') ? _c('el-input', {
      attrs: {
        "placeholder": item.placeholder,
        "name": key,
        "size": "small",
        "disabled": !!_vm.check || !!_vm.infoId && (key === 'idCardNo' || key === 'mobile')
      },
      model: {
        value: (_vm.infoForm[key]),
        callback: function($$v) {
          _vm.$set(_vm.infoForm, key, $$v)
        },
        expression: "infoForm[key]"
      }
    }) : _vm._e(), _vm._v(" "), (key === 'idCardNo' && !_vm.check) ? _c('p', {
      staticClass: "idNumber-sign"
    }, [_vm._v("*仅添加是可以编辑，后续只读，不可修改")]) : _vm._e(), _vm._v(" "), (key === 'brokerageRatio' && !_vm.check) ? _c('p', {
      staticClass: "percent-sign"
    }, [_vm._v("\n          指该分销商带来的的销售额中，需要按照该设置项来结算给该分销商的金额。该比例不能超过您与喜马拉雅的分成比例。")]) : _vm._e(), _vm._v(" "), (key === 'appRatio' && !_vm.check) ? _c('p', {
      staticClass: "percent-sign"
    }, [_vm._v("\n          分成比例设置为0时，分销商不会看到绑定用户和APP内订单信息；分成比例不为0，分销商将直接获得收益并看到其带来的绑定用户和APP内订单信息。")]) : _vm._e()], 1)
  }), _vm._v(" "), (!_vm.check) ? _c('div', {
    staticClass: "handle-footer"
  }, [_c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.infoId) ? _c('div', {
    staticClass: "amendment-record"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("分成比例修改记录")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "modifiedAt",
      "label": "修改时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newBrokerageRatio",
      "label": "分成比例",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modifierName",
      "label": "修改人"
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 940:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.list || []
    }
  }, _vm._l((_vm.tableData.keyList), function(key) {
    return _c('el-table-column', {
      key: key,
      attrs: {
        "label": _vm.keyTxt[key] && _vm.keyTxt[key].txt,
        "prop": key,
        "width": _vm.keyTxt[key] && _vm.keyTxt[key].width
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-manager"
  }, [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "227",
      "height": "227"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "425",
      "height": "425"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "850",
      "height": "850"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "white-box sub-manager-search column-content"
  }, [_c('span', {
    staticClass: "sub-id-txt span-14"
  }, [_vm._v("子站编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入子站编号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.subsiteListSearch()
      }
    },
    model: {
      value: (_vm.subSiteId),
      callback: function($$v) {
        _vm.subSiteId = $$v
      },
      expression: "subSiteId"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-name-txt span-14"
  }, [_vm._v("子站名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入子站名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.subsiteListSearch()
      }
    },
    model: {
      value: (_vm.subSiteName),
      callback: function($$v) {
        _vm.subSiteName = $$v
      },
      expression: "subSiteName"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        _vm.subsiteListSearch()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box sub-list"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("子站列表")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listData.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "subSiteId",
      "label": "子站编号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subSiteName",
      "label": "子站名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "链接",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "sub-url",
          attrs: {
            "href": scope.row.subsiteRealUrl
          }
        }, [_vm._v("此链接为" + _vm._s(scope.row.promotor.name) + "的销售链接")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "子站二维码",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "left"
          }
        }, [_c('div', {
          staticClass: "preQr"
        }, [_c('p', [_vm._v(_vm._s(((scope.row.subSiteName) + "（子站二维码）")))]), _vm._v(" "), _c('img', {
          attrs: {
            "src": scope.row.subsiteRealQrcode
          }
        }), _vm._v(" "), _c('p', [_vm._v("可使用手机扫码，查看子站在手机上的展示效果")])]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper column-content qr-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('img', {
          staticClass: "qrImg",
          attrs: {
            "src": scope.row.subsiteRealQrcode
          }
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "注册二维码",
      "width": "120",
      "label-class-name": "codeTip"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "left"
          }
        }, [_c('div', {
          staticClass: "preQr"
        }, [_c('p', [_vm._v(_vm._s(((scope.row.subSiteName) + "（注册二维码）")))]), _vm._v(" "), _c('img', {
          attrs: {
            "src": scope.row.subsiteSigninQrCode
          }
        }), _vm._v(" "), _c('p', [_vm._v("可使用手机扫码，查看子站在手机上的展示效果")])]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper column-content qr-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('img', {
          staticClass: "qrImg",
          attrs: {
            "src": scope.row.subsiteSigninQrCode
          }
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "width": "169"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.getFormatTime(scope.row.createAt)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handle",
      "label": "操作",
      "width": "185"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operate-button"
        }, [(_vm.promotorType === 1 && _vm.accountState === 1) ? _c('p', {
          staticClass: "modifySub"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'substationSet',
              query: {
                sid: scope.row.subSiteId
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("修改设置")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.changeName(scope.row.subSiteId, scope.$index)
            }
          }
        }, [_vm._v("修改名称")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('el-button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: (("" + (scope.row.subsiteRealUrl))),
            expression: "`${scope.row.subsiteRealUrl}`",
            arg: "copy"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:success",
            value: (_vm.onCopy),
            expression: "onCopy",
            arg: "success"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:error",
            value: (_vm.onError),
            expression: "onError",
            arg: "error"
          }],
          staticClass: "copy-url",
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("复制链接")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.downloadQr(scope.row.subsiteRealQrcode, scope.row.subSiteName)
            }
          }
        }, [_vm._v("保存子站二维码")])], 1), _vm._v(" "), _c('p', [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.downloadQr(scope.row.subsiteSigninQrCode, scope.row.subSiteName + '(注册)')
            }
          }
        }, [_vm._v("保存注册二维码")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.listData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.listData.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.listData, "curPage", $event)
      }
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "oTip"
  }, [_vm._v("用户扫描本二维码后，会直接进入登录页面。用户通过本链接成为新注册用户，该用户将会被您锁定。")])])
},staticRenderFns: []}

/***/ }),

/***/ 942:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread-crumb",
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/advancepayment/manager'
      }
    }
  }, [_vm._v("进货款管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("充值记录")])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "search-form white-box",
    attrs: {
      "model": _vm.form,
      "inline": true,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入编号"
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", $$v)
      },
      expression: "form.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "现金充值",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "提现",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择申请状态"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待审核",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已通过",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未通过",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": "请选择时间"
    },
    model: {
      value: (_vm.form.time),
      callback: function($$v) {
        _vm.$set(_vm.form, "time", $$v)
      },
      expression: "form.time"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getRechargeList()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "search-table",
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "申请编号",
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "申请时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "充值金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "voucher",
      "label": "凭证"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "image",
          attrs: {
            "src": scope.row.voucher.split(',')[0]
          },
          on: {
            "click": function($event) {
              _vm.doCarousel(scope.row.voucher.split(','))
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "申请状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "未通过原因"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "200",
            "trigger": "hover",
            "content": scope.row.reason
          }
        }, [(scope.row.reason) ? _c('el-button', {
          attrs: {
            "slot": "reference",
            "size": "small"
          },
          slot: "reference"
        }, [_vm._v("详情原因")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageInfo.curPage,
      "page-size": _vm.pageInfo.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.pageInfo.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 943:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankData"
  }, [_c('div', {
    staticClass: "title-con"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("喜马拉雅用户数据：")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.initLoading),
      expression: "initLoading"
    }],
    attrs: {
      "placeholder": "请选择城市"
    },
    on: {
      "change": _vm.initFetch
    },
    model: {
      value: (_vm.curCityId),
      callback: function($$v) {
        _vm.curCityId = $$v
      },
      expression: "curCityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.cityId,
      attrs: {
        "label": item.cityName,
        "value": item.cityId
      }
    })
  }))], 1), _vm._v(" "), (_vm.cityList.length) ? _c('div', {
    staticClass: "rank-board"
  }, [_c('el-row', {
    staticClass: "row-bg board-head",
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "fill": "#f86442"
    },
    on: {
      "change": _vm.switchType
    },
    model: {
      value: (_vm.rankType),
      callback: function($$v) {
        _vm.rankType = $$v
      },
      expression: "rankType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "album"
    }
  }, [_vm._v("整张专辑销售排行榜")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "track"
    }
  }, [_vm._v("单条声音销售排行榜")])], 1), _vm._v(" "), _c('div', {
    staticClass: "goSearch"
  }, [_c('div', {
    staticClass: "searchInput"
  }, [_c('el-input', {
    attrs: {
      "placeholder": ("请输入" + (_vm.rankType === 'album' ? '专辑' : '声音') + "名称")
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchKey.length),
      expression: "searchKey.length"
    }],
    staticClass: "el-input__icon el-icon-close",
    on: {
      "click": _vm.initFetch
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getRankList
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.initLoading),
      expression: "initLoading"
    }],
    attrs: {
      "value": _vm.curClassName
    },
    on: {
      "tab-click": function($event) {
        _vm.switchTab(_vm.curClassIdx)
      }
    },
    model: {
      value: (_vm.curClassIdx),
      callback: function($$v) {
        _vm.curClassIdx = $$v
      },
      expression: "curClassIdx"
    }
  }, _vm._l((_vm.classify), function(item) {
    return _c('el-tab-pane', {
      key: item,
      attrs: {
        "label": item
      }
    })
  })), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg classify-board",
    attrs: {
      "type": "flex",
      "justify": "end",
      "align": "middle"
    }
  }, [_c('div', {
    staticClass: "sortBy"
  }, [_c('span', [_vm._v("排序方式: ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getRankList
    },
    model: {
      value: (_vm.curSortType),
      callback: function($$v) {
        _vm.curSortType = $$v
      },
      expression: "curSortType"
    }
  }, _vm._l((_vm.sortTypes), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), (_vm.rankType == 'album') ? _c('el-radio-group', {
    attrs: {
      "size": "small",
      "fill": "#f86442"
    },
    on: {
      "change": _vm.getRankList
    },
    model: {
      value: (_vm.rankTime),
      callback: function($$v) {
        _vm.rankTime = $$v
      },
      expression: "rankTime"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("最近一周")])], 1) : _c('el-button', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("昨日")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.rankLoading),
      expression: "rankLoading"
    }],
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "empty-text": _vm.ret === 0 ? '该分类下暂无排行数据' : _vm.dataMsg
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "albumId",
      "label": "专辑id",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专辑封面",
      "width": "168"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "img-placeholder"
        }, [_c('div', {
          staticClass: "img-box"
        }, [_c('img', {
          staticClass: "albumCover",
          attrs: {
            "src": scope.row.coverPath
          }
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "albumName",
      "label": "专辑名称",
      "width": "216"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分类",
      "width": "168"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.categoryName))]), _vm._v(" "), (_vm.onSearching) ? _c('p', {
          staticClass: "cateName"
        }, [_vm._v("【子站分类: " + _vm._s(scope.row.subsiteCategoryName) + "】")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ranking",
      "label": "排行",
      "width": "168"
    }
  })], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lockUserDetail"
  }, [_c('div', {
    staticClass: "title-con"
  }, [_c('div', {
    staticClass: "left-con"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("用户列表")]), _vm._v(" "), (_vm.promotorType == '1') ? _c('a', {
    staticClass: "lockUserHelp",
    attrs: {
      "href": "https://shimo.im/doc/jzvfab0MuZ01GTLV?r=MKZ48/",
      "target": "_blank"
    }
  }, [_vm._v("查看用户锁定操作方法")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dateFilter"
  }, [_c('span', [_vm._v("时间筛选：")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "size": "small",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.dateFilter
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('a', {
    staticClass: "el-button el-button--primary el-button--small",
    attrs: {
      "href": ("/lock/detail/export?from=" + (_vm.exportParams().from) + "&to=" + (_vm.exportParams().to)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _c('span', {
    staticClass: "exportText",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("导出表格")])])], 1)]), _vm._v(" "), (_vm.lockData) ? _c('p', {
    staticClass: "tableTips"
  }, [_vm._v("销售额和佣金不是实时数据，上一次更新时间为" + _vm._s(_vm.lockData.operateDate) + "，锁定时间和信息为实时数据")]) : _vm._e(), _vm._v(" "), (_vm.lockData) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lockData.list,
      "stripe": ""
    }
  }, _vm._l((_vm.lockDetailKey), function(iKey) {
    return ((iKey.key != 'mobile' && iKey.key != 'promotorName') || _vm.promotorType == '1') ? _c('el-table-column', {
      key: iKey.key,
      attrs: {
        "label": iKey.label,
        "label-class-name": iKey.key,
        "width": iKey.width,
        "show-overflow-tooltip": iKey.key != 'promotorName' ? true : false
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(iKey.key != 'promotorName') ? _c('span', [_vm._v(_vm._s(scope.row[iKey.key]))]) : _vm._e(), _vm._v(" "), (iKey.key == 'promotorName') ? _c('el-popover', {
            ref: scope.row.uid,
            refInFor: true,
            attrs: {
              "trigger": "hover",
              "placement": "right"
            }
          }, [_vm._l((scope.row[iKey.template].split('$#$')), function(item) {
            return _c('p', [_vm._v(_vm._s(item))])
          }), _vm._v(" "), (_vm.promotorType == 1) ? _c('span', {
            staticClass: "name-wrapper",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row[iKey.key].split('-')[0] == '合伙人' ? ("城市服务商-" + (scope.row[iKey.key].split('-')[1])) : scope.row[iKey.key]) + "\n\t\t\t\t\t\t"), _c('i', {
            staticClass: "el-icon-caret-right"
          })]) : _vm._e(), _vm._v(" "), (_vm.promotorType == 2) ? _c('span', {
            staticClass: "name-wrapper",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row[iKey.key].split('-')[1]) + "\n\t\t\t\t\t\t"), _c('i', {
            staticClass: "el-icon-caret-right"
          })]) : _vm._e()], 2) : _vm._e()]
        }
      }])
    }) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.lockData) ? _c('el-pagination', {
    attrs: {
      "currentPage": _vm.lockData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.lockData.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.lockData.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "oTip"
  }, [_vm._v("用户在您的子站或者您分销商的子站购买商品的销售额")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-box recharge-succ"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "succ-tips"
  }, [_vm._v("提交成功，等待财务审核")]), _vm._v(" "), _c('p', {
    staticClass: "succ-sub-tips"
  }, [_vm._v("审核完成后，会通过短信通知您，短信将发到您登陆本系统的手机号")]), _vm._v(" "), _c('p', {
    staticClass: "succ-sub-tips"
  }, [_vm._v("您还可以，点此"), _c('span', {
    on: {
      "click": function($event) {
        _vm.go('rechargelist')
      }
    }
  }, [_vm._v("查看充值申请")]), _vm._v(" 或 "), _c('span', {
    on: {
      "click": function($event) {
        _vm.go('recharge')
      }
    }
  }, [_vm._v("继续发起充值申请")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "succ-icon"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  })])
}]}

/***/ }),

/***/ 946:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "increment"
  }, [_c('div', {
    staticClass: "title-con"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("喜马拉雅用户数据：")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.initLoading),
      expression: "initLoading"
    }],
    attrs: {
      "placeholder": "请选择城市"
    },
    on: {
      "change": _vm.switchCity
    },
    model: {
      value: (_vm.curCityId),
      callback: function($$v) {
        _vm.curCityId = $$v
      },
      expression: "curCityId"
    }
  }, _vm._l((_vm.basicData), function(item) {
    return _c('el-option', {
      key: item.cityId,
      attrs: {
        "label": item.cityName,
        "value": item.cityId
      }
    })
  }))], 1), _vm._v(" "), (_vm.dataMsg) ? _c('p', {
    staticClass: "dataMsg"
  }, [_vm._v(_vm._s(_vm.dataMsg))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.basicData), function(itemCity) {
    return (itemCity.cityId === _vm.curCityId) ? _c('div', {
      staticClass: "dashboard"
    }, [_c('div', {
      staticClass: "nums-board"
    }, [_vm._m(0, true), _vm._v(" "), _c('ul', {
      staticClass: "board-content"
    }, _vm._l((_vm.numsKey), function(keyItem) {
      return _c('li', {
        staticClass: "board-content-item"
      }, [_c('div', {
        staticClass: "count-nums"
      }, [_c('span', [_vm._v(_vm._s(itemCity[((keyItem.key) + "Count")]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(keyItem.name))])]), _vm._v(" "), _c('ul', {
        staticClass: "percents"
      }, _vm._l((keyItem.dateType), function(typeItem) {
        return _c('li', {
          staticClass: "percent-item"
        }, [_c('span', {
          staticClass: "typeItem"
        }, [_vm._v(_vm._s(typeItem.name)), (typeItem.name == '周') ? _c('span', {
          staticClass: "oHelp forType"
        }, [_vm._v("?")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "dataBlock"
        }, [(itemCity[((keyItem.key) + "Compare" + (typeItem.key))].indexOf('-') === -1) ? _c('span', {
          staticClass: "up"
        }, [_vm._v("▲")]) : (itemCity[((keyItem.key) + "Compare" + (typeItem.key))] !== '0%') ? _c('span', {
          staticClass: "down"
        }, [_vm._v("▼")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(itemCity[((keyItem.key) + "Compare" + (typeItem.key))]))])])])
      }))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "charts-board"
    }, [_c('el-row', {
      staticClass: "row-bg",
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_c('el-radio-group', {
      attrs: {
        "fill": "#f86442"
      },
      on: {
        "change": _vm.switchChart
      },
      model: {
        value: (_vm.curChart),
        callback: function($$v) {
          _vm.curChart = $$v
        },
        expression: "curChart"
      }
    }, [_c('el-radio-button', {
      attrs: {
        "label": "active"
      }
    }, [_vm._v("活跃用户数")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": "newUser"
      }
    }, [_vm._v("新增用户数")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-radio-group', {
      on: {
        "change": _vm.switchChartRegion
      },
      model: {
        value: (_vm.curChartRegion),
        callback: function($$v) {
          _vm.curChartRegion = $$v
        },
        expression: "curChartRegion"
      }
    }, [_c('el-radio-button', {
      attrs: {
        "label": "7"
      }
    }, [_vm._v("7天")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": "15"
      }
    }, [_vm._v("15天")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": "30"
      }
    }, [_vm._v("30天")])], 1)], 1)], 1), _vm._v(" "), _c('echarts', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.chartLoading),
        expression: "chartLoading"
      }],
      attrs: {
        "options": _vm.lineChart
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "table-con"
  }, [(_vm.basicData) ? _c('el-row', {
    staticClass: "row-bg title",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "选择日期",
      "editable": false,
      "clearable": false
    },
    on: {
      "change": _vm.switchTableRegion
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    staticClass: "el-button el-button--primary",
    class: _vm.tableData.length && !_vm.tableLoading ? '' : 'is-disabled',
    attrs: {
      "href": ("/report/active/export?city=" + (_vm.exportParams().city) + "&start=" + (_vm.exportParams().startDate) + "&end=" + (_vm.exportParams().endDate)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _c('span', {
    staticClass: "exportText"
  }, [_vm._v("导出表格")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.tableData) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    }
  }, _vm._l((_vm.incrementKey), function(iKey) {
    return _c('el-table-column', {
      key: iKey.key,
      attrs: {
        "prop": iKey.key,
        "label": iKey.label,
        "label-class-name": iKey.key,
        "width": iKey.width,
        "sortable": "",
        "show-overflow-tooltip": ""
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "oTip forTitle"
  }, [_vm._v("部分数据因为用户未授权地理位置权限，无法获取地理位置，没有显示在本表中，请悉知。")]), _vm._v(" "), _c('p', {
    staticClass: "oTip forType"
  }, [_vm._v("昨日数据和上周日均数据的对比")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("昨日关键数据"), _c('span', {
    staticClass: "oHelp forTitle"
  }, [_vm._v("?")])])
}]}

/***/ }),

/***/ 947:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partner-notice"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.collapseChange
    }
  }, [_vm._l((_vm.notifyAllData), function(item) {
    return _c('el-collapse-item', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "item-title",
      class: {
        read: !item.read
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "item-date"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })], 2)
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "system-name"
  }, [_vm._v("喜马城市服务商智能管理系统")]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "unique-opened": true,
      "mode": "vertical",
      "default-active": _vm.$route.path
    }
  }, _vm._l((_vm.permission_routers), function(item) {
    return (!item.hidden && !(item.path == '/data/center' && !_vm.isPromotorDisplay)) ? _c('router-link', {
      key: item.text,
      attrs: {
        "to": item.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.text
      }
    }, [_c('div', {
      class: ("icon-img " + (item.icon))
    }), _vm._v(_vm._s(item.text))])], 1) : _vm._e()
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 950:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lockUserDetail"
  }, [_vm._m(0), _vm._v(" "), (_vm.lockData) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lockData.list,
      "stripe": ""
    }
  }, _vm._l((_vm.lockDetailKey), function(iKey) {
    return _c('el-table-column', {
      key: iKey.key,
      attrs: {
        "label": iKey.label,
        "label-class-name": iKey.key,
        "width": iKey.width,
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(iKey.key != 'partnerName') ? _c('span', [_vm._v(_vm._s(scope.row[iKey.key]))]) : _vm._e(), _vm._v(" "), (iKey.key == 'partnerName' && _vm.promotorType == 1) ? _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row[iKey.key].split('-')[0].trim() == '城市合伙人' ? ("城市服务商 - " + (scope.row[iKey.key].split('-')[1].trim())) : scope.row[iKey.key]) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (iKey.key == 'partnerName' && _vm.promotorType == 2) ? _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row[iKey.key.split('-')[1].trim()]) + "\n\t\t\t\t")]) : _vm._e()]
        }
      }])
    })
  })) : _vm._e(), _vm._v(" "), (_vm.lockData) ? _c('el-pagination', {
    attrs: {
      "currentPage": _vm.lockData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.lockData.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.lockData.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-con"
  }, [_c('div', {
    staticClass: "left-con"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("用户列表")])])])
}]}

/***/ }),

/***/ 951:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-manager"
  }, [_c('div', {
    staticClass: "white-box order-manager-table"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("订单列表")]), _vm._v(" "), _c('table', {
    staticClass: "xmly-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderTableData), function(order) {
    return _c('tbody', {
      key: order.orderNo
    }, [_c('tr', {
      staticClass: "order"
    }, [_c('td', [_vm._v(_vm._s(("订单编号：" + (order.orderNo))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "column-content"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": order.coverUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h2', {
      staticClass: "tit elli"
    }, [_vm._v(_vm._s(order.commodityName))]), _vm._v(" "), _c('p', {
      staticClass: "price elli"
    }, [_vm._v(_vm._s(("售价：￥" + (order.orderAmount))))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.commodityType))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "name elli"
    }, [_vm._v(_vm._s(order.buyerNickName))]), _vm._v(" "), _c('p', {
      staticClass: "tel elli"
    }, [_vm._v(_vm._s(order.buyerMobile))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.orderStatus == 2 ? '订单成功' : (order.orderStatus == 5 ? '已退款' : '')) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.orderAmount))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.brokerageAmount))))]), _vm._v(" "), (_vm.promotorType == 1) ? _c('td', [_vm._v(_vm._s(order.promotorName.split('-')[0] == '城市合伙人' ? ("城市服务商-" + (order.promotorName.split('-')[1])) : order.promotorName))]) : _vm._e(), _vm._v(" "), (_vm.promotorType == 2) ? _c('td', [_vm._v(_vm._s(order.promotorName.split('-')[1]))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.createdAt))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "order-manager-pag column-content white-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.curPage = $event
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('th', [_vm._v("用户")]), _vm._v(" "), _c('th', [_vm._v("订单状态")]), _vm._v(" "), _c('th', [_vm._v("订单金额（元）")]), _vm._v(" "), _c('th', [_vm._v("分成比例")]), _vm._v(" "), _c('th', [_vm._v("佣金（元）")]), _vm._v(" "), _c('th', [_vm._v("渠道")]), _vm._v(" "), _c('th', [_vm._v("创建时间")])])])
}]}

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(425);
module.exports = __webpack_require__(424);


/***/ })

},[990]);


// WEBPACK FOOTER //
// static/js/app.js